// import { errorMessages } from '../constants/messages';
import {
  map, size, forEach, filter, find, isEqual, get,
  mergeWith,
  isArray,
  isNumber,
} from 'lodash'; // , orderBy, keyBy, sortBy, get

import axios from 'axios';
import i18n from 'i18next';

import moment from 'moment';
import {
  Firebase,
  FirebaseRef,
  AdminLogsRef,
  RoomsRef,
  UserStatsRef,
  TournamentsRef,
  LeaderboardRef,
  StatusRef,
  FirebaseStorage,
} from '../lib/firebase';
import {
  isAndroid,
  isIOS,
  isIOS13,
  isTablet,
  isMobile,
  isDesktop,
  browserName,
  browserVersion,
  osName,
  osVersion,
  mobileModel
} from 'react-device-detect';
import { errorMessages } from '../constants/messages';
import * as statisticsConst from '../constants/statisticsTypes';
import * as constants from '../constants/constants';
import config from '../constants/config';
import { getDbRoomGameType } from '../utils/roomUtils';
import { padToTwoDigits, toUrlString } from '../utils/stringUtils';
import { user } from 'firebase-functions/lib/providers/auth';
import { epochToDateString } from '../utils/dateUtils';

let chatRef = null;

function dateFormat(formatData) {
  const formattedData = moment(formatData).format('DD-MM-YYYY HH:mm:ss');
  return formattedData;
}

function formatLogValue(value) {
  if (value === null || value === undefined) return '';
  if (isArray(value)) {
    return value.map(item => formatLogValue(item)).filter(item => item !== '').join(', ');
  }
  if (typeof value === 'object') {
    if (value.value !== undefined && value.value !== null) return `${value.value}`;
    if (value.label !== undefined && value.label !== null) return `${value.label}`;
    if (value.name !== undefined && value.name !== null) return `${value.name}`;
    return JSON.stringify(value);
  }
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  return `${value}`;
}

function isEmptyEquivalent(value) {
  return value === null || value === undefined || value === '';
}

function stripHtmlTags(html) {
  if (!html) return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
}

const getDevMode = () => {
  const hostname = get(window.location, 'hostname');
  let devMode = false;

  if (hostname === 'inbox.dev.spelezoli.lv' || hostname === 'dra.dev.spelezoli.lv' || hostname === 'dev.spelezoli.lv' || hostname === 'fb.dev.spelezoli.lv' || hostname === 'localhost') {
    devMode = true;
  }

  return devMode;
}

/*
function dateFormatMoment(formatData, dateType) {
  return moment(formatData).format(dateType);
} */

export function getmissedTurnsCount() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => AdminLogsRef().child('missedTurnsCount').once('value', (snapshot) => {
    const array = [];

    snapshot.forEach((childSnapshot) => {
      const val = childSnapshot.val();
      const { key } = childSnapshot;
      array.push({ key, ...val });
    });

    array.sort((a, b) => b.count - a.count);

    return resolve(dispatch({ type: 'MISSED_TURNS_COUNT', data: array }));
  })).catch((err) => { console.log(err.message); });
}

export function getProfanitiesList() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('profanitiesList').once('value', (snapshot) => {
    const profanitiesList = snapshot.val() || {};

    return resolve(dispatch({ type: 'PROFANITIES_LIST', data: profanitiesList }));
  })).catch((err) => { console.log(err.message); });
}

export function addProfanity(word, exact) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise(async (resolve) => {
    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'addProfanity',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      data: word,
      date: Firebase.database.ServerValue.TIMESTAMP,
    });

    return FirebaseRef.child(`profanitiesList/${word}`).set({ word, count: 0, exact: exact ? true : false }).then(() => resolve());
  });
}


export function deleteProfanity(word) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise(async (resolve) => {
    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'deleteProfanity',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      data: word,
      date: Firebase.database.ServerValue.TIMESTAMP,
    });

    FirebaseRef.child(`profanitiesList/${word}`).remove().then(() => resolve());
  });
}

export function getmissedTurnsData(userId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());


  return dispatch => new Promise(resolve => AdminLogsRef().child(`missedTurnsData/${userId}`).once('value', (snapshot) => {
    const missedTurnsData = snapshot.val() || {};

    return resolve(dispatch({ type: 'MISSED_TURNS_DATA', data: missedTurnsData }));
  })).catch((err) => { console.log(err.message); });
}

export function getUserCount() {
  if (Firebase === null) return () => new Promise(resolve => resolve());


  return dispatch => new Promise(resolve => FirebaseRef.child('statistics/userCount')
    .on('value', (snapshot) => {
      const userCount = snapshot.val() || {};

      return resolve(dispatch({ type: 'ADMIN_USER_COUNT', data: userCount }));
    })).catch((err) => { console.log(err.message); });
}

export function getUsersRange(start, end) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  console.log('users fetch getUsersRange', start, end);

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child('users').off();

    FirebaseRef.child('users')
      .orderByChild('userIndex')
      .startAt(start)
      .endAt(end)
      .on('child_changed', (snapshot) => {
        const user = snapshot.val() || {};
        const { key } = snapshot;

        console.log('getUsersRange change', key, user);

        dispatch({ type: 'ADMIN_USER_REPLACE', data: { user, key } });
      });

    FirebaseRef.child('users')
      .orderByChild('userIndex')
      .startAt(start)
      .endAt(end)
      .once('value', (snapshot) => {
        const users = snapshot.val() || {};

        return resolve(dispatch({ type: 'ADMIN_USERS_REPLACE', data: users }));
      });
  }).catch((err) => { console.log(err.message); });
}


// export function getFilteredUsers(filterValue, filterType) {
//   if (Firebase === null) return () => new Promise(resolve => resolve());

//   if (!filterType || !filterValue) return dispatch => new Promise(resolve => resolve(dispatch({ type: 'ADMIN_FILTERED_USERS', data: null })));
//   if (filterType === constants.USERNAME_LOWER_UPPER.lowerCaseName || filterType === constants.USERNAME_LOWER_UPPER.lowerCaseLastName) {
//     return dispatch => new Promise(resolve => FirebaseRef.child('users')
//       .orderByChild(filterType)
//       .startAt(filterValue.toLowerCase())
//       .endAt(`${filterValue.toLowerCase()}\uf8ff`)
//       .once('value', (snapshot) => {
//         const data = snapshot.val() || {};

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_USERS', data }));
//       })).catch((err) => { console.log(err.message); });
//   }


//   if (filterType === 'uid') {
//     return dispatch => new Promise(resolve => FirebaseRef.child('users')
//       .orderByKey()
//       .equalTo(filterValue.toString())
//       .limitToFirst(1)
//       .once('value', (snapshot) => {
//         const data = snapshot.val() || {};

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_USERS', data }));
//       })).catch((err) => { console.log(err.message); });
//   }

//   if (filterType === 'email') {
//     return dispatch => new Promise(resolve => FirebaseRef.child('users')
//       .orderByChild(filterType)
//       .startAt(filterValue)
//       .endAt(`${filterValue}\uf8ff`)
//       .once('value', (snapshot) => {
//         const data = snapshot.val() || {};

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_USERS', data }));
//       })).catch((err) => { console.log(err.message); });
//   }

//   return new Promise(resolve => resolve());
// }

export function getFilteredUsers(
  filterValue, filterType, filterRegMethod, filterPlatform, filterLanguage, filterDesign,
  filterTheme, filterBirthday, filterVIP, filterProfilePhoto, filterSound, filterAutoJoin,
  filterFont, filterGameSetting, filterVerified, filterRegEnabled, filterRegStartDate, filterRegEndDate,
  filterLastLoginEnabled, filterLastLoginStartDate, filterLastLoginEndDate, filterBalanceEnabled,
  filterBalanceFrom, filterBalanceTo, filterPointsEnabled, filterPointsFrom, filterPointsTo,
  filterPlayedGamesEnabled, filterPlayedGamesFrom, filterPlayedGamesTo, filterLevelEnabled,
  filterLevelFrom, filterLevelTo, filterPurchasesEnabled, filterPurchasesFrom, filterPurchasesTo,
  filterSpentEnabled, filterSpentFrom, filterSpentTo, filterAchievementsEnabled,
  filterAchievementsStartDate, filterAchievementsEndDate, filterRewardsEnabled,
  filterRewardsFrom, filterRewardsTo, filterTutorialBonus, filterRank, filterIOSAppBonus, filterAndroidAppBonus,
  filterOnlyBuyers, filterOnlyOnlinePlayers, filterPrecision,
) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  // if (!filterValue && !filterRegMethod && !filterPlatform && !filterSound && !filterLanguage
  //   && !filterDesign && !filterTheme && !filterBirthday && !filterVIP && !filterProfilePhoto && !filterFont
  //   && !filterAutoJoin && !filterSound && !filterGameSetting && !filterVerified && !filterRegEnabled
  //   && !filterLastLoginEnabled && !filterBalanceEnabled && !filterPointsEnabled && !filterPlayedGamesEnabled
  //   && !filterLevelEnabled && !filterPurchasesEnabled && !filterSpentEnabled && !filterAchievementsEnabled
  //   && !filterRewardsEnabled && !filterTutorialBonus && !filterRank && !filterAndroidAppBonus && !filterIOSAppBonus
  //   && !filterOnlyBuyers && !filterOnlyOnlinePlayers && !filterPrecision
  // ) {
  //   return dispatch => new Promise(resolve =>
  //     resolve(dispatch({ type: 'ADMIN_FILTERED_USERS', data: null }))
  //   );
  // }

  const applyFilters = async (data) => {
    if (/*filterPurchasesEnabled || */filterSpentEnabled || filterOnlyBuyers) {
      try {
        const productPrices = new Map(constants.SHOP_PRODUCT_TYPES.map(product => [product.id, product.realPrice]));

        const paymentsSnapshot = await FirebaseRef.child('completedPayments').once('value');
        const completedPayments = paymentsSnapshot.val() || {};
        const userStats = Object.values(completedPayments)
          .filter(payment => payment.status === "completed")
          .reduce((acc, payment) => {
            const uid = payment.userUid;
            if (!acc[uid]) acc[uid] = { count: 0, spent: 0 };
            acc[uid].count++;
            acc[uid].spent += productPrices.get(payment.productNr) || 0;
            return acc;
          }, {});

        data = Object.fromEntries(
          Object.entries(data).filter(([uid]) => {
            const stats = userStats[uid] || { count: 0, spent: 0 };

            if (filterOnlyBuyers && stats.count === 0) {
              return false;
            }

            if (filterPurchasesEnabled && (stats.count < filterPurchasesFrom || stats.count > filterPurchasesTo)) {
              return false;
            }

            if (filterSpentEnabled && (stats.spent < filterSpentFrom || stats.spent > filterSpentTo)) {
              return false;
            }

            return true;
          })
        );

      } catch (err) {
        console.log("err loading completed payments:", err);
      }
    }

    console.log('applyFilters', data);

    let onlinePlayers = {};
    if (filterOnlyOnlinePlayers) {
      try {
        const onlinePlayersSnapshot = await StatusRef.child('status').once('value');
        onlinePlayers = onlinePlayersSnapshot.val() || {};
      } catch (err) {
        console.log("err loading completed online players:", err);
      }
    }

    let filterPurchasesUsers = [];
    if (filterPurchasesEnabled) {
      const fromNum = Number.isFinite(Number(filterPurchasesFrom)) ? parseInt(filterPurchasesFrom, 10) : null;
      const toNum   = Number.isFinite(Number(filterPurchasesTo))   ? parseInt(filterPurchasesTo, 10)   : null;

      if (toNum !== null) {
        try {
          let purchasesQuery = FirebaseRef.child('userAchievements').orderByChild('storePurchase');

          if (fromNum === null || fromNum === 0) {
            purchasesQuery = purchasesQuery.endAt(toNum);
          } else {
            purchasesQuery = purchasesQuery.startAt(fromNum).endAt(toNum);
          }

          const snapshot = await purchasesQuery.once('value');
          const val = snapshot.val() || {};
          filterPurchasesUsers = Object.keys(val);

        } catch (err) {
          console.log("err loading storePurchase data", err);
        }
      } else {
        filterPurchasesUsers = [];
        console.log("invalid filterPurchasesTo:", filterPurchasesTo);
      }
    }

    const entries = await Promise.all(
      Object.entries(data).map(async ([uid, user]) => {
        let includeItem = true;

        if (filterOnlyOnlinePlayers && !onlinePlayers[user.uid]) includeItem = false;
        if (filterRegMethod && user.socProvider !== filterRegMethod) includeItem = false;

        if (filterPlatform && user.lastPlatform !== filterPlatform) {
          if (filterPlatform === "web") {
            if (user.lastPlatform && !["web", "draugiem", "inbox", "facebook"].includes(user.lastPlatform)) includeItem = false;
          } else {
            includeItem = false;
          }
        }

        if (filterLanguage && user.lastLanguage !== filterLanguage) {
          if (filterLanguage === "lv") {
            if (user.lastLanguage && user.lastLanguage !== "lv") includeItem = false;
          } else {
            includeItem = false;
          }
        }
        if (filterDesign === "new" && !user.newDesign || filterDesign === "old" && user.newDesign) includeItem = false;
        if (filterTheme && user.screenMode !== filterTheme) includeItem = false;
        if (filterBirthday === "yes" && !user.birthday || filterBirthday === "no" && user.birthday) includeItem = false;
        if (filterVIP === "yes" && (!user.vipUntil || Date.now() > user.vipUntil) || filterVIP === "no" && (user.vipUntil && Date.now() < user.vipUntil)) includeItem = false;
        if (filterProfilePhoto === "yes" && !user.photo || filterProfilePhoto === "no" && user.photo) includeItem = false;

        if (filterFont) {
          if (user.fontMode) {
            if (user.fontMode !== filterFont) includeItem = false;
          } else {
            if (filterFont !== "normal") includeItem = false;
          }
        }

        if (filterAutoJoin === "yes" && !user.autoMergeRooms || filterAutoJoin === "no" && user.autoMergeRooms) includeItem = false;

        if (filterSound || filterGameSetting && filterGameSetting !== "autoPlay" && filterGameSetting !== "showHint") {
          try {
            const userSettingsSnapshot = await FirebaseRef.child(`usersSettings/${uid}`).once('value');
            const userSettings = userSettingsSnapshot.val() || null;

            const userMobileSettingsSnapshot = await FirebaseRef.child(`userSettings/${uid}`).once('value');
            const userMobileSettings = userMobileSettingsSnapshot.val() || null;
            
            if (filterSound === "yes") {
              if (userSettings && userSettings.userSettings && userSettings.userSettings.soundOn === false) includeItem = false;
            } else if (filterSound === "no") {
              if (!userSettings || !userSettings.userSettings || userSettings.userSettings.soundOn === true) includeItem = false;
            }

            if (filterGameSetting === "leavingRoomBeforeEnd") {
              // if (userSettings && userSettings.notificationSettings && userSettings.notificationSettings.leaveRoom === false) {
              //   includeItem = false;
              // }
              if (userSettings?.notificationSettings?.leaveRoom ?? true) {
                includeItem = false;
              }
            }
            else if (filterGameSetting === "choosingLastRound") {
              // if (userSettings && userSettings.notificationSettings && userSettings.notificationSettings.lastRound === false) {
              //   includeItem = false;
              // }
              if (userSettings?.notificationSettings?.lastRound ?? true) {
                includeItem = false;
              }
            }
            else if (filterGameSetting === "choosingFold") {
              // if (userSettings && userSettings.notificationSettings && userSettings.notificationSettings.quitRound === false) {
              //   includeItem = false;
              // }
              if (userSettings?.notificationSettings?.quitRound ?? true) {
                includeItem = false;
              }
            }
            else if (filterGameSetting === "ignoringPlayer") {
              // if (userSettings && userSettings.notificationSettings && userSettings.notificationSettings.ignorePlayer === false) {
              //   includeItem = false;
              // }
              if (userSettings?.notificationSettings?.ignorePlayer ?? true) {
                includeItem = false;
              }
            }
            else if (filterGameSetting === "leavingGameAccount") {
              // if (userSettings && userSettings.notificationSettings && userSettings.notificationSettings.quitAccount === false) {
              //   includeItem = false;
              // }
              if (userSettings?.notificationSettings?.quitAccount ?? true) {
                includeItem = false;
              }
            }
            else if (filterGameSetting === "purchasingGift") {
              // if (userSettings && userSettings.notificationSettings && userSettings.notificationSettings.purchaseGift === false) {
              //   includeItem = false;
              // }
              if (userSettings?.notificationSettings?.purchaseGift ?? true) {
                includeItem = false;
              }
            }
            else if (filterGameSetting === "removingGiftFromProfile") {
              // if (userSettings && userSettings.notificationSettings && userSettings.notificationSettings.removeGift === false) {
              //   includeItem = false;
              // }
              if (userSettings?.notificationSettings?.removeGift ?? true) {
                includeItem = false;
              }
            }
            else if (filterGameSetting === "showResultsAfterEachRound") {
              // if (userSettings && userSettings.notificationSettings && userSettings.notificationSettings.showAfterRound === false) {
              //   includeItem = false;
              // }
              if (userSettings?.notificationSettings?.showAfterRound ?? true) {
                includeItem = false;
              }
            }
            else if (filterGameSetting === "showResultsAtTheEndOfRoom") {
              // if (userSettings && userSettings.notificationSettings && userSettings.notificationSettings.showAtRoomEnd === false) {
              //   includeItem = false;
              // }
              if (userSettings?.notificationSettings?.showAtRoomEnd ?? true) {
                includeItem = false;
              }
            }

            else if (filterGameSetting === "doNotShowAnyConfirmationWindow") {
              if (userSettings && userSettings.notificationSettings) {
                if ((userSettings.notificationSettings.leaveRoom
                  || userSettings.notificationSettings.lastRound
                  || userSettings.notificationSettings.quitRound
                  || userSettings.notificationSettings.ignorePlayer
                  || userSettings.notificationSettings.quitAccount
                  || userSettings.notificationSettings.purchaseGift
                  || userSettings.notificationSettings.removeGift
                  || userSettings.notificationSettings.showAfterRound
                  || userSettings.notificationSettings.showAtRoomEnd)
                ) includeItem = false;
              } else {
                includeItem = false;
              }

              // if (userSettings && userSettings.notificationSettings) {
              //   if ((userSettings.notificationSettings.leaveRoom === false
              //     && userSettings.notificationSettings.lastRound === false
              //     && userSettings.notificationSettings.quitRound === false
              //     && userSettings.notificationSettings.ignorePlayer === false
              //     && userSettings.notificationSettings.quitAccount === false
              //     && userSettings.notificationSettings.purchaseGift === false
              //     && userSettings.notificationSettings.removeGift === false
              //     && userSettings.notificationSettings.showAfterRound === false
              //     && userSettings.notificationSettings.showAtRoomEnd === false)
              //   ) includeItem = false;
              // }
            }
            if (filterGameSetting === "cardPlayWithOneClick" && !userSettings?.gameSettings?.doubleClickPlay) includeItem = false;
            //if (filterGameSetting === "cardPlayWithOneClick" && userSettings?.gameSettings?.doubleClickPlay) includeItem = false;

          } catch (err) {
            console.error(`sound fetch err ${uid}:`, err);
            includeItem = false;
          }
        }

        if (filterGameSetting === "autoPlay" && !user.disableAutoPlay) includeItem = false;
        if (filterGameSetting === "showHint" && !user.showHint) includeItem = false;

        const isSocial = user.socProvider && user.socProvider !== 'password';
        if (isSocial) {
          if (filterVerified === "n/a" && (user.contactEmail || user.verifiedEmail)) includeItem = false;
          if (filterVerified === "true" && (!user.contactEmail || user.contactEmail === constants.NO_EMAIL_USER || !user.verifiedEmail)) includeItem = false;
          if (filterVerified === "false" && (!user.contactEmail || user.contactEmail === constants.NO_EMAIL_USER || user.verifiedEmail)) includeItem = false;
        } else {
          if (filterVerified === "n/a") includeItem = false;
          if (filterVerified === "true" && !user.verifiedEmail) includeItem = false;
          if (filterVerified === "false" && user.verifiedEmail) includeItem = false;
        }
        
        

        if (filterRegEnabled && !(user.dateCreated >= filterRegStartDate && user.dateCreated <= filterRegEndDate)) includeItem = false;
        if (filterLastLoginEnabled && !(user.lastLogin >= filterLastLoginStartDate && user.lastLogin <= filterLastLoginEndDate)) includeItem = false;
        if (filterBalanceEnabled && !(user.bal >= filterBalanceFrom && user.bal <= filterBalanceTo)) includeItem = false;
        if (filterPointsEnabled && !(user.totalPnts >= filterPointsFrom && user.totalPnts <= filterPointsTo)) includeItem = false;

        if (filterPurchasesEnabled) {
          if (filterPurchasesUsers.length > 0) {
            if (!filterPurchasesUsers.includes(uid)) {
              includeItem = false;
            }
          } else {
            includeItem = false;
          }
        }

        if (filterPlayedGamesEnabled && !(user.gPlayed >= filterPlayedGamesFrom && user.gPlayed <= filterPlayedGamesTo)) {
          includeItem = false;}
        if (filterLevelEnabled && !(user.lvl >= filterLevelFrom && user.lvl <= filterLevelTo)) includeItem = false;

        if (filterAchievementsEnabled) {
          let claimedAchievementsHistory = {};
          try {
            const claimedAchievementsHistorySnapshot = await FirebaseRef.child(`claimedAchievementsHistory/${uid}`).once('value');
            claimedAchievementsHistory = claimedAchievementsHistorySnapshot.val() || {};

            const count = Object.values(claimedAchievementsHistory).filter(achievement => achievement.time >= filterAchievementsStartDate && achievement.time <= filterAchievementsEndDate).length;
            if (count === 0) includeItem = false;

          } catch (err) {
            console.error("err loading completed claimedAchievementsHistory:", err, uid);
            includeItem = false;
          }
        }

        if (filterRewardsEnabled && !(user.claimedAchievementsTotal >= filterRewardsFrom && user.claimedAchievementsTotal <= filterRewardsTo)) includeItem = false;

        /* if (filterRewardsEnabled) {
          let claimedRewards = {};
          try {
            const claimedRewardsSnapshot = await FirebaseRef.child(`claimedRewards/${uid}`).once('value');
            claimedRewards = claimedRewardsSnapshot.val() || {};

            const count = Object.keys(claimedRewards).length;

            if (!(count >= filterRewardsFrom && count <= filterRewardsTo)) includeItem = false;

          } catch (err) {
            console.error("err loading completed claimedRewards:", err, uid);
            includeItem = false;
          }
        } */

        if (filterTutorialBonus === "yes" && !user.tutorialBonus || filterTutorialBonus === "no" && user.tutorialBonus) includeItem = false;
        if (filterAndroidAppBonus === "yes" && !user.AndroidBonus || filterAndroidAppBonus === "no" && user.AndroidBonus) includeItem = false;
        if (filterIOSAppBonus === "yes" && !user.IOSBonus || filterIOSAppBonus === "no" && user.IOSBonus) includeItem = false;
        if (filterRank && !user[filterRank]) includeItem = false;
        return includeItem ? [uid, user] : null;
      })
    );

    const sortedEntries = Object.fromEntries(
      entries.filter(Boolean)
        .sort(([, userA], [, userB]) => userB.lastLogin - userA.lastLogin)
    );

    return sortedEntries;
  };

  // const fetchFilteredData = (query, queries) => { // old

  //   return query.once('value')
  //     .then(snapshot => {
  //       let data = snapshot.val() || {};
  //       return applyFilters(data);
  //     })
  //     .catch(error => {
  //       console.log("err fetchFilteredData:", error);
  //       return {};
  //     });
  // };


  const fetchFilteredData = (query, queries = []) => {
    const getData = q => q.once('value').then(snap => snap.val() || {});

    // for cases when multiple queries arent used
    if (!queries || queries.length === 0) {
      return getData(query)
        .then(data => applyFilters(data))
        .catch(error => {
          console.error("err fetchFilteredData:", error);
          return {};
        });
    }

    // for cases when multiple queries are used
    return Promise.all(queries.map(getData))
      .then(results => {
        const dataArrays = results.map(obj => Object.values(obj || {}));

        const uidSets = dataArrays.map(arr => new Set(arr.map(item => item.uid)));
        const commonUids = [...uidSets[0]].filter(uid =>
          uidSets.every(set => set.has(uid))
        );

        const combinedData = {};
        dataArrays[0].forEach(item => {
          if (commonUids.includes(item.uid)) {
            combinedData[item.uid] = item;
          }
        });

        return applyFilters(combinedData);
      })
      .catch(error => {
        console.error("err fetchFilteredData:", error);
        return {};
      });
  };

  const dispatchFilteredData = (query, queries, dispatch) => {
    return fetchFilteredData(query, queries)
      .then(data => dispatch({ type: 'ADMIN_FILTERED_USERS', data }))
      .catch(err => console.log(err.message));
  };

  return dispatch => {
    let query;
    let queries = [];

    console.log('filterRewardsEnabled', filterRewardsEnabled, filterRewardsFrom, filterRewardsTo);

    if (!filterValue) {
      // if (filterPrecision && (filterBalanceEnabled || filterPointsEnabled || filterPlayedGamesEnabled || filterLevelEnabled || filterRewardsEnabled)) {
      //   if (filterBalanceEnabled && (parseInt(filterBalanceFrom, 10) || parseInt(filterBalanceFrom, 10) === 0) && parseInt(filterBalanceTo, 10)) {
      //     //query = FirebaseRef.child('users').orderByChild('bal').startAt(parseInt(filterBalanceFrom, 10)).endAt(parseInt(filterBalanceTo, 10)).limitToLast(20000);
      //     if (filterBalanceFrom === 0) {
      //       queries.push(FirebaseRef.child('users').orderByChild('bal').endAt(parseInt(filterBalanceTo, 10)));//.limitToLast(20000);
      //     } else {
      //       queries.push(FirebaseRef.child('users').orderByChild('bal').startAt(parseInt(filterBalanceFrom, 10)).endAt(parseInt(filterBalanceTo, 10)));//.limitToLast(20000);
      //     }

      //   }
      //   if (filterPointsEnabled && (parseInt(filterPointsFrom, 10) || parseInt(filterPointsFrom, 10) === 0) && parseInt(filterPointsTo, 10)) {
      //     //query = FirebaseRef.child('users').orderByChild('totalPnts').startAt(parseInt(filterPointsFrom, 10)).endAt(parseInt(filterPointsTo, 10)).limitToLast(20000);
      //     // if (filterPointsFrom === 0) {
      //     //   queries.push(FirebaseRef.child('users').orderByChild('totalPnts').endAt(parseInt(filterPointsTo, 10)));//.limitToLast(20000);
      //     // } else {
      //       queries.push(FirebaseRef.child('users').orderByChild('totalPnts').startAt(parseInt(filterPointsFrom, 10)).endAt(parseInt(filterPointsTo, 10)));//.limitToLast(20000);
      //     //}

      //   }
      //   if (filterPlayedGamesEnabled && (parseInt(filterPlayedGamesFrom, 10) || parseInt(filterPlayedGamesFrom, 10) === 0) && parseInt(filterPlayedGamesTo, 10)) {
      //     //query = FirebaseRef.child('users').orderByChild('gPlayed').startAt(parseInt(filterPlayedGamesFrom, 10)).endAt(parseInt(filterPlayedGamesTo, 10)).limitToLast(20000);
      //     if (filterPlayedGamesFrom === 0) {
      //       queries.push(FirebaseRef.child('users').orderByChild('gPlayed').endAt(parseInt(filterPlayedGamesTo, 10)));//.limitToLast(20000);
      //     } else {
      //       queries.push(FirebaseRef.child('users').orderByChild('gPlayed').startAt(parseInt(filterPlayedGamesFrom, 10)).endAt(parseInt(filterPlayedGamesTo, 10)));//.limitToLast(20000);
      //     }

      //   }
      //   if (filterLevelEnabled && (parseInt(filterLevelFrom, 10) || parseInt(filterLevelFrom, 10) === 0) && parseInt(filterLevelTo, 10)) {
      //     //query = FirebaseRef.child('users').orderByChild('lvl').startAt(parseInt(filterLevelFrom, 10)).endAt(parseInt(filterLevelTo, 10)).limitToLast(20000);
      //     if (filterLevelFrom === 0) {
      //       queries.push(FirebaseRef.child('users').orderByChild('lvl').endAt(parseInt(filterLevelTo, 10)));//.limitToLast(20000);
      //     } else {
      //       queries.push(FirebaseRef.child('users').orderByChild('lvl').startAt(parseInt(filterLevelFrom, 10)).endAt(parseInt(filterLevelTo, 10)));//.limitToLast(20000);
      //     }

      //   }
      //   if (filterRewardsEnabled && (parseInt(filterRewardsFrom, 10) || parseInt(filterRewardsFrom, 10) === 0) && parseInt(filterRewardsTo, 10)) {
      //     //query = FirebaseRef.child('users').orderByChild('claimedAchievementsTotal').startAt(parseInt(filterRewardsFrom, 10)).endAt(parseInt(filterRewardsTo, 10)).limitToLast(20000);
      //     if (filterRewardsFrom === 0) {
      //       queries.push(FirebaseRef.child('users').orderByChild('claimedAchievementsTotal').endAt(parseInt(filterRewardsTo, 10)));//.limitToLast(20000);
      //     } else {
      //       queries.push(FirebaseRef.child('users').orderByChild('claimedAchievementsTotal').startAt(parseInt(filterRewardsFrom, 10)).endAt(parseInt(filterRewardsTo, 10)));//.limitToLast(20000);
      //     }
      //   }
      // }
      // else {
        if (!filterPrecision)
          query = FirebaseRef.child('users').orderByChild('lastLogin').limitToLast(20000);
        else
          query = FirebaseRef.child('users').orderByChild('lastLogin');
      //}
    } else if (filterType === constants.USERNAME_LOWER_UPPER.lowerCaseName || filterType === constants.USERNAME_LOWER_UPPER.lowerCaseLastName) {
      query = FirebaseRef.child('users').orderByChild(filterType).startAt(filterValue.toLowerCase()).endAt(`${filterValue.toLowerCase()}\uf8ff`);
    } else if (filterType === 'uid') {
      query = FirebaseRef.child('users').orderByKey().equalTo(filterValue.toString()).limitToFirst(1);
    } else if (filterType === 'email') {
      query = FirebaseRef.child('users').orderByChild(filterType).startAt(filterValue).endAt(`${filterValue}\uf8ff`);
    } else if (filterType === 'lastIp') {
      return FirebaseRef.child('usersLastIp').orderByValue().equalTo(filterValue).once('value')
        .then(snapshot => {
          const matchingKeys = Object.keys(snapshot.val() || {});

          if (matchingKeys.length === 0) {
            return dispatch({ type: 'ADMIN_FILTERED_USERS', data: {} });
          }

          const promises = matchingKeys.map(key => FirebaseRef.child('users').child(key).once('value'));
          return Promise.all(promises).then(snapshots => {
            let data = {};
            snapshots.forEach(snap => {
              if (snap.exists()) {
                data[snap.key] = snap.val();
              }
            });
            return applyFilters(data).then(filteredData =>
              dispatch({ type: 'ADMIN_FILTERED_USERS', data: filteredData })
            );
          });
        })
        .catch(err => console.log(err.message));
    }

    return dispatchFilteredData(query, queries, dispatch);
  };

}
export function getNonVerifiedUsers(filterValue, filterType) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  console.log('users fetch getNonVerifiedUsers', filterValue, filterType);

  return dispatch => new Promise(resolve => FirebaseRef.child('users')
    .orderByChild('verifiedEmail')
    .equalTo(false)
    // .limitToFirst(300)
    .once('value', (snapshot) => {
      const data = snapshot.val() || {};
      const array = [];

      console.log('data', data);

      Object.keys(data).map((key) => {
        if (filterValue && filterType) {
          if (filterType === 'lowerCaseName') {
            if (data[key].lowerCaseName && data[key].lowerCaseName.includes(filterValue.toLowerCase())) {
              array.push({ key, ...data[key] });
            }
          } else if (filterType === 'lowerCaseLastName') {
            if (data[key].lowerCaseLastName && data[key].lowerCaseLastName.includes(filterValue.toLowerCase())) {
              array.push({ key, ...data[key] });
            }
          } else if (filterType === 'uid') {
            if (key && key.toLowerCase().includes(filterValue.toLowerCase())) {
              array.push({ key, ...data[key] });
            }
          } else if (filterType === 'email') {
            if (data[key].email && data[key].email.includes(filterValue.toLowerCase())) {
              array.push({ key, ...data[key] });
            }
          }
        } else {
          array.push({ key, ...data[key] });
        }
        return null;
      });

      array.sort((a, b) => (b.lastLogin - a.lastLogin));

      // show only users from social networks, who have set contactEmail, but have not verified it
      const filteredArray = array.filter(user => (
        (!['draugiem', 'inbox', 'facebook'].includes(user.socProvider) ||
         // (user.socProvider === 'password' && !user.verifiedEmailForFirstTime) ||
        (user.contactEmail && user.contactEmail !== constants.NO_EMAIL_USER && !user.contactEmail.endsWith('@openid.inbox.lv') && !user.emailVerified)) &&
        user.verifiedEmailSent
      ));

      return resolve(dispatch({ type: 'ADMIN_NONVERIFIED_REPLACE', data: filteredArray }));
    })).catch((err) => { console.log(err.message); });
}

export function getAutoCompensations() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => AdminLogsRef().child('autoCompensations')
    .once('value', (snapshot) => {
      const autoCompensations = snapshot.val() || {};

      const sortedCompensations = Object.fromEntries(
        Object.entries(autoCompensations)
          .sort(
            ([, a], [, b]) =>
              b.lastDate - a.lastDate
          )
      );

      return resolve(dispatch({ type: 'ADMIN_AUTO_COMPENSATIONS_REPLACE', data: sortedCompensations }));
    })).catch((err) => { console.log(err.message); });
}

export function disableAutoCompensation(uid, autoCompensation, name) {
  return () => new Promise((resolve, reject) => {

    if (!uid) return reject({ code: 'Missing UID' });

    const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
    const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
    const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;


    const disableAutoCompensationFunction = Firebase.app().functions('europe-west1').httpsCallable('disableAutoCompensation');

    disableAutoCompensationFunction({uid, autoCompensation}).then(async (res) => {
      if (res.data.status === 'error') {
        return resolve({ status: constants.SERVER_STATUS_CODE.error, message: 'error' });
      } else {

        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'disableAutoCompensation',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          userId: uid.toString(),
          userName: name || null,
          data: {
            disabled: !!autoCompensation,
          },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });

        return resolve({ status: constants.SERVER_STATUS_CODE.success });
      }

    }).catch(e => {
      console.log(e, "disable auto compensation error")
      return reject({ code: e.code });
    });
  });
}

export function getRoomLogCount() {
  if (Firebase === null) return () => new Promise(resolve => resolve());


  return dispatch => new Promise(resolve => FirebaseRef.child('statistics/roomsPlayed')
    .on('value', (snapshot) => {
      const roomsPlayed = snapshot.val() || 0;

      return resolve(dispatch({ type: 'ADMIN_ROOM_LOGS_COUNT', data: roomsPlayed }));
    })).catch((err) => { console.log(err.message); });
}

export function getRoomLogCount2() {
  if (Firebase === null) return () => new Promise(resolve => resolve());


  return dispatch => new Promise(resolve => FirebaseRef.child('statistics/roomsPlayed2')
    .on('value', (snapshot) => {
      const roomsPlayed = snapshot.val() || 0;

      return resolve(dispatch({ type: 'ADMIN_ROOM_LOGS_COUNT_2', data: roomsPlayed }));
    })).catch((err) => { console.log(err.message); });
}


// export function getRoomLogsRange(start, end) {
//   if (Firebase === null) return () => new Promise(resolve => resolve());

//   return dispatch => new Promise(resolve => AdminLogsRef().child('adminLogs/roomIds')
//     .orderByChild('index')
//     .startAt(start)
//     .endAt(end)
//     .once('value', async (snapshot) => {
//       const roomLogs = snapshot.val() || {};
//       forEach(roomLogs, async (item, key) => {
//         const promise1 = await AdminLogsRef().child(`adminLogs/rooms/${key}`).once('value');
//         roomLogs[key] = { ...roomLogs[key], partyCount: size(promise1.val()) - 1 };
//       });
//       console.log(roomLogs, "check===================")

//       return resolve(dispatch({ type: 'ADMIN_ROOM_LOGS_REPLACE', data: { logs: roomLogs, loading: false } }));
//     }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
// }

export function getRoomLogsRange(start, end) {
  if (Firebase === null) return () => Promise.resolve();

  return async dispatch => {
    dispatch({type: 'ADMIN_ROOM_LOGS_REPLACE', data: { loading: true }});

    try {
      const snapshot = await AdminLogsRef()
        .child('adminLogs/roomIds')
        .orderByChild('index')
        .startAt(start)
        .endAt(end)
        .once('value');

      const roomLogs = snapshot.val() || {};

      await Promise.all(Object.keys(roomLogs).map(async key => {
        const snap = await AdminLogsRef()
          .child(`adminLogs/rooms/${key}`)
          .once('value');

        roomLogs[key] = {
          ...roomLogs[key],
          partyCount: size(snap.val()) - 1
        };
      }));

      console.log(roomLogs, "check===================");
      dispatch({ type: 'ADMIN_ROOM_LOGS_REPLACE', data: { logs: roomLogs, loading: false }});

    } catch (err) {
      console.log(err);
      dispatch({ type: 'ADMIN_ROOM_LOGS_REPLACE', data: { loading: false } });
    }
  };
}



// export function getFilteredRoomLogs(filterValue, filterType, filterMinValue, filterSpeed, filterBet, filterAmountOfPlayer, filterCloseReason, filterByTimeBetween, filterByTimeBetweenTime, showBotRoom, startDate, endDate) {
//   if (Firebase === null) return () => new Promise(resolve => resolve());
//   console.log('getFilteredRoomLogs', { filterValue, filterType, filterMinValue, filterSpeed, filterBet, filterAmountOfPlayer, filterCloseReason, filterByTimeBetween, filterByTimeBetweenTime, showBotRoom, startDate, endDate });


//   if (!filterType || (!filterValue && !filterMinValue && !startDate && !endDate && !filterSpeed && !filterBet && !filterAmountOfPlayer && !(filterByTimeBetween !== '' && filterByTimeBetweenTime) && filterType !== constants.MISSEDTURN && !filterCloseReason && !showBotRoom)) return dispatch => new Promise(resolve => resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: null })));

//   if (filterByTimeBetween !== '' && filterByTimeBetweenTime) {
//     console.log('filter by time between', filterByTimeBetween, filterByTimeBetweenTime, (parseInt(filterByTimeBetweenTime, 10) * (1000 * 60)));

//     return dispatch => new Promise((resolve) => {
//       AdminLogsRef().child('adminLogs/roomIds')
//         .orderByChild(filterByTimeBetween)
//         .startAt(parseInt(filterByTimeBetweenTime, 10) * (1000 * 60))
//         .limitToLast(3000)
//         .once('value', (snapshot) => {
//           const data = snapshot.val() || {};

//           console.log('test 2 filterByTimeBetween', data);

//           let updatedLogs = [];
//           if (Object.keys(data).length > 0) {
//             Object.entries(data).map(([key, item]) => {
//               if (item.date >= startDate && item.date <= endDate) {
//                 updatedLogs.push({
//                   ...item,
//                   key,
//                 });
//               }
//             });

//             updatedLogs.reverse();

//             console.log('updatedLogs', updatedLogs);
//           }

//           return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs }));
//         });
//     });
//   }


//   if (filterCloseReason !== '') {
//     if ([constants.LASTROUND, constants.LeftBeforeStart, constants.GAMEERROR, filterCloseReason === constants.LEFTROOM].includes(filterCloseReason)) { //  || filterCloseReason === constants.GAMEERROR || filterCloseReason === constants.LEFTROOM
//       return dispatch => new Promise((resolve) => {
//         AdminLogsRef().child('adminLogs/roomIds')
//           .orderByChild('closeReason')
//           .equalTo(filterCloseReason)
//           .limitToLast(35000)
//           .once('value', async (snapshot) => {
//             const data = snapshot.val() || {};

//             let updatedLogs = [];
//             if (Object.keys(data).length > 0) {
//               const promises = Object.entries(data).map(async ([key, item]) => {
//                 if (item.closeReason === filterCloseReason && item.date >= startDate && item.date <= endDate) {

//                   updatedLogs.push({
//                     ...item,
//                     key,
//                   });
//                 }
//               });

//               updatedLogs.reverse();

//               await Promise.all(promises);
//             }

//             return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs }));
//           });
//       });
//     }
//     const selectFilterCloseReason = constants.closeReason.filter(item => filterCloseReason === item.id).reduce((obj, key) => {
//       const objCopy = { ...obj };
//       objCopy[key] = constants.closeReason[key];
//       return objCopy;
//     });
//     return dispatch => new Promise(resolve => {
//       AdminLogsRef().child('adminLogs/roomIds')
//       .orderByChild('date')
//       .startAt(startDate)
//         .endAt(endDate)
//         .limitToLast(35000)
//       .once('value', async (snapshot) => {
//         const data = snapshot.val() || {};

//         let updatedLogs = [];
//         if (Object.keys(data).length > 0) {
//           const promises = Object.entries(data).map(async ([key, item]) => {
//             if ((item.closeReason === selectFilterCloseReason.filterType && (!selectFilterCloseReason.isOnline && (data[key].isOnline === selectFilterCloseReason.isOnline || !data[key].isOnline)) && (!selectFilterCloseReason.triedToMove && (data[key].triedToMove === selectFilterCloseReason.triedToMove || !data[key].triedToMove))) || (item.closeReason === selectFilterCloseReason.filterType && (selectFilterCloseReason.isOnline && data[key].isOnline === selectFilterCloseReason.isOnline) && (selectFilterCloseReason.triedToMove && data[key].triedToMove === selectFilterCloseReason.triedToMove))) {

//               updatedLogs.push({
//                   ...item,
//                   key,
//               });
//             }
//           });

//           await Promise.all(promises);
//         }

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//       })
//     })
//   }

//   if (filterMinValue !== '') {
//     return dispatch => new Promise(resolve => {
//       AdminLogsRef().child('adminLogs/roomIds')
//       .orderByChild('date')
//       .startAt(startDate)
//         .endAt(endDate)
//         .limitToLast(35000)
//       .once('value', async (snapshot) => {
//         const data = snapshot.val() || {};

//         let updatedLogs = [];
//         if (Object.keys(data).length > 0) {
//           const promises = Object.entries(data).map(async ([key, item]) => {
//             if (data[key]?.party >= parseInt(filterMinValue, 10)) {

//               updatedLogs.push({
//                   ...item,
//                   key,
//               });
//             }
//           });

//           await Promise.all(promises);
//         }

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//       })
//     })
//   }

//   if (filterSpeed !== '') {
//     return dispatch => new Promise(resolve => {
//       AdminLogsRef().child('adminLogs/roomIds')
//       .orderByChild('date')
//       .startAt(startDate)
//         .endAt(endDate)
//         .limitToLast(35000)
//       .once('value', async (snapshot) => {
//         const data = snapshot.val() || {};

//         let updatedLogs = [];
//         if (Object.keys(data).length > 0) {
//           const promises = Object.entries(data).map(async ([key, item]) => {
//             if (data[key]?.speed === filterSpeed) {

//               updatedLogs.push({
//                   ...item,
//                   key,
//               });
//             }
//           });

//           await Promise.all(promises);
//         }
//         return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//       })
//     })
//   }

//   if (filterBet !== '') {
//     return dispatch => new Promise(resolve => {
//       AdminLogsRef().child('adminLogs/roomIds')
//       .orderByChild('date')
//       .startAt(startDate)
//         .endAt(endDate)
//         .limitToLast(35000)
//       .once('value', async (snapshot) => {
//         const data = snapshot.val() || {};

//         let updatedLogs = [];
//         if (Object.keys(data).length > 0) {
//           const promises = Object.entries(data).map(async ([key, item]) => {
//             if (data[key]?.bet === filterBet) {

//               updatedLogs.push({
//                   ...item,
//                   key,
//               });
//             }
//           });

//           await Promise.all(promises);
//         }

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//       })
//     })
//   }

//   if (filterAmountOfPlayer !== '') {
//     console.log('has filterAmountOfPlayer');

//     if (filterAmountOfPlayer === 'true') {
//       return dispatch => new Promise(resolve => {
//         AdminLogsRef().child('adminLogs/roomIds')
//         .orderByChild('date')
//         .startAt(startDate)
//           .endAt(endDate)
//           .limitToLast(35000)
//         .once('value', async (snapshot) => {
//           const data = snapshot.val() || {};

//           let updatedLogs = [];
//           if (Object.keys(data).length > 0) {
//             const promises = Object.entries(data).map(async ([key, item]) => {
//               if (data[key]?.fourPRoom) {

//                 updatedLogs.push({
//                     ...item,
//                     key,
//                 });
//               }
//             });

//             await Promise.all(promises);
//           }

//           return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//         })
//       })
//     }

//     return dispatch => new Promise(resolve => {
//       AdminLogsRef().child('adminLogs/roomIds')
//       .orderByChild('date')
//       .startAt(startDate)
//       .endAt(endDate)
//         .limitToLast(35000)
//       .once('value', async (snapshot) => {
//         const data = snapshot.val() || {};

//         console.log('data', data);

//         let updatedLogs = [];
//         if (Object.keys(data).length > 0) {
//           const promises = Object.entries(data).map(async ([key, item]) => {
//             if (!data[key]?.fourPRoom) {

//               updatedLogs.push({
//                   ...item,
//                   key,
//               });
//             }
//           });

//           await Promise.all(promises);
//         }

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//       })
//     })
//   }

//   console.log('adminLogs/roomIds test 2', { filterType, filterValue, startDate, endDate });

//   if (filterType === constants.ROOMID && !filterValue && startDate && endDate) {
//     return dispatch => new Promise(resolve => AdminLogsRef().child('adminLogs/roomIds')
//       .orderByChild('date')
//       .startAt(startDate)
//       .endAt(endDate)
//       .limitToLast(35000)
//       .once('value', async (snapshot) => {
//         const data = snapshot.val() || {};

//         let updatedLogs = [];
//         if (Object.keys(data).length > 0) {
//           const promises = Object.entries(data).map(async ([key, item]) => {
//             updatedLogs.push({
//               ...item,
//               key,
//             });
//           });

//           await Promise.all(promises);
//         }

//         console.log('updatedLogs 1', updatedLogs);

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//       })).catch((err) => { console.log(err.message); });
//   }

//   if (filterType === constants.ROOMID) {
//     return dispatch => new Promise(resolve => AdminLogsRef().child('adminLogs/roomIds')
//       .orderByKey()
//       .startAt(filterValue.trim())
//       .endAt(`${filterValue.trim()}\uf8ff`)
//       .limitToLast(2500)
//       .once('value', async (snapshot) => {
//         const data = snapshot.val() || {};

//         let updatedLogs = [];
//         if (Object.keys(data).length > 0) {
//           const promises = Object.entries(data).map(async ([key, item]) => {
//             updatedLogs.push({
//               ...item,
//               key,
//             });
//           });

//           await Promise.all(promises);
//         }

//         console.log('updatedLogs 2', updatedLogs);

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//       })).catch((err) => { console.log(err.message); });
//   }

//   if (filterType === constants.USERID && startDate && endDate) {
//     return dispatch => new Promise(resolve => AdminLogsRef().child(`adminLogs/playerRooms/${filterValue}`)
//       .orderByChild('date')
//       .startAt(startDate)
//       .endAt(endDate)
//       .limitToLast(2500)
//         .once('value', async (snapshot) => {
//           const data = snapshot.val() || {};
//           console.log(data, "checkRoomId=");


//           let updatedLogs = [];
//           if (Object.keys(data).length > 0) {
//             const promises = Object.entries(data).map(async ([key, item]) => {
//               updatedLogs.push({
//                 ...item,
//                 key,
//               });
//             });

//             await Promise.all(promises);
//           }

//           return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//         })).catch((err) => { console.log(err.message); });
//   }

//   if (filterType === constants.USERID) {
//     return dispatch => new Promise(resolve => AdminLogsRef().child(`adminLogs/playerRooms/${filterValue}`).limitToLast(1000)
//       .once('value', async (snapshot) => {
//         const data = snapshot.val() || {};
//         console.log(data, "checkRoomId=");

//         let updatedLogs = [];
//         if (Object.keys(data).length > 0) {
//           const promises = Object.entries(data).map(async ([key, item]) => {
//             updatedLogs.push({
//               ...item,
//               key,
//             });
//           });

//           await Promise.all(promises);
//         }

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//       })).catch((err) => { console.log(err.message); });
//   }

//   if (showBotRoom) {
//     return dispatch => new Promise(resolve => {
//       AdminLogsRef().child('adminLogs/roomIds')
//       .orderByChild('date')
//       .startAt(startDate)
//       .endAt(endDate)
//       .once('value', async (snapshot) => {
//         const data = snapshot.val() || {};

//         let updatedLogs = [];
//         if (Object.keys(data).length > 0) {
//           const promises = Object.entries(data).map(async ([key, item]) => {
//             if (data[key]?.hasBots) {

//               updatedLogs.push({
//                   ...item,
//                   key,
//               });
//             }
//           });

//           await Promise.all(promises);
//         }

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//       })
//     })
//   }

//   if (filterType === constants.MISSEDTURN) {
//     return dispatch => new Promise(resolve => {
//       AdminLogsRef().child('adminLogs/roomIds')
//       .orderByChild('date')
//       .startAt(startDate)
//       .endAt(endDate)
//       .once('value', async (snapshot) => {
//         const data = snapshot.val() || {};

//         let updatedLogs = [];
//         if (Object.keys(data).length > 0) {
//           const promises = Object.entries(data).map(async ([key, item]) => {
//             if (data[key]?.closeReason === constants.MISSEDTURN) {

//               updatedLogs.push({
//                   ...item,
//                   key,
//               });
//             }
//           });

//           await Promise.all(promises);
//         }

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//       })
//     })
//   }
//   if (startDate && endDate) {
//     return dispatch => new Promise(resolve => {
//       let query = AdminLogsRef().child('adminLogs/roomIds')
//         .orderByChild(filterType)
//         .startAt(filterValue.trim())
//         .endAt(`${filterValue.trim()}\uf8ff`)
//         .limitToLast(3000);

//       query.once('value', async (snapshot) => {
//         const data = snapshot.val() || {};

//         console.log('datadatadata', data, filterType, filterValue);

//         let updatedLogs = [];
//         if (Object.keys(data).length > 0) {
//           updatedLogs = Object.entries(data)
//             .map(([key, item]) => ({ ...item, key }))
//             .filter(item => item.date >= startDate && item.date <= endDate);
//         }

//         return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//       });
//     }).catch((err) => {
//       console.log(err.message);
//     });
//   }
//   return dispatch => new Promise(resolve => AdminLogsRef().child('adminLogs/roomIds')
//     .orderByChild(filterType)
//     .startAt(filterValue.trim())
//     .endAt(`${filterValue.trim()}\uf8ff`)
//     .limitToLast(3000)
//     .once('value', async (snapshot) => {
//       const data = snapshot.val() || {};
//       console.log('datadatadata', data, filterType, filterValue);

//       let updatedLogs = [];
//       if (Object.keys(data).length > 0) {
//         const promises = Object.entries(data).map(async ([key, item]) => {
//           updatedLogs.push({
//             ...item,
//             key,
//           });
//         });

//         await Promise.all(promises);
//       }

//       return resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: updatedLogs.reverse() }));
//     })).catch((err) => { console.log(err.message); });
// }

export function getFilteredRoomLogs(
  filterValue,
  filterType,
  filterMinValue,
  filterPlatform,
  filterSpeed,
  filterGames,
  filterBet,
  filterGameType,
  filterAmountOfPlayer,
  filterCloseReason,
  filterByTimeBetween,
  filterByTimeBetweenTime,
  filterBots,
  filterTournament,
  showActiveRooms,
  showMergedRooms,
  showAutoPlayRooms,
  excludeLeftBeforeStartRooms,
  onlyPenaltyRooms,
  startDate,
  endDate,
  winPointsFrom,
  winPointsTo,
  winCoinsFrom,
  winCoinsTo,
  lossPointsFrom,
  lossPointsTo,
  lossCoinsFrom,
  lossCoinsTo,
) {

  console.log('getFilteredRoomLogs', {
    filterValue,
    filterType,
    filterMinValue,
    filterPlatform,
    filterSpeed,
    filterGames,
    filterBet,
    filterGameType,
    filterAmountOfPlayer,
    filterCloseReason,
    filterByTimeBetween,
    filterByTimeBetweenTime,
    filterBots,
    filterTournament,
    showActiveRooms,
    showMergedRooms,
    showAutoPlayRooms,
    excludeLeftBeforeStartRooms,
    onlyPenaltyRooms,
    startDate,
    endDate,
    winPointsFrom,
    winPointsTo,
    winCoinsFrom,
    winCoinsTo,
    lossPointsFrom,
    lossPointsTo,
    lossCoinsFrom,
    lossCoinsTo,
  });

  if (Firebase === null) return () => new Promise(resolve => resolve());
  if (
    !filterType &&
    !filterValue &&
    (!filterMinValue || filterMinValue.length === 0) &&
    !startDate &&
    !endDate &&
    !filterSpeed &&
    !filterGames &&
    (!filterBet || filterBet.length === 0) &&
    (!filterGameType || filterGameType.length === 0) &&
    (!filterPlatform || filterPlatform.length === 0) &&
    !filterAmountOfPlayer &&
    (!filterCloseReason || filterCloseReason.length === 0) &&
    !filterBots &&
    !filterTournament &&
    !showActiveRooms &&
    !showMergedRooms &&
    !showAutoPlayRooms &&
    !excludeLeftBeforeStartRooms &&
    !onlyPenaltyRooms &&
    !winPointsFrom &&
    !winPointsTo &&
    !winCoinsFrom &&
    !winCoinsTo &&
    !lossPointsFrom &&
    !lossPointsTo &&
    !lossCoinsFrom &&
    !lossCoinsTo
  ) {
    return dispatch =>
      new Promise(resolve =>
        resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: {loading: false, logs: [], totalRoomCount: 0} }))
      );
  }

  return dispatch =>
    new Promise(async resolve => {

      dispatch({
        type: 'ADMIN_FILTERED_ROOM_LOGS',
        data: {
          loading: true,
          logs: [],
          totalRoomCount: 0,
        },
      });

      try {
        const activeRoomsSnapshot = await FirebaseRef.child('activeRooms').once('value');
        const activeRooms = activeRoomsSnapshot.val() || {};
        const activeRoomIds = Object.keys(activeRooms);

        let query;
        let queries = [];
        if (filterType === constants.LASTIP && filterValue) {
          const lastIpSnapshot = await FirebaseRef.child('usersLastIp').once('value');
          const lastIpData = lastIpSnapshot.val() || {};
          const userIdsWithSpecificIp = Object.keys(lastIpData).filter(userId => lastIpData[userId] === filterValue);

          if (!showActiveRooms) {
            for (const userId of userIdsWithSpecificIp) {
              queries.push(AdminLogsRef().child(`adminLogs/playerRooms/${userId}`).orderByChild('date').startAt(startDate).endAt(endDate).limitToLast(35000));
            }
          } else {
            for (const userId of userIdsWithSpecificIp) {
              queries.push(AdminLogsRef().child(`adminLogs/playerRooms/${userId}`).orderByChild('date').limitToLast(35000));
            }
          }
        } else {
          if (!showActiveRooms) {
            query = AdminLogsRef().child(`adminLogs/roomIds`).orderByChild('date').startAt(startDate).endAt(endDate).limitToLast(35000);
          } else {
            query = AdminLogsRef().child(`adminLogs/roomIds`).orderByChild('date').limitToLast(35000);
          }

          if (filterType === constants.ROOMID && filterValue) {
            query = AdminLogsRef().child(`adminLogs/roomIds/${filterValue}`);
          }

          if (filterType === constants.TOURNAMENTID && filterValue) {
            query = AdminLogsRef().child('adminLogs/roomIds').orderByChild('tournamentId').equalTo(filterValue).limitToLast(35000);
          }

          if (filterType === constants.USERID && filterValue) {
            if (!showActiveRooms) {
              query = AdminLogsRef().child(`adminLogs/playerRooms/${filterValue}`).orderByChild('date').startAt(startDate).endAt(endDate).limitToLast(35000);
            } else {
              query = AdminLogsRef().child(`adminLogs/playerRooms/${filterValue}`).orderByChild('date').limitToLast(35000);
            }
          }
        }
        const filterByTimeBetweenTimeMs = parseInt(filterByTimeBetweenTime, 10) * (1000 * 60);

        console.log('filterByTimeBetweenTimeMs', filterByTimeBetweenTimeMs);

        // const selectFilterCloseReason = filterCloseReason
        //   ? constants.closeReason.filter(item => filterCloseReason === item.id).reduce((obj, key) => {
        //         const objCopy = { ...obj };
        //         objCopy[key] = constants.closeReason[key];
        //         return objCopy;
        //   }) : null;
        const selectFilterCloseReason = (filterCloseReason && filterCloseReason.length > 0) ? (filterCloseReason
          .map(filter => constants.closeReason.find(reason => reason.id === filter.value))
          .filter(Boolean)) : [];

        const roomsPlayedSnapshot = await FirebaseRef.child('statistics/roomsPlayed').once('value');
        const roomsPlayedLastIndexSnapshot = await FirebaseRef.child('statistics/roomsPlayedLastIndex').once('value');
        const roomsPlayed = roomsPlayedSnapshot.val() || 0;
        const roomsPlayedLastIndex = roomsPlayedLastIndexSnapshot.val() || 0;

        const totalRoomCount = roomsPlayed - roomsPlayedLastIndex;


        let data = {};

        if (filterType === constants.LASTIP && filterValue) {
          for (const lastIpQuery of queries) {
            const lastIpQuerySnapshot = await lastIpQuery.once('value');
            const lastIpQueryData = lastIpQuerySnapshot.val() || {};

            data = { ...data, ...lastIpQueryData}
          }

        } else {
          const querySnapshot = await query.once('value');
          const queryData = querySnapshot.val() || {};

          if (filterType === constants.ROOMID && filterValue) {
            data = Object.keys(queryData).length > 0 ? { [filterValue]: queryData } : {};
          } else {
            data = queryData || {};
          }
        }

        let updatedLogs = [];

        if (Object.keys(data).length > 0) {
          const promises = Object.entries(data).map(async ([key, item]) => {
            let includeItem = true;

            if (showActiveRooms && !activeRoomIds.includes(key)) {
              includeItem = false;
            }

            if ((filterType === constants.USERID || filterType === constants.LASTIP) && filterValue) {
              const roomSnapshot = await AdminLogsRef().child(`adminLogs/roomIds/${key}`).once('value');
              const roomData = roomSnapshot.val();
              item.firstRoundStart = roomData.firstRoundStart;
              item.firstRoundStartTimeTaken = roomData.firstRoundStartTimeTaken;
              item.secondUserJoined = roomData.secondUserJoined;
              item.secondUserJoinedTimeTaken = roomData.secondUserJoinedTimeTaken;
              item.triedToMove = roomData.triedToMove;
              item.isOnline = roomData.isOnline;
              item.leaveReason = roomData.leaveReason;
              item.hadPenalty = roomData.hadPenalty;

              item.privateRoom = roomData.privateRoom;

            //  console.log('filterByTimeBetweenTimeMs 222', filterByTimeBetweenTimeMs);

              if (!roomData) includeItem = false;
              if (filterBots && (!!roomData.hasBots).toString() !== filterBots) includeItem = false;
              if (filterByTimeBetween !== '' && filterByTimeBetweenTime && (!roomData[filterByTimeBetween] || roomData[filterByTimeBetween] < filterByTimeBetweenTimeMs)) includeItem = false;
              if (filterAmountOfPlayer && filterAmountOfPlayer === '2players' && !roomData.studentRoom) includeItem = false;
              if (filterAmountOfPlayer && filterAmountOfPlayer === '4players' && !roomData.fourPRoom) includeItem = false;
              if (filterAmountOfPlayer && filterAmountOfPlayer === '3players' && roomData.fourPRoom) includeItem = false;
              if (filterTournament && (!!roomData.tournamentId).toString() !== filterTournament) includeItem = false;
              if (showAutoPlayRooms && !roomData.hadAutomatedPlay) includeItem = false;
              if (showMergedRooms && !roomData.hasAutoMerge) includeItem = false;
              if (filterGameType?.includes('Private') && !roomData.privateRoom) includeItem = false;
            } else {

            //  if (!(!item[filterByTimeBetween] || item[filterByTimeBetween] < filterByTimeBetweenTimeMs)) {
            //    console.log('filterByTimeBetweenTimeMs 333', filterByTimeBetweenTimeMs, item, filterByTimeBetween);
            //  }

              if (filterBots && (!!item.hasBots).toString() !== filterBots) includeItem = false;
              if (filterByTimeBetween !== '' && filterByTimeBetweenTime && (!item[filterByTimeBetween] || item[filterByTimeBetween] < filterByTimeBetweenTimeMs)) includeItem = false;
              if (filterAmountOfPlayer && filterAmountOfPlayer === '2players' && !item.studentRoom) includeItem = false;
              if (filterAmountOfPlayer && filterAmountOfPlayer === '4players' && !item.fourPRoom) includeItem = false;
              if (filterAmountOfPlayer && filterAmountOfPlayer === '3players' && item.fourPRoom) includeItem = false;
              if (filterTournament && (!!item.tournamentId).toString() !== filterTournament) includeItem = false;
              if (showAutoPlayRooms && !item.hadAutomatedPlay) includeItem = false;
              if (showMergedRooms && !item.hasAutoMerge) includeItem = false;
              if (filterGameType?.includes('Private') && !item.privateRoom) includeItem = false;
            }

            if (includeItem) {
              // if (filterCloseReason && selectFilterCloseReason &&
              //   ((item.closeReason !== selectFilterCloseReason.id &&
              //     (item.closeReason !== selectFilterCloseReason.filterType || item.triedToMove !== selectFilterCloseReason.triedToMove || item.isOnline !== selectFilterCloseReason.isOnline)
              //   ) || !item.closeReason)
              // ) includeItem = false;

              if (filterCloseReason && Array.isArray(selectFilterCloseReason) && selectFilterCloseReason.length > 0) {
                const matchesAny = selectFilterCloseReason.some(reason => {
                  return (
                    item.closeReason === reason.id ||
                    (
                      item.closeReason === reason.filterType &&
                      item.triedToMove === reason.triedToMove &&
                      item.isOnline === reason.isOnline
                    )
                  );
                });

                if (!matchesAny || !item.closeReason) {
                  includeItem = false;
                }
              }

              if (excludeLeftBeforeStartRooms && item.closeReason === "leftBeforeStart") includeItem = false;

              if (onlyPenaltyRooms && !item.hadPenalty) includeItem = false;

              if (filterMinValue && filterMinValue.length !== 0 && !filterMinValue.includes(item.minGames.toString())) includeItem = false;
              if (filterSpeed && item.speed !== filterSpeed) includeItem = false;
              if (filterBet && filterBet.length !== 0 && !filterBet.includes(item.bet)) includeItem = false;
              if (item.date < startDate || item.date > endDate) includeItem = false;

              if (filterPlatform && filterPlatform.length !== 0) {
                if (item.envInRoom) {
                  for (const filterPlatformPart of filterPlatform) {
                    if (!item.envInRoom[filterPlatformPart]) {
                      includeItem = false;
                      break;
                    }
                  }
                } else {
                  includeItem = false;
                }
              }

              if (filterGames && (!item.party || item.party < parseInt(filterGames, 10))) includeItem = false;

              // const filterPrivate = filterGameType?.includes('Private');
              const filteredGameTypes = filterGameType?.filter(type => type !== 'Private');

              if (
                filteredGameTypes &&
                filteredGameTypes.length !== 0 &&
                !filteredGameTypes.includes(getDbRoomGameType(item))
              ) {
                includeItem = false;
              }

              if (
                winPointsFrom || winPointsTo ||
                winCoinsFrom || winCoinsTo ||
                lossPointsFrom || lossPointsTo ||
                lossCoinsFrom || lossCoinsTo
              ) {
                try {
                  const roomPointsSnapshot = await RoomsRef.child(`roomsPoints/${key}/`).once('value');
                  const pointsData = roomPointsSnapshot.val() || {};

                  if (pointsData && pointsData.points) {
                    const totals = pointsData.points.total || {};
                    const balances = pointsData.points.bal || {};

                    const totalValues = Object.values(totals);
                    const balValues = Object.values(balances);

                    if (winPointsFrom || winPointsTo) {
                      const hasValue = totalValues.some(v =>
                        (winPointsFrom ? v >= winPointsFrom : true) &&
                        (winPointsTo ? v <= winPointsTo : true)
                      );
                      if (!hasValue) includeItem = false;
                    }

                    if (winCoinsFrom || winCoinsTo) {
                      const hasValue = balValues.some(v =>
                        (winCoinsFrom ? v >= winCoinsFrom : true) &&
                        (winCoinsTo ? v <= winCoinsTo : true)
                      );
                      if (!hasValue) includeItem = false;
                    }

                    if (lossPointsFrom || lossPointsTo) {
                      const hasValue = totalValues.some(v =>
                        (lossPointsFrom ? v <= -lossPointsFrom : true) &&
                        (lossPointsTo ? v >= -lossPointsTo : true)
                      );
                      if (!hasValue) includeItem = false;
                    }

                    if (lossCoinsFrom || lossCoinsTo) {
                      const hasValue = balValues.some(v =>
                        (lossCoinsFrom ? v <= -lossCoinsFrom : true) &&
                        (lossCoinsTo ? v >= -lossCoinsTo : true)
                      );
                      if (!hasValue) includeItem = false;
                    }

                  } else {
                    includeItem = false;
                  }
                } catch (error) {
                  console.log('roomsPoints err:', error);
                  includeItem = false;
                }
              }

            }

            if (includeItem) {
              updatedLogs.push({ ...item, key });
            }
          });

          await Promise.all(promises);
        }
        updatedLogs.reverse();
        return resolve( dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: { loading: false, logs: updatedLogs, totalRoomCount } }));

      } catch (err) {
        console.log('Error:', err.message);
        resolve(dispatch({ type: 'ADMIN_FILTERED_ROOM_LOGS', data: { loading: false, logs: [], totalRoomCount: 0 } }));
      }
    });
}

export function getMissedRooms(start, end) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  if (!start || !end) return () => new Promise(resolve => resolve());

  return () => new Promise(resolve => AdminLogsRef().child('missedRoomsData')
    .orderByChild('date')
    .startAt(start)
    .endAt(end)
    .once('value', (snapshot) => {
      const roomLogs = snapshot.val() || {};

      return resolve(roomLogs);
    }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
}

export function getSuspiciousPlayers2() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => AdminLogsRef().child('roomsTogether/suspiciousPlayers')
    .once('value', (snapshot) => {
      const suspiciousPlayers = snapshot.val() || {};

      return resolve(dispatch({ type: 'SUSPICIOUS_PLAYERS', data: suspiciousPlayers }));
    }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
}

export function getSuspiciousPlayers() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => AdminLogsRef().child('roomsTogether2/players').orderByChild('count').startAt(5)
    .once('value', (snapshot) => {
      const suspiciousPlayers = snapshot.val() || {};

      return resolve(dispatch({ type: 'SUSPICIOUS_PLAYERS', data: suspiciousPlayers }));
    }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
}

export function getSuspiciousPlayersRooms(player1, player2) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => AdminLogsRef().child(`roomsTogether2/playerRooms/${player1}--${player2}`)
    .once('value', (snapshot) => {
      const rooms = snapshot.val() || {};
      console.log('rooms', rooms);

      return resolve(dispatch({ type: 'SUSPICIOUS_PLAYERS_ROOMS', data: rooms }));
    }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
}


export function getSuspiciousSameIPPlayersRooms(player1, player2) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => AdminLogsRef().child(`suspiciousSameIP/playerRooms/${player1}--${player2}`)
    .once('value', (snapshot) => {
      const rooms = snapshot.val() || {};
      console.log('rooms', rooms);

      return resolve(dispatch({ type: 'SUSPICIOUS_SAME_IP_PLAYERS_ROOMS', data: rooms }));
    }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
}


export function getFilteredTransactions(provider, purchasedItem, dateFrom, dateTo, show, UUID, devMode, source) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const startAt = new Date(dateFrom).setHours(0, 0, 0, 0);
  const endAt = new Date(dateTo).setHours(23, 59, 59, 59);
  return dispatch => new Promise((resolve) => {
    if (dateFrom != null && dateTo != null) {
      FirebaseRef.child(show)
        .orderByChild('dateInitiated')
        .startAt(startAt)
        .endAt(endAt)
        .once('value', async (snapshot) => {
        let data = snapshot.val() || {};

        let merge = { ...data };
        if (show === 'initiatedPayments') {
          const cancelledSnapshot = await FirebaseRef.child('failedPayments').orderByChild('dateInitiated').startAt(startAt).endAt(endAt).once('value');
          const cancelledPayments = cancelledSnapshot.val();
          merge = { ...merge, ...cancelledPayments };
        }

        if (UUID !== '') {
          merge = Object.keys(merge).filter(key => merge[key].userUid === UUID).reduce((obj, key) => {
            obj[key] = merge[key];
            return obj;
          }, {});
        }
        if (provider !== 'all') {
          console.log('data provider', provider, merge);

          merge = Object.keys(merge).filter(key => merge[key].provider === provider).reduce((obj, key) => {
            obj[key] = merge[key];
            return obj;
          }, {});
        }
        if (purchasedItem != null) {
          const purchasedItemArray = [];
          Object.keys(purchasedItem).map((key1) => {
            purchasedItemArray.push(purchasedItem[key1].value);
            return null;
          });
          merge = Object.keys(merge).filter(key => purchasedItemArray.includes(merge[key].productNr ? merge[key].productNr.toString() : '') === true)
            .reduce((obj, key) => {
              obj[key] = merge[key];
              return obj;
            }, {});
        }
        if (source !== undefined && source !== 'all') {
          console.log('data source', source);

          merge = Object.keys(merge).filter(key => merge[key]?.paymentInfo?.source === source).reduce((obj, key) => {
            obj[key] = merge[key];
            return obj;
          }, {});
        }

        if (devMode) {
          merge = Object.keys(merge).filter(key => merge[key].devMode === true)
            .reduce((obj, key) => {
              obj[key] = merge[key];
              return obj;
            }, {});
        } else {
          merge = Object.keys(merge).filter(key => !merge[key].devMode)
            .reduce((obj, key) => {
              obj[key] = merge[key];
              return obj;
            }, {});
        }
        console.log('data check devMode', data, merge, devMode);
        return resolve(dispatch({ type: 'ADMIN_PAYMENTS_REPLACE', data: merge }));
      });
    } else if (dateFrom != null && dateTo == null) {
      FirebaseRef.child(show)
        .orderByChild('dateInitiated')
        .startAt(startAt)
        .once('value', async (snapshot) => {
          let data = snapshot.val() || {};

          let merge = {};
          if (show === 'initiatedPayments') {
            const cancelledSnapshot = await FirebaseRef.child('failedPayments').orderByChild('dateInitiated').startAt(startAt).endAt(endAt).once('value');
            const cancelledPayments = cancelledSnapshot.val();

            merge = { ...data, ...cancelledPayments };
          }

          if (UUID !== '') {
            merge = Object.keys(merge).filter(key => merge[key].userUid === UUID).reduce((obj, key) => {
              obj[key] = merge[key];
              return obj;
            }, {});
          }
          if (provider !== 'all') {
            merge = Object.keys(merge).filter(key => merge[key].provider === provider).reduce((obj, key) => {
              obj[key] = merge[key];
              return obj;
            }, {});
          }
          if (purchasedItem != null) {
            const purchasedItemArray = [];
            Object.keys(purchasedItem).map((key1) => {
              purchasedItemArray.push(purchasedItem[key1].value);
              return null;
            });
            merge = Object.keys(merge).filter(key => purchasedItemArray.includes(merge[key].productNr ? merge[key].productNr.toString() : '') === true)
              .reduce((obj, key) => {
                obj[key] = merge[key];
                return obj;
              }, {});
          }

          if (devMode) {
            merge = Object.keys(merge).filter(key => merge[key].devMode === true)
              .reduce((obj, key) => {
                obj[key] = merge[key];
                return obj;
              }, {});
          } else {
            merge = Object.keys(merge).filter(key => !merge[key].devMode)
              .reduce((obj, key) => {
                obj[key] = merge[key];
                return obj;
              }, {});
          }
          console.log('data', merge);

          return resolve(dispatch({ type: 'ADMIN_PAYMENTS_REPLACE', data: merge }));
        });
    } else if (dateFrom == null && dateTo != null) {
      FirebaseRef.child(show)
        .orderByChild('dateInitiated')
        .endAt(endAt)
        .once('value', async (snapshot) => {
          let data = snapshot.val() || {};

          let merge = {};
          if (show === 'initiatedPayments') {
            const cancelledSnapshot = await FirebaseRef.child('failedPayments').orderByChild('dateInitiated').startAt(startAt).endAt(endAt).once('value');
            const cancelledPayments = cancelledSnapshot.val();

            merge = { ...data, ...cancelledPayments };
          }

          if (UUID !== '') {
            merge = Object.keys(merge).filter(key => merge[key].userUid === UUID).reduce((obj, key) => {
              obj[key] = merge[key];
              return obj;
            }, {});
          }
          if (provider !== 'all') {
            merge = Object.keys(merge).filter(key => merge[key].provider === provider).reduce((obj, key) => {
              obj[key] = merge[key];
              return obj;
            }, {});
          }
          if (purchasedItem != null) {
            const purchasedItemArray = [];
            Object.keys(purchasedItem).map((key1) => {
              purchasedItemArray.push(purchasedItem[key1].value);
              return null;
            });
            merge = Object.keys(merge).filter(key => purchasedItemArray.includes(merge[key].productNr ? merge[key].productNr.toString() : '') === true)
              .reduce((obj, key) => {
                obj[key] = merge[key];
                return obj;
              }, {});
          }

          if (devMode) {
            merge = Object.keys(merge).filter(key => merge[key].devMode === true)
              .reduce((obj, key) => {
                obj[key] = merge[key];
                return obj;
              }, {});
          } else {
            merge = Object.keys(merge).filter(key => !merge[key].devMode)
              .reduce((obj, key) => {
                obj[key] = merge[key];
                return obj;
              }, {});
          }
          console.log('dataaaa', merge);

          return resolve(dispatch({ type: 'ADMIN_PAYMENTS_REPLACE', data: merge }));
        });
    } else {
      FirebaseRef.child(show)
        .orderByChild('dateInitiated')
        .once('value', async (snapshot) => {
          let data = snapshot.val() || {};

          let merge = {};
          if (show === 'initiatedPayments') {
            const cancelledSnapshot = await FirebaseRef.child('failedPayments').orderByChild('dateInitiated').startAt(startAt).endAt(endAt).once('value');
            const cancelledPayments = cancelledSnapshot.val();

            merge = { ...data, ...cancelledPayments };
          }

          if (UUID !== '') {
            merge = Object.keys(merge).filter(key => merge[key].userUid === UUID).reduce((obj, key) => {
              obj[key] = merge[key];
              return obj;
            }, {});
          }
          if (provider !== 'all') {
            console.log('data', merge);
            merge = Object.keys(merge).filter(key => merge[key].provider === provider).reduce((obj, key) => {
              obj[key] = merge[key];
              return obj;
            }, {});
          }
          if (purchasedItem != null) {
            const purchasedItemArray = [];
            Object.keys(purchasedItem).map((key1) => {
              purchasedItemArray.push(purchasedItem[key1].value);
              return null;
            });
            merge = Object.keys(merge).filter(key => purchasedItemArray.includes(merge[key].productNr ? merge[key].productNr.toString() : '') === true)
              .reduce((obj, key) => {
                obj[key] = merge[key];
                return obj;
              }, {});
          }

          if (devMode) {
            merge = Object.keys(merge).filter(key => merge[key].devMode === true)
              .reduce((obj, key) => {
                obj[key] = merge[key];
                return obj;
              }, {});
          } else {
            merge = Object.keys(merge).filter(key => !merge[key].devMode)
              .reduce((obj, key) => {
                obj[key] = merge[key];
                return obj;
              }, {});
          }
          console.log('data', merge);

          return resolve(dispatch({ type: 'ADMIN_PAYMENTS_REPLACE', data: merge }));
        });
    }
  }).catch((err) => { console.log(err.message); });
}

export function getUserName(userId) {
  if (!Firebase) {
    return Promise.resolve({ status: "error", name: "" });
  }

  return new Promise((resolve, reject) => {
    FirebaseRef.child('users')
      .orderByChild('uid')
      .equalTo(userId)
      .once('value')
      .then(snapshot => {
        const userData = snapshot.val();
        if (userData) {
          const user = Object.values(userData)[0];

          resolve({ status: "success", name: user.name });
        } else {
          resolve({ status: "error", name: "" });
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}


export function getPaymentsRange(start, end) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('initiatedPayments')
    .orderByChild('index')
    .startAt(start)
    .endAt(end)
    .once('value', (snapshot) => {
      const initiatedPayments = snapshot.val() || {};

      return resolve(dispatch({ type: 'ADMIN_PAYMENTS_REPLACE', data: initiatedPayments }));
    })).catch((err) => { console.log(err.message); });
}


export function getCompletedPaymentsRange(start, end) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('completedPayments')
    .orderByChild('index')
    .startAt(start)
    .endAt(end)
    .once('value', (snapshot) => {
      const completedPayments = snapshot.val() || {};

      return resolve(dispatch({ type: 'ADMIN_PAYMENTS_REPLACE', data: completedPayments }));
    })).catch((err) => { console.log(err.message); });
}

export function getInitiatedPaymentsRange(start, end) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('incompletePayments')
    .orderByChild('index')
    .startAt(start)
    .endAt(end)
    .once('value', (snapshot) => {
      const initiatedPayments = snapshot.val() || {};

      return resolve(dispatch({ type: 'ADMIN_PAYMENTS_REPLACE', data: initiatedPayments }));
    })).catch((err) => { console.log(err.message); });
}

export function getCancelledPaymentsRange(start, end) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('failedPayments')
    .orderByChild('index')
    .startAt(start)
    .endAt(end)
    .once('value', (snapshot) => {
      const failedPayments = snapshot.val() || {};

      return resolve(dispatch({ type: 'ADMIN_PAYMENTS_REPLACE', data: failedPayments }));
    })).catch((err) => { console.log(err.message); });
}

export function getPaymentsCount() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child('initiatedPaymentsCount/count')
      .on('value', (snapshot) => {
        const paymentsCount = snapshot.val() || 0;
        dispatch({ type: 'ADMIN_PAYMENTS_COUNT', data: paymentsCount });

        FirebaseRef.child('initiatedPaymentsRemovedCount/count')
          .on('value', (snapshot2) => {
            const removedPaymentsCount = snapshot2.val() || 0;

            return resolve(dispatch({ type: 'ADMIN_REMOVED_PAYMENTS_COUNT', data: removedPaymentsCount }));
          });
      });
  }).catch((err) => { console.log(err.message); });
}


export function getCompletedPaymentsCount() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('completedPaymentsCount/count')
    .once('value', (snapshot) => {
      const paymentsCount = snapshot.val() || 0;

      return resolve(dispatch({ type: 'ADMIN_COMPLETED_PAYMENTS_COUNT', data: paymentsCount }));
    })).catch((err) => { console.log(err.message); });
}

export function getInitiatedPaymentsCount() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('incompletePaymentsCount/count')
    .once('value', (snapshot) => {
      const paymentsCount = snapshot.val() || 0;

      return resolve(dispatch({ type: 'ADMIN_INITIATED_PAYMENTS_COUNT', data: paymentsCount }));
    })).catch((err) => { console.log(err.message); });
}

export function getCancelledPaymentsCount() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('incompletePaymentsCount/count')
    .once('value', (snapshot) => {
      const paymentsCount = snapshot.val() || 0;

      return resolve(dispatch({ type: 'ADMIN_INITIATED_PAYMENTS_COUNT', data: paymentsCount }));
    })).catch((err) => { console.log(err.message); });
}

export function getAllUsers() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  console.log('getAllUsers');

  return dispatch => new Promise(resolve => FirebaseRef.child('users')
    .once('value', (snapshot) => {
      const data = snapshot.val() || {};

      return resolve(dispatch({ type: 'ADMIN_USERS_REPLACE', data }));
    })).catch((err) => { console.log(err.message); });
}

export function getDashboardData(timePeriod) {
  const deepSum = (target, source) => {
    Object.keys(source).forEach(key => {
      const sourceVal = source[key];
      const targetVal = target[key];

      if (typeof sourceVal === 'number') {
        target[key] = (targetVal || 0) + sourceVal;
      } else if (typeof sourceVal === 'object' && sourceVal !== null) {
        if (!target[key]) target[key] = {};
        deepSum(target[key], sourceVal);
      }
    });
  };

  const getKey = (date) => {
    const pad = n => String(n).padStart(2, '0');

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}-${pad(date.getHours())}`;
  };

  const getPastDateKey = (days) => {
    const now = new Date();
    const past = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
    return getKey(past);
  };

  if (Firebase === null) return () => new Promise(resolve => resolve());

  let currentStartKey;
  let previousStartKey;

  if (timePeriod === constants.DASHBOARD_TIME_PERIOD['24h']) {
    currentStartKey = getPastDateKey(1);
    previousStartKey = getPastDateKey(2);
  } else if (timePeriod === constants.DASHBOARD_TIME_PERIOD['7d']) {
    currentStartKey = getPastDateKey(7);
    previousStartKey = getPastDateKey(14);
  } else if (timePeriod === constants.DASHBOARD_TIME_PERIOD['28d']) {
    currentStartKey = getPastDateKey(28);
    previousStartKey = getPastDateKey(56);
  } else if (timePeriod === constants.DASHBOARD_TIME_PERIOD['365d']) {
    currentStartKey = getPastDateKey(365);
    previousStartKey = getPastDateKey(730);
  }

  return dispatch => new Promise(resolve => AdminLogsRef()
    .child('dashboardAggregatedData')
    .orderByKey()
    .startAt(previousStartKey)
    .once('value', (snapshot) => {
      
      const allDashboardData = snapshot.val() || {};

      const current = {};
      const previous = {};

      Object.keys(allDashboardData).forEach(key => {
        if (key >= currentStartKey) {
          deepSum(current, allDashboardData[key]);
        } else if (key >= previousStartKey && key < currentStartKey) {
          deepSum(previous, allDashboardData[key]);
        }
      });

      const data = { current, previous }

      return resolve(dispatch({ type: 'ADMIN_DASHBOARD_REPLACE', data }));
    })).catch((err) => { console.log("getDashboardData err: ", err.message); });
}


// export function getUserMessages(uid) {
//   if (Firebase === null) return () => new Promise(resolve => resolve());

//   const UID = (
//     FirebaseRef
//     && Firebase
//     && Firebase.auth()
//     && Firebase.auth().currentUser
//     && Firebase.auth().currentUser.uid
//   ) ? Firebase.auth().currentUser.uid : null;
//   if (!UID) return () => new Promise(resolve => resolve());

//   return dispatch => new Promise(resolve => FirebaseRef.child(`supportChat/messages/${uid.toString()}`)
//     .limitToLast(100)
//     .on('value', (snapshot) => {
//       const messages = snapshot.val() || {};

//       resolve(dispatch({
//         type: 'USER_CHATS',
//         data: messages,
//       }));
//     }));
// }
let messagesListener = null; // outside to hold the listener for cleanup

export function getUserMessagesLive(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const UID = (
    FirebaseRef &&
    Firebase &&
    Firebase.auth() &&
    Firebase.auth().currentUser &&
    Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => {
    const messagesRef = FirebaseRef.child(`supportChat/messages/${uid.toString()}`).limitToLast(100);
    const languageRef = FirebaseRef.child(`users/${uid.toString()}/lastLanguage`);

    messagesListener = messagesRef.on('value', snapshot => {
      const messages = snapshot.val() || {};

      languageRef.once('value').then(languageSnapshot => {
        const lastLanguage = languageSnapshot.val() || 'en';

        dispatch({
          type: 'USER_CHATS',
          data: {
            messages,
            lastLanguage,
          },
        });

        resolve();
      }).catch(err => {
        console.log('Error fetching language:', err);
        resolve();
      });
    }, error => {
      console.log('Error listening to messages:', error);
      resolve();
    });
  });
}

export function stopGetUserMessagesLive(uid) {
  return dispatch => new Promise((resolve) => {
    if (messagesListener && FirebaseRef) {
      const messagesRef = FirebaseRef
        .child(`supportChat/messages/${uid.toString()}`)
        .limitToLast(100);
      messagesRef.off('value', messagesListener);
      messagesListener = null;
    }

    resolve();
  });
}

export function editUserMessage(name, uid, msgKey, msg, oldMsg) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef &&
    Firebase &&
    Firebase.auth() &&
    Firebase.auth().currentUser &&
    Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) {
    return () => new Promise(resolve => resolve());
  }

  return () => new Promise((resolve) => {
    const messageRef = FirebaseRef.child(
      `supportChat/messages/${uid.toString()}/${msgKey.toString()}`
    );

    messageRef.update({
      message: msg,
      edited: Firebase.database.ServerValue.TIMESTAMP,
    })
      .then(async () => {
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        return AdminLogsRef()
          .child('adminLogs/adminActions')
          .push({
            type: 'editMessage',
            message: msg,
            messageOld: oldMsg,
            adminId: UID,
            adminEmail,
            adminName: confirmAdminName || adminName,
            userId: uid.toString(),
            userName: name || null,
            date: Firebase.database.ServerValue.TIMESTAMP,
          });
      })
      .then(() => resolve())
      .catch(error => {
        console.log("Error editing message:", error);
        resolve();
      });
  });
}

export function deleteUserMessage(name, uid, msgKey, msg) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef &&
    Firebase &&
    Firebase.auth() &&
    Firebase.auth().currentUser &&
    Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise((resolve) => {
    const messageRef = FirebaseRef.child(
      `supportChat/messages/${uid.toString()}/${msgKey.toString()}`
    );

    messageRef
      .remove()
      .then(async () => {
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        return AdminLogsRef()
          .child('adminLogs/adminActions')
          .push({
            type: 'deleteMessage',
            message: msg,
            adminId: UID,
            adminEmail,
            adminName: confirmAdminName || adminName,
            userId: uid.toString(),
            userName: name || null,
            date: Firebase.database.ServerValue.TIMESTAMP,
          });
      })
      .then(() => resolve())
      .catch(error => {
        console.log("Error deleting message:", error);
        resolve();
      });
  });
}

export function getUserMessages(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => {
    const messagesRef = FirebaseRef.child(`supportChat/messages/${uid.toString()}`).limitToLast(100);
    const languageRef = FirebaseRef.child(`users/${uid.toString()}/lastLanguage`);

    Promise.all([
      messagesRef.once('value'),
      languageRef.once('value')
    ]).then(([messagesSnapshot, languageSnapshot]) => {
      const messages = messagesSnapshot.val() || {};
      const lastLanguage = languageSnapshot.val() || 'en';

      resolve(dispatch({
        type: 'USER_CHATS',
        data: {
          messages,
          lastLanguage,
        },
      }));
    }).catch(error => {
      console.log("Error fetching messages or language:", error);
      resolve();
    });
  });
}

export function cancelUserMessages(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child(`supportChat/messages/${uid.toString()}`).off();
    return resolve(dispatch({
      type: 'USER_CHATS',
      data: {},
    }));
  });
}

export function setChatTyping(chatUserUid, typingUserRole) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef &&
    Firebase &&
    Firebase.auth() &&
    Firebase.auth().currentUser &&
    Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  return () => new Promise((resolve) => {
    if (typingUserRole !== 'admin' && typingUserRole !== 'user') {
      return resolve();
    }

    const updates = {
      [`supportTyping/${chatUserUid}/${typingUserRole}`]: Date.now()
    };

    if (typingUserRole === 'admin') {
      updates[`supportTyping/${chatUserUid}/adminUid`] = UID;
    }

    return FirebaseRef.update(updates).then(() => resolve());
  });
}

let typingListener = null;

export function getChatTypingLive(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef &&
    Firebase &&
    Firebase.auth() &&
    Firebase.auth().currentUser &&
    Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => {
    const typingRef = FirebaseRef.child(`supportTyping/${uid.toString()}`);

    typingListener = typingRef.on('value', snapshot => {
      let typing = snapshot.val() || {};
      dispatch({
        type: 'USER_CHATS_TYPING',
        data: {
          typing,
        },
      });
    }, error => {
      console.log('Error listening to messages:', error);
      resolve();
    });
  });
}

export function stopGetChatTypingLive(uid) {
  return dispatch => new Promise((resolve) => {
    if (typingListener && FirebaseRef) {
      const typingRef = FirebaseRef.child(`supportTyping/${uid.toString()}`);
      typingRef.off('value', typingListener);
      typingListener = null;
    }

    resolve();
  });
}

export function getActiveReadMessages() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  return dispatch => new Promise((resolve) => {
    FirebaseRef.child('supportChat/activeChats')
      .orderByChild('responded').equalTo(true).once('value', (readChatsSnapshot) => {
        const readChats = readChatsSnapshot.val() || {};

        console.log('activeChats readChats', readChats);

        FirebaseRef.child('supportChat/activeChats')
          .orderByChild('responded').equalTo(true).on('child_added', (unreadChatsSnapshot) => {
            const unreadChats = unreadChatsSnapshot.val() || {};
            const { key } = unreadChatsSnapshot;

            dispatch({
              type: 'ACTIVE_READ_MESSAGE_CHANGE',
              data: unreadChats,
              key,
            });
          });

        FirebaseRef.child('supportChat/activeChats')
          .orderByChild('responded').equalTo(true).on('child_changed', (unreadChatsSnapshot) => {
            const unreadChats = unreadChatsSnapshot.val() || {};
            const { key } = unreadChatsSnapshot;

            dispatch({
              type: 'ACTIVE_READ_MESSAGE_CHANGE',
              data: unreadChats,
              key,
            });
          });

        FirebaseRef.child('supportChat/activeChats')
          .orderByChild('responded').equalTo(true).on('child_removed', (unreadChatsSnapshot) => {
            const { key } = unreadChatsSnapshot;

            dispatch({
              type: 'ACTIVE_READ_MESSAGES_REMOVE',
              key,
            });
          });

        resolve(dispatch({
          type: 'ACTIVE_READ_MESSAGES',
          data: readChats,
        }));
      });
  });
}

export function getActiveUnreadMessages() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child('supportChat/activeChats')
      .orderByChild('responded').equalTo(false).once('value', (unreadChatsSnapshot) => {
        const unreadChats = unreadChatsSnapshot.val() || {};
        console.log('activeChats unreadChats', unreadChats);

        FirebaseRef.child('supportChat/activeChats')
          .orderByChild('responded').equalTo(false).on('child_added', (unreadChatsChangeSnapshot) => {
            const unreadChatsChange = unreadChatsChangeSnapshot.val() || {};
            const { key } = unreadChatsChangeSnapshot;

            dispatch({
              type: 'ACTIVE_UNREAD_MESSAGE_CHANGE',
              data: unreadChatsChange,
              key,
            });
          });

        FirebaseRef.child('supportChat/activeChats')
          .orderByChild('responded').equalTo(false).on('child_changed', (unreadChatsChangeSnapshot) => {
            const unreadChatsChange = unreadChatsChangeSnapshot.val() || {};
            const { key } = unreadChatsChangeSnapshot;

            dispatch({
              type: 'ACTIVE_UNREAD_MESSAGE_CHANGE',
              data: unreadChatsChange,
              key,
            });
          });

        FirebaseRef.child('supportChat/activeChats')
          .orderByChild('responded').equalTo(false).on('child_removed', (unreadChatsChangeSnapshot) => {
            const { key } = unreadChatsChangeSnapshot;

            dispatch({
              type: 'ACTIVE_UNREAD_MESSAGES_REMOVE',
              key,
            });
          });

        resolve(dispatch({
          type: 'ACTIVE_UNREAD_MESSAGES',
          data: unreadChats,
        }));
      });
  });
}

export function getActiveMessages2() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('supportChat/activeChats')
    .orderByChild('active').equalTo(true).on('value', (snapshot) => {
      const activeChats = snapshot.val() || {};

      console.log('activeChats', activeChats);

      resolve(dispatch({
        type: 'ACTIVE_MESSAGES',
        data: activeChats,
      }));
    }));
}

export function updateAvatarFileUpload(fileUpload, editUserId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = editUserId;

  if (fileUpload !== '') {
    const baseData = fileUpload.toString();

    return () => new Promise((resolve) => {
      console.log('called here@@@@@@@@@@@@@@@@@', UID, baseData.replace(/^data:image\/[a-z]+;base64,/, ''));
      const uploadTask = FirebaseStorage.ref(`/userAvatars/${UID}`).child(`${UID}-${(Date.now().toString())}`)
        .putString(baseData.replace(/^data:image\/[a-z]+;base64,/, ''), 'base64', { contentType: 'image/jpg' });

      uploadTask.on('state_changed',
        (snapshot) => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log(`Upload is ${progress}% done`);
        },
        (error) => {
          console.log(error);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log('File available at', downloadURL);
            resolve({ status: 'success', url: downloadURL });
          });
        });
    });
  }
  return () => new Promise(resolve => resolve());
}

export function supportMessageFileUpload(fileUpload) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  if (fileUpload !== '') {
    return () => new Promise((resolve) => {
      const uploadTask = FirebaseStorage.ref(`/attachFiles/${(Date.now().toString())}`)
        .put(fileUpload);

      uploadTask.on('state_changed',
        (snapshot) => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log(`Upload is ${progress}% done`);
        },
        (error) => {
          console.log(error);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log('File available at', downloadURL);
            resolve({ status: 'success', url: downloadURL });
          });
        });
    });
  }
  return () => new Promise(resolve => resolve());
}

export async function supportFileUpload(fileUpload) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return () => new Promise((resolve) => {
    if (fileUpload) {
      const uploadTask = FirebaseStorage.ref(`/attachFiles/${(Date.now().toString())}`)
        .put(fileUpload);

      uploadTask.on('state_changed',
        (snapshot) => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log(`Upload is ${progress}% done`);
        },
        (error) => {
          console.log(error);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log('File available at', downloadURL);
            return resolve({ status: 'success', url: downloadURL });
          });
        });
    } else {
      return resolve({ status: 'error' });
    }
  });
}

export function answerSupportMessage({
  uid, message, fileUploadUrl, fileName, screen, isPenaltyChecked,
}) {
  console.log('answerSupportMessage', uid, message, fileUploadUrl, fileName, isPenaltyChecked);

  let screen2 = 'dWeb'
  if (window.innerWidth <= 1280 && window.innerWidth > 832) {
    screen2 = 'tablet'
  } else if (window.innerWidth <= 832) {
    screen2 = 'mWeb'
  }

  if (!uid) return () => new Promise(resolve => resolve());

  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;
  console.log('Firebase.auth().currentUser', { currentUser: Firebase.auth().currentUser });

  let deviceInfo = screen2 || constants.DWEB_PLATFORM;
  let env = screen2 || constants.DWEB_PLATFORM;

  if (screen2.toLowerCase() === 'android' || screen2.toLowerCase() === 'ios') {
    env = constants.DWEB_PLATFORM;
  } else if (screen2.toLowerCase() === constants.TABLET_PLATFORM) {
    env = constants.DWEB_PLATFORM;
  } else {
    env = screen2;
  }

  if (screen2.toLowerCase() === 'draugiem' || screen2.toLowerCase() === 'facebook' || screen2.toLowerCase() === 'inbox') {
    deviceInfo = constants.DWEB_PLATFORM;
  }

  const isInDraugiemAppFrame = config.isInDraugiemAppFrame();
  const isInFacebookAppFrame = config.isInFacebookAppFrame();
  const isInInboxAppFrame = config.isInInboxAppFrame();

  if (isTablet) {
    deviceInfo = constants.TABLET_PLATFORM;
  } else if (isIOS) {
    deviceInfo = constants.IOS_PLATFORM.toLowerCase();
  } else if (isAndroid && !isDesktop) {
    deviceInfo = constants.ANDROID_PLATFORM;
  } else if (isInDraugiemAppFrame) {
    env = constants.DRAUGIEM_PLATFORM;
  } else if (isInFacebookAppFrame) {
    env = constants.FACEBOOK_PLATFORM;
  } else if (isInInboxAppFrame) {
    env = constants.INBOX_PLATFORM;
  }
  let additionalData = {};

  if (deviceInfo === 'android' || deviceInfo === 'ios') {
    additionalData = {
      ...additionalData,
      appVersion: osVersion || '',
      osVersion: `${osName || ''} - ${mobileModel || ''}`,
    };
  }

  // return () => new Promise(resolve => FirebaseRef.child(`users/${uid.toString()}/name`).once('value', (snapshot) => {
  //  const name = snapshot.val() || null;

  return () => new Promise(resolve => {
    const promise1 = FirebaseRef.child(`users/${uid.toString()}/name`).once('value');
    const promise2 = FirebaseRef.child(`supportChat/activeChats/${uid.toString()}`).once('value');

    return Promise.all([promise1, promise2]).then((promisesRes) => {
      let name;
      let activeChat;

      promisesRes.map((promiseRes, index) => {
        if (index === 0) {
          name = promiseRes.val() || null;
        } else if (index === 1) {
          activeChat = promiseRes.val() || {};
        }
        return null;
      });

      console.log('activeChat', activeChat, name);

      if (activeChat && activeChat.isGuestUserMessage) {
        name = activeChat.name || name || null;

        // Send the response to the users email if is a guest user messsage

        const mailGuestUserMessageFunction = Firebase.app().functions().httpsCallable('mailGuestUserMessage');

        mailGuestUserMessageFunction({
          activeChat,
          uid,
          email: activeChat.email,
          name,
          message,
          fileUploadUrl,
          fileName,
        }).then((res) => {
          if (res.data && res.data.status === constants.SERVER_STATUS_CODE.success) {
            return resolve({ status: constants.SERVER_STATUS_CODE.success });
          }
          return resolve({ status: constants.SERVER_STATUS_CODE.error });
        }).catch(err => resolve({ status: constants.SERVER_STATUS_CODE.error, message: err.code }));
      }

        FirebaseRef.child(`supportChat/messages/${uid.toString()}`).push({
          message: !message ? '' : message,
          date: Firebase.database.ServerValue.TIMESTAMP,
          fileUpload: fileUploadUrl || null,
          fileName: fileName || null,
          env,
          device: deviceInfo,
        }).then(async () => {
          FirebaseRef.child(`supportChat/activeChats/${uid.toString()}`).update({
            //  active: true,
            name: name || null,
            responded: true,
            autoRespond: false,
            lastResponse: Firebase.database.ServerValue.TIMESTAMP,
            lastAction: Firebase.database.ServerValue.TIMESTAMP,
            read: false,
          });

          if (isPenaltyChecked) {
            console.log('isPenaltyChecked', uid);
            FirebaseRef.child(`users/${uid.toString()}/bal`)
              .transaction((bal) => (bal || 0) - 300).then(async (transactionRes) => {
                if (transactionRes.committed) {
                  const newBal = transactionRes.snapshot.val();

                  console.log('isPenaltyChecked newBal', newBal);

                  UserStatsRef().child(`userBalHistory/${uid.toString()}`).push({
                    time: Date.now(),
                    type: 'profanityPenalty',
                    change: -300,
                    old: newBal + 300,
                    new: newBal,
                  });
                }
                return null;
              });
          }

          FirebaseRef.child(`supportChat/messagesCount/${uid.toString()}`).remove();
          const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
          const confirmAdminName = (await adminNamePromise)?.val() || null;

          AdminLogsRef().child('adminLogs/adminActions').push({
            type: 'sendMessage',
            message: !message ? '' : message,
            adminId: UID,
            adminEmail,
            adminName: confirmAdminName || adminName,
            userId: uid.toString(),
            userName: name || null,
            date: Firebase.database.ServerValue.TIMESTAMP,
            fileUpload: fileUploadUrl || null,
            fileName: fileName || null,
            env,
            device: deviceInfo,
          });

          resolve({ status: 'success' });
        }).catch((err) => {
          resolve({ status: 'error', mesage: err });
        });
    });
  });
}
export function answerSupportMessageMultiple({
  uids, messageEN, messageLV, messageRU, fileUploadUrl, fileName, screen, coins, grantVIP,
}) {
  let screen2 = 'dWeb'
  if (window.innerWidth <= 1280 && window.innerWidth > 832) {
    screen2 = 'tablet'
  } else if (window.innerWidth <= 832) {
    screen2 = 'mWeb'
  }

  if (!uids || uids.length === 0) return () => new Promise(resolve => resolve());

  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;
  console.log('Firebase.auth().currentUser', { currentUser: Firebase.auth().currentUser });

  let deviceInfo = screen2 || constants.DWEB_PLATFORM;
  let env = screen2 || constants.DWEB_PLATFORM;

  if (screen2.toLowerCase() === 'android' || screen2.toLowerCase() === 'ios') {
    env = constants.DWEB_PLATFORM;
  } else if (screen2.toLowerCase() === constants.TABLET_PLATFORM) {
    env = constants.DWEB_PLATFORM;
  } else {
    env = screen2;
  }

  if (screen2.toLowerCase() === 'draugiem' || screen2.toLowerCase() === 'facebook' || screen2.toLowerCase() === 'inbox') {
    deviceInfo = constants.DWEB_PLATFORM;
  }

  const isInDraugiemAppFrame = config.isInDraugiemAppFrame();
  const isInFacebookAppFrame = config.isInFacebookAppFrame();
  const isInInboxAppFrame = config.isInInboxAppFrame();

  if (isTablet) {
    deviceInfo = constants.TABLET_PLATFORM;
  } else if (isIOS) {
    deviceInfo = constants.IOS_PLATFORM.toLowerCase();
  } else if (isAndroid && !isDesktop) {
    deviceInfo = constants.ANDROID_PLATFORM;
  } else if (isInDraugiemAppFrame) {
    env = constants.DRAUGIEM_PLATFORM;
  } else if (isInFacebookAppFrame) {
    env = constants.FACEBOOK_PLATFORM;
  } else if (isInInboxAppFrame) {
    env = constants.INBOX_PLATFORM;
  }
  let additionalData = {};

  if (deviceInfo === 'android' || deviceInfo === 'ios') {
    additionalData = {
      ...additionalData,
      appVersion: osVersion || '',
      osVersion: `${osName || ''} - ${mobileModel || ''}`,
    };
  }

  return () => new Promise(resolve => {
    const promises = uids.map(uid => {
      return FirebaseRef.child(`users/${uid.toString()}`).once('value')
        .then(snapshot => {
          const userData = snapshot.val() || {};
          const name = userData?.name;
          const lastLanguage = userData?.lastLanguage || 'lv';
          const vipUntil = userData?.vipUntil;
          const adsHidden = userData?.adsHidden;

          let sendMessage = '';
          if (lastLanguage === 'lv') {
            sendMessage = messageLV;
          } else if (lastLanguage === 'en') {
            sendMessage = messageEN;
          } else {
            sendMessage = messageRU;
          }

          return FirebaseRef.child(`supportChat/messages/${uid.toString()}`).push({
            //message: !message ? '' : message,
            message: sendMessage,
            date: Firebase.database.ServerValue.TIMESTAMP,
            fileUpload: fileUploadUrl || null,
            fileName: fileName || null,
            env,
            device: deviceInfo,
          }).then(async () => {
            FirebaseRef.child(`supportChat/activeChats/${uid.toString()}`).update({
              read: false,
            });

            FirebaseRef.child(`supportChat/messagesCount/${uid.toString()}`).remove();


            // if (coins !== 0) {
            //   return addBalance(uid, coins)().then(balanceResult => {
            //     return { uid, name, status: 'success', balanceResult };
            //   });
            // }

            let balanceResult = null;
            if (coins !== 0) {
              balanceResult = await addBalance(uid, coins)();
            }

            if (grantVIP) {
              let newVipUntil;
              let newAdsHidden;

              if (!vipUntil || vipUntil < Date.now()) {
                newVipUntil = Date.now() + 30 * 24 * 60 * 60 * 1000;
              } else {
                newVipUntil = vipUntil + 30 * 24 * 60 * 60 * 1000;
              }

              if (!adsHidden || adsHidden < Date.now()) {
                newAdsHidden = Date.now() + 30 * 24 * 60 * 60 * 1000;
              } else {
                newAdsHidden = adsHidden + 30 * 24 * 60 * 60 * 1000;
              }
              // newAdsHidden = ((adsHidden || 0) < newVipUntil) ? newVipUntil : adsHidden;

              await FirebaseRef.child(`users/${uid.toString()}`).update({
                vipUntil: newVipUntil,
                adsHidden: newAdsHidden,
              });

            }

            return { uid, name, status: 'success', balanceResult };
          });
        })
        .catch(err => {
          return { uid, status: 'error', message: err };
        });
    });

    Promise.all(promises).then(async (results) => {
      const successfulLogs = results.filter(r => r.status === 'success');

      if (successfulLogs.length > 0) {

        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'sendMessageMultiple',
          //message: !message ? '' : message,
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          //uids: successfulLogs.map(r => r.uid),
          date: Firebase.database.ServerValue.TIMESTAMP,
          fileUpload: fileUploadUrl || null,
          fileName: fileName || null,
          env,
          data: {
            //message: !message ? '' : message,
            messageLV,
            messageEN,
            messageRU,
            uids: successfulLogs.map(r => r.uid).join(', '),
            grantVIP: grantVIP.toString(),
            coins,
          },
          device: deviceInfo,
        });
      }

      resolve(results);
    });
  });
}

export function grantVIP({ uids }) {
  if (!uids || uids.length === 0) return () => new Promise(resolve => resolve());

  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise(resolve => {
    const promises = uids.map(uid => {
      return FirebaseRef.child(`users/${uid.toString()}`).once('value')
        .then(async snapshot => {
          const userData = snapshot.val() || {};
          const name = userData?.name;
          const vipUntil = userData?.vipUntil;
          const adsHidden = userData?.adsHidden;



          let newVipUntil;
          let newAdsHidden;

          if (!vipUntil || vipUntil < Date.now()) {
            newVipUntil = Date.now() + 30 * 24 * 60 * 60 * 1000;
          } else {
            newVipUntil = vipUntil + 30 * 24 * 60 * 60 * 1000;
          }

          if (!adsHidden || adsHidden < Date.now()) {
            newAdsHidden = Date.now() + 30 * 24 * 60 * 60 * 1000;
          } else {
            newAdsHidden = adsHidden + 30 * 24 * 60 * 60 * 1000;
          }
          // newAdsHidden = ((adsHidden || 0) < newVipUntil) ? newVipUntil : adsHidden;

          await FirebaseRef.child(`users/${uid.toString()}`).update({
            vipUntil: newVipUntil,
            adsHidden: newAdsHidden,
          });


          return { uid, name, status: 'success' };

        })
        .catch(err => {
          return { uid, status: 'error', message: err };
        });
    });

    Promise.all(promises).then(async (results) => {
      const successfulLogs = results.filter(r => r.status === 'success');

      if (successfulLogs.length > 0) {

        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'grantVIPs',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          //uids: successfulLogs.map(r => r.uid),
          date: Firebase.database.ServerValue.TIMESTAMP,
          data: {
            // uids: successfulLogs.map(r => r.uid).join(', '),
            players: successfulLogs.map(item => `${item.name} (${item.uid})`).join(", ")
          },
        });
      }

      resolve(results);
    });
  });
}

export function setSupportMessageAsResponded({ uid }) {
  if (!uid) return () => new Promise(resolve => resolve());

  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise(resolve => FirebaseRef.child(`users/${uid.toString()}/name`).once('value', (snapshot) => {
    const name = snapshot.val() || null;

    console.log('name', { name });

    FirebaseRef.child(`supportChat/activeChats/${uid.toString()}`).update({
      responded: true,
      autoRespond: false,
    }).then(async () => {
      console.log('test2');

      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'setMessageAsRead',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        userId: uid.toString(),
        userName: name || null,
        date: Firebase.database.ServerValue.TIMESTAMP,
      });

      resolve({ status: 'success' });
    }).catch((err) => {
      console.log(err);
      resolve({ status: 'error', mesage: err });
    });
  }));
}

export function messageAll(message, filterPlayers, messageLvInput, messageEnInput, messageRuInput, languageType, coins, tournament) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef &&
    Firebase &&
    Firebase.auth() &&
    Firebase.auth().currentUser &&
    Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  const devMode = getDevMode();

  if (!UID) return () => new Promise(resolve => resolve());

  return () => new Promise((resolve) => {
    console.log(message, 'ALL', filterPlayers, 'filter', messageLvInput, 'LV', messageEnInput, 'EN', messageRuInput, 'RU', languageType, 'admin check');

    if (tournament) {
      TournamentsRef().child(`newTournamentsList/${tournament}`).once('value')
        .then(snapshot => {
          if (!snapshot.val()) {
            return resolve({ status: constants.SERVER_STATUS_CODE.error, message: 'Tournament ID not found' });
          }

          const messageAllFunction = Firebase.app().functions().httpsCallable('messageAll');

          return messageAllFunction({
            message,
            filterPlayers,
            messageLvInput,
            messageEnInput,
            messageRuInput,
            languageType,
            coins,
            tournament,
            devMode,
          }).then(res => {
            console.log('messageAllFunction', res);
            if (res.data && res.data.status === constants.SERVER_STATUS_CODE.success) {
              return resolve({ status: constants.SERVER_STATUS_CODE.success });
            }
            return resolve({ status: constants.SERVER_STATUS_CODE.error });
          }).catch((err) =>
            resolve({ status: constants.SERVER_STATUS_CODE.error, message: err.code })
          );
        })
        .catch(err => {
          resolve({ status: constants.SERVER_STATUS_CODE.error, message: err.code });
        });
    } else {
      const messageAllFunction = Firebase.app().functions().httpsCallable('messageAll');

      return messageAllFunction({
        message,
        filterPlayers,
        messageLvInput,
        messageEnInput,
        messageRuInput,
        languageType,
        coins,
        tournament,
        devMode,
      }).then(res => {
        console.log('messageAllFunction', res);
        if (res.data && res.data.status === constants.SERVER_STATUS_CODE.success) {
          return resolve({ status: constants.SERVER_STATUS_CODE.success });
        }
        return resolve({ status: constants.SERVER_STATUS_CODE.error });
      }).catch((err) =>
        resolve({ status: constants.SERVER_STATUS_CODE.error, message: err.code })
      );
    }
  });
}



export function getUsersCount() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('users_count')
    .once('value', (snapshot) => {
      const data = snapshot.val() || {};

      return resolve(dispatch({ type: 'USERS_COUNT_REPLACE', data }));
    })).catch((err) => { console.log(err.message); });
}


export function getAllVipUsers() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  console.log('users fetch getAllVipUsers');

  return dispatch => new Promise(resolve => FirebaseRef.child('users')
    .orderByChild('vip')
    .equalTo(true)
    .on('value', (snapshot) => {
      const data = snapshot.val() || {};

      return resolve(dispatch({ type: 'ADMIN_VIP_REPLACE', data }));
    })).catch((err) => { console.log(err.message); });
}


export function getAllBans() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('bans')
    .on('value', (snapshot) => {
      const data = snapshot.val() || {};

      const array = [];
      map(data, (item, key) => {
        array.push({ key, ...data[key] });
        return null;
      });
      array.sort((a, b) => b.endDate - a.endDate);

      return resolve(dispatch({ type: 'ADMIN_BANS2_REPLACE', array }));
    })).catch((err) => { console.log(err.message); });
}


export function getBansRange(start, end) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('bans')
    .orderByChild('endDate')
    .limitToLast(end)
    .on('value', (snapshot) => {
      const bans = snapshot.val() || {};
      const array = [];
      map(bans, (item, key) => {
        array.push({ key, ...bans[key] });
        return null;
      });
      array.sort((a, b) => b.endDate - a.endDate);
      return resolve(dispatch({ type: 'ADMIN_BANS_REPLACE', data: array }));
    })).catch((err) => { console.log(err.message); });
}


export function getBansCount() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('statistics/bansCount')
    .once('value', (snapshot) => {
      const data = snapshot.val() || {};

      return resolve(dispatch({ type: 'BANS_COUNT_REPLACE', data }));
    })).catch((err) => { console.log(err.message); });
}

export function getAllTransactions() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('transactions')
    .once('value', (snapshot) => {
      const data = snapshot.val() || {};

      return resolve(dispatch({ type: 'ADMIN_TRANSACTIONS_REPLACE', data }));
    })).catch((err) => { console.log(err.message); });
}

export function getAllTournaments() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => TournamentsRef().child('newTournamentsList')
    .on('value', (snapshot) => {
      const data = snapshot.val() || {};

      console.log('getAllTournaments', data);

      console.log('test data', data['-O73LC9o7SMN3ZldKvk5']);

      return resolve(dispatch({ type: 'ADMIN_TOURNAMENTS_REPLACE', data }));
    })).catch((err) => { console.log(err.message); });
}

export function getClaimedPlayers(code) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child(`claimedGiftCodes/${code}`)
    .on('value', (snapshot) => {
      const data = snapshot.val() || {};

      return resolve(dispatch({ type: 'ADMIN_CLAIMEDPLAYERS_REPLACE', data }));
    })).catch((err) => { console.log(err.message); });
}

export function getAllGiftCodes() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('giftCodes')
    .on('value', (snapshot) => {
      const data = snapshot.val() || {};
      const array = [];

      Object.keys(data).map((key) => {
        array.push({ key, ...data[key] });
        return null;
      });

      array.sort((a, b) => (a.expires - b.expires));
      return resolve(dispatch({ type: 'ADMIN_GIFTCODES_REPLACE', data: array }));
    })).catch((err) => { console.log(err.message); });
}

export function getTournamentPlayers(tournamentId, tournamentState) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    const promise1 = TournamentsRef().child(`newTournaments/${tournamentId}/players`).once('value');
    const promise2 = TournamentsRef().child(`newTournaments/${tournamentId}/playersStaticData`).once('value');

    Promise.all([promise1, promise2]).then((promisesRes) => {
      let playersData;
      let playersStaticData;

      promisesRes.map((promiseRes, index) => {
        if (index === 0) {
          playersData = promiseRes.val() || {};
        } else if (index === 1) {
          playersStaticData = promiseRes.val() || {};
        }
        return null;
      });

      const players = {};
      const playersArr = [];

      if (playersStaticData) {
        Object.keys(playersStaticData).map((key) => {
          players[key] = { ...playersData[key], ...playersStaticData[key] };
          playersArr.push({ key, ...playersData[key], ...playersStaticData[key] });
          return null;
        });
      }

      console.log(players, "dddtournamentsPlayers playersArr", playersArr);

      //closed
      if (tournamentState === 'closed') {
        playersArr.sort((a, b) => (a.finalPosition - b.finalPosition));

        playersArr.sort((a, b) => {
          const aMainPoints = a.tournamentPoints || 0;
          const bMainPoints = b.tournamentPoints || 0;

          const aTotalRoomPoints = a.totalRoomPoints || 0;
          const bTotalRoomPoints = b.totalRoomPoints || 0;

          if (bMainPoints === aMainPoints) {
            return bTotalRoomPoints - aTotalRoomPoints;
          }
          return bMainPoints - aMainPoints;
        });
      } else {
        playersArr.sort((a, b) => (a.joinTime - b.joinTime));
      }

      const leaveReasonPromises = playersArr.map((player) => {
        return TournamentsRef()
          .child(`tournamentPlayerHistory/${tournamentId}/players/${player.uid}`)
          .once('value')
          .then(snapshot => {
            const rounds = snapshot.val() || {};
            let leaveReason = null;
            Object.values(rounds).forEach(roundData => {
              if (roundData && roundData.leaveReason) {
                leaveReason = roundData.leaveReason;
              }
            });
            return { uid: player.uid, leaveReason };
          });
      });

      Promise.all(leaveReasonPromises).then((leaveReasons) => {
        const leaveReasonMap = {};
        leaveReasons.forEach(({ uid, leaveReason }) => {
          if (uid) leaveReasonMap[uid] = leaveReason;
        });

        playersArr.forEach((player, idx) => {
          playersArr[idx] = { ...player, leaveReason: leaveReasonMap[player.uid] };
        });

        Object.keys(players).forEach((key) => {
          const uid = players[key]?.uid;
          players[key] = { ...players[key], leaveReason: leaveReasonMap[uid] };
        });

        const players2 = {};
        playersArr.map((player) => {
          players2[player.key] = { ...player };
        });
        console.log('players2', players2);
        return resolve(dispatch({ type: 'TOURNAMENT_PLAYERS', data: { tournamentPlayers: players, tournamentPlayersArr: playersArr, tournamentId } }));
      });
    });
  }).catch((err) => { console.log(err.message); });
}


export function getTournamentUsers(startDate, endDate, filterType, filterValue) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    TournamentsRef().child(`newTournaments`)
      .orderByChild('params/startDate')
      .startAt(startDate)
      .endAt(endDate)
      .once('value', async (snapshot) => {
        const newTournaments = snapshot.val() || {};
        const newTournamentsKeys = Object.keys(newTournaments);

        console.log('getTournamentUsers', newTournaments);

        let tempTournaments = {};
        let tempUsers = {};
        let userPromises = [];
        let uidsToFetch = new Set();

        for (const key of newTournamentsKeys) {
          if (newTournaments[key].playersStaticData) {
            const playersStaticDataKeys = Object.keys(newTournaments[key].playersStaticData);

            tempTournaments[key] = { ...newTournaments[key].params, players: playersStaticDataKeys };

            for (const playerKey of playersStaticDataKeys) {
              const playerStaticData = newTournaments[key].playersStaticData[playerKey];

              if (filterValue !== '') {
                if (filterType === 'lowerCaseName' && !playerStaticData.name.toLowerCase().includes(filterValue.toLowerCase())) continue;
                if (filterType === 'uid' && playerStaticData.uid !== filterValue) continue;
                if (filterType === 'lastIp') {
                  uidsToFetch.add(playerStaticData.uid);
                }
              }

              if (!tempUsers[playerKey]) {
                tempUsers[playerKey] = {
                  tPlayed: 0,
                  tTotalPnts: 0,
                  tTotalBal: 0,
                };
              }

              tempUsers[playerKey].tPlayed += 1;
              tempUsers[playerKey].tTotalPnts += (playerStaticData.initalPoints && playerStaticData.endPoints)
                ? playerStaticData.endPoints - playerStaticData.initalPoints
                : 0;
              tempUsers[playerKey].tTotalBal += (playerStaticData.initialBal && playerStaticData.endBal)
                ? playerStaticData.endBal - playerStaticData.initialBal
                : 0;

              userPromises.push(
                FirebaseRef.child(`users/${playerKey}`).once('value').then(userSnapshot => {
                  const userData = userSnapshot.val() || {};

                  if (filterValue !== '') {
                    if (filterType === 'lowerCaseLastName' && !userData.lastName?.toLowerCase().includes(filterValue.toLowerCase())) {
                      delete tempUsers[playerKey];
                      return;
                    }
                    if (filterType === 'email' && userData.email?.toLowerCase() !== filterValue.toLowerCase() && userData.contactEmail?.toLowerCase() !== filterValue.toLowerCase()) {
                      delete tempUsers[playerKey];
                      return;
                    }
                  }

                  tempUsers[playerKey] = {
                    ...tempUsers[playerKey],
                    name: playerStaticData.name,
                    uid: playerStaticData.uid,
                    lvl: userData.lvl || 0,
                    bal: userData.bal || 0,
                    totalPnts: userData.totalPnts || 0,
                    gPlayed: userData.gPlayed || 0,
                    lastName: userData.lastName || null,
                    email: userData.email || null,
                  };
                }).catch(err => {
                  console.log(err.message);
                })
              );
            }
          }
        }

        let lastIpData = {};

        if (filterType === 'lastIp' && filterValue !== '') {
          if (uidsToFetch.size > 0) {
            await FirebaseRef.child('usersLastIp').once('value').then(snapshot => {
              const allIps = snapshot.val() || {};
              lastIpData = Object.fromEntries(
                Array.from(uidsToFetch).map(uid => [uid, allIps[uid] || null])
              );
            }).catch(err => {
              console.log(err.message);
            });
          }

          tempUsers = Object.fromEntries(
            Object.entries(tempUsers).filter(([playerKey, user]) => {
              const lastIp = lastIpData[user.uid];
              return lastIp === filterValue;
            })
          );

        }

        let totalUserCount = 0;

        await TournamentsRef().child('allTimeTournamentPlayersCount').once('value').then(countSnapshot => {
          totalUserCount = countSnapshot.val() || 0;
        }).catch(err => {
          console.log(err.message);
        });

        await Promise.all(userPromises);

        return resolve(dispatch({ type: 'TOURNAMENT_USERS', data: { users: tempUsers, userTournaments: tempTournaments, totalUserCount } }));
      }).catch((err) => {
        console.log(err.message);
        return resolve();
      });
  }).catch((err) => { console.log(err.message); });
}

export function getTournamentPlayerHistory(tournamentId, playerId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    TournamentsRef().child(`tournamentPlayerHistory/${tournamentId}/players/${playerId}`).once('value', (snapshot) => {
      const playerHistory = snapshot.val() || null;

      return resolve(dispatch({ type: 'TOURNAMENT_PLAYER_HISTORY', data: playerHistory }));
    }).catch((err) => {
      console.log(err);
      return resolve();
    });
  }).catch((err) => { console.log(err.message); });
}

export function getTournamentResults(tournamentId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    const promise1 = TournamentsRef().child(`newTournaments/${tournamentId}/rounds`).once('value');

    Promise.all([promise1]).then((promisesRes) => {
      let rounds;

      promisesRes.map((promiseRes, index) => {
        if (index === 0) {
          rounds = promiseRes.val() || {};
        }
        return null;
      });

      return resolve(dispatch({ type: 'TOURNAMENT_RESULTS', data: { rounds, tournamentId } }));
    });
  }).catch((err) => { console.log(err.message); });

  // return dispatch => new Promise((resolve) => {
  //   const promise1 = AdminLogsRef().child(`adminLogs/rooms/${tournamentId}`).once('value');
  //   const promise2 = RoomsRef.child(`roomsPoints/${tournamentId}/points`).once('value');

  //   return Promise.all([promise1, promise2]).then((promisesRes) => {
  //     let data;
  //     let roomsPoints;
  //     promisesRes.map((resp, index) => {
  //       if (index === 0) {
  //         data = resp.val();
  //       } else if (index === 1) {
  //         roomsPoints = resp.val();
  //       }
  //       return null;
  //     });
  //     console.log(data, roomsPoints, "tournamentsPoints")

  //     return resolve(dispatch({
  //       type: 'TOURNAMENT_RESULTS', data: { data, tournamentId }, roomsPoints
  //     }));
  //   });
  // });
}


export function forceCloseTournament(tournamentId) {
  if (Firebase === null || !tournamentId) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return () => new Promise(resolve => resolve());

  // return () => new Promise((resolve) => {

  return () => new Promise(resolve => FirebaseRef.child('events').orderByChild('descriptionTournamentId').equalTo(tournamentId).limitToLast(1).once('value', async (snapshot) => {
    const eventData = snapshot.val() || null;

    console.log('eventData', eventData);

    const eventKey = (eventData && Object.keys(eventData).length > 0) ? Object.keys(eventData)[0] : null;

    console.log('already has an event, update exisitng one', eventKey);

    if (eventKey) {
      const deleteEventFunction = Firebase.app().functions().httpsCallable('deleteEvent');

      console.log('call delete banner');

      await deleteEventFunction({
        eventId: eventKey,
      });
    }

    const forceCloseTournamentFunction = Firebase.app().functions().httpsCallable('forceCloseTournament');

    forceCloseTournamentFunction({
      tournamentId,
    }).then(async () => {
      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'forceCloseTournament',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        tournamentId,
        data: null,
        date: Firebase.database.ServerValue.TIMESTAMP,
      });

      return resolve();
    });
  }));
}


export function deleteUser(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  /*
  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;
  */

  return () => new Promise(resolve => Firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      const deleteUserFunction = Firebase.app().functions().httpsCallable('deleteUser');

      FirebaseRef.child(`users/${uid.toString()}/name`).once('value', (snapshot) => {
        const name = snapshot.val() || {};
        if (name) {
          deleteUserFunction({
            uid: uid.toString(),
          }).then((result) => {
            resolve(result);
          });
        }
      });
    }
  }));
}

export function manualyVerifyUser(uid, lang) {
  console.log('manualyVerifyUser', uid, lang);
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise((resolve) => {
    const sendVerificationEmailFunction = Firebase.app().functions().httpsCallable('sendVerificationEmail2');

    sendVerificationEmailFunction({
      uid: uid.toString(),
      lang,
    }).then(async (result) => {
      console.log('sendVerificationEmailFunction result', result);
      if (result.data.status === 'success') {
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'sendVerifiedEmail',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          uid,
          date: Firebase.database.ServerValue.TIMESTAMP,
        });
      }

      dispatch({ type: 'SEND_NON_VERIFIED_PLAYER', data: { status: 'success', uid } });
      resolve({ status: 'success' });
    });
  });
}

export function toggleLogRocket(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  if (!uid) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav id' })); }

  const adminId = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise(resolve => FirebaseRef.child(`users/${uid.toString()}`)
    .once('value', (userSnapshot) => {
      const userData = userSnapshot.val() || false;

      const newEnableLogRocket = !userData.enableLogRocket;

      const updates = {
        enableLogRocket: newEnableLogRocket,
      };

      if (newEnableLogRocket) {
        updates.enableLogRocketDate =
          Firebase.database.ServerValue.TIMESTAMP;
      }

      FirebaseRef.child(`users/${uid.toString()}`).update(updates)
        .then(async () => {
          dispatch({ type: 'CHANGE_LOGROCKET', data: { status: 'success', enabled: !userData.enableLogRocket, uid } });

          const adminNamePromise = FirebaseRef.child(`users/${adminId?.toString()}/name`).once('value');
          const confirmAdminName = (await adminNamePromise)?.val() || null;

          AdminLogsRef().child('adminLogs/adminActions').push({
            type: !userData.enableLogRocket ? 'enableLogrocket' : 'disableLogrocket',
            adminId,
            adminEmail,
            adminName: confirmAdminName || adminName,
            data: { uid },
            userId: uid,
            userName: userData.name || null,
            date: Firebase.database.ServerValue.TIMESTAMP,
          });

          return resolve({ status: 'success', enabled: !userData.enableLogRocket });
        })
        .catch(err => resolve({ status: 'error', message: err }));
    }));
}
export function toggleSmartlook(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  if (!uid) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav id' })); }

  return dispatch => new Promise(resolve => FirebaseRef.child(`users/${uid.toString()}/enableSmartlook`)
    .once('value', (userSnapshot) => {
      const enableSmartlook = userSnapshot.val() || false;

      FirebaseRef.child(`users/${uid.toString()}`).update({
        enableSmartlook: !enableSmartlook,
      })
        .then(() => {
          dispatch({ type: 'CHANGE_SMARTLOOK', data: { status: 'success', enabled: !enableSmartlook, uid } });

          return resolve({ status: 'success', enabled: !enableSmartlook });
        })
        .catch(err => resolve({ status: 'error', message: err }));
    }));
}


export function resetActiveRoom(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  if (!uid) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav id' })); }

  return () => new Promise((resolve) => {
    FirebaseRef.child(`users/${uid.toString()}`).update({
      activeRoom: null,
      joinedRooms: null,
    })
      .then(() => resolve({ status: 'success' }))
      .catch(err => resolve({ status: 'error', message: err }));
  });
}


export function blockUser(uid, endDate, reason) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const endDate2 = new Date(endDate);

  const endDateParsed = Date.parse(endDate2);

  if (!uid) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav id' })); }
  if (!reason) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav iemesla' })); }
  if (!endDateParsed || !(endDate2 instanceof Date)) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav beigu laika' })); }

  const blockUserFunction = Firebase.app().functions().httpsCallable('blockUser');

  return dispatch => new Promise(resolve => blockUserFunction({
    uid,
    endDate: endDateParsed,
    reason,
  }).then(() => {
    dispatch({ type: 'CHANGE_BLOCK', data: { status: 'success', blocked: true, uid } });

    return resolve({ status: 'success' });
  }).catch((err) => {
    console.log(err);
    return resolve({ status: 'success' });
  }));
}


export function unblockUser(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  if (!uid) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav id' })); }

  const unblockUserFunction = Firebase.app().functions().httpsCallable('unblockUser');

  return dispatch => new Promise(resolve => unblockUserFunction({
    uid,
  }).then(() => {
    dispatch({ type: 'CHANGE_BLOCK', data: { status: 'success', blocked: false, uid } });

    return resolve({ status: 'success' });
  }).catch((err) => {
    console.log(err);
    return resolve({ status: 'success' });
  }));
}


export function editUser(uid, bal, lvl, gPlayed, totalPnts, firstName, lastName, photo, updateFlag, filterValue, filterType, name, lowerCaseName, lowerCaseLastName) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!lvl && lvl !== 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav līmeņa' })); }
  if (!gPlayed && gPlayed !== 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav izspēlēto spēļu' })); }
  if (Number.isNaN(Number(lvl)) || lvl < 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Līmenim jābūt pozitīvam skaitlim' })); }
  if (Number.isNaN(Number(gPlayed)) || gPlayed < 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Izspēlētajām spēlēm jābūt pozitīvam skaitlim' })); }

  if (!firstName) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingFirstName })); }
  if (!lastName) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLastName })); }

  return () => new Promise((resolve) => {
    const promise1 = FirebaseRef.child(`users/${uid.toString()}/lvl`).once('value');
    const promise2 = FirebaseRef.child(`users/${uid.toString()}/gPlayed`).once('value');
    const promise3 = FirebaseRef.child(`users/${uid.toString()}/name`).once('value');
    const promise4 = FirebaseRef.child(`users/${uid.toString()}/photo`).once('value');

    Promise.all([promise1, promise2, promise3, promise4]).then((promiseRes) => {
      let userOldLvl;
      let userOldGPlayed;
      let oldName;
      let oldPhoto;
      promiseRes.map((res2) => {
        if (res2) {
          if (res2.key === 'lvl') {
            userOldLvl = res2.val() || null;
          } else if (res2.key === 'gPlayed') {
            userOldGPlayed = res2.val() || null;
          } else if (res2.key === 'name') {
            oldName = res2.val() || null;
          } else if (res2.key === 'photo') {
            oldPhoto = res2.val() || null;
          }
        }
        return null;
      });

      FirebaseRef.child(`users/${uid.toString()}`).update({
        lvl,
        gPlayed,
        firstName,
        lastName,
        photo: photo || null,
        name,
        lowerCaseName,
        lowerCaseLastName,
      }).then(async () => {
        console.log('reset user photo in leaderboard', photo, oldPhoto);

        LeaderboardRef.child(`leaderboard/allTime/${uid.toString()}/photo`).set(photo || null);
        LeaderboardRef.child(`leaderboard/daily/${uid.toString()}/photo`).set(photo || null);
        LeaderboardRef.child(`leaderboard/week/${uid.toString()}/photo`).set(photo || null);
        LeaderboardRef.child(`leaderboard/month/${uid.toString()}/photo`).set(photo || null);
        LeaderboardRef.child(`leaderboard/year/${uid.toString()}/photo`).set(photo || null);

        let changedLog = '';
        if (oldPhoto !== photo) {
          changedLog += 'oldPhoto: ' + (oldPhoto || null) + ', newPhoto: ' + (photo || null) + ', ';
        }
        if (oldName !== name) {
          changedLog += 'oldName: ' + (oldName || null) + ', newName: ' + (name || null) + ', ';
        }
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'editUser',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          userId: uid.toString(),
          userName: name || null,
          data: {
            changedLog,
          },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });

        resolve({ status: 'success' });
      }).catch((err) => {
        console.log(err);
        resolve({ status: 'error', message: 'Neizdevās labot' });
      });
    }).catch((err) => {
      console.log(err);
      resolve({ status: 'error', message: 'Neizdevās labot' });
    });
  });
}

export function addBalance(uid, balanceChange) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  console.log('addBalance', uid, balanceChange);

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!balanceChange && balanceChange !== 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav bilances' })); }

  return () => new Promise(resolve =>
    {
      try {
        FirebaseRef.child(`users/${uid.toString()}/name`).once('value', (snapshot) => {
          const name = snapshot.val() || null;

          FirebaseRef.child(`users/${uid.toString()}/bal`)
            .transaction(bal => (parseInt(bal, 10) || 0) + parseInt(balanceChange, 10)).then(async (transactionRes) => {
              if (transactionRes.committed) {
                const newBal = transactionRes.snapshot.val();

                UserStatsRef().child('statistics/money').update({ admin: Firebase.database.ServerValue.increment(parseInt(balanceChange, 10)) });

                if (parseInt(balanceChange, 10) < 0) {
                  UserStatsRef().child('statistics/money').update({ adminRemoved: Firebase.database.ServerValue.increment(parseInt(balanceChange, 10)) });
                } else {
                  UserStatsRef().child('statistics/money').update({ adminAdded: Firebase.database.ServerValue.increment(parseInt(balanceChange, 10)) });
                }

              //  LeaderboardRef.child(`leaderboard/allTime/${uid.toString()}/bal`).set(Firebase.database.ServerValue.increment(parseInt(-balanceChange, 10)));
                LeaderboardRef.child(`leaderboard/daily/${uid.toString()}/bal`).set(Firebase.database.ServerValue.increment(parseInt(-balanceChange, 10)));
                LeaderboardRef.child(`leaderboard/week/${uid.toString()}/bal`).set(Firebase.database.ServerValue.increment(parseInt(-balanceChange, 10)));
                LeaderboardRef.child(`leaderboard/month/${uid.toString()}/bal`).set(Firebase.database.ServerValue.increment(parseInt(-balanceChange, 10)));
                LeaderboardRef.child(`leaderboard/year/${uid.toString()}/bal`).set(Firebase.database.ServerValue.increment(parseInt(-balanceChange, 10)));

              //  LeaderboardRef.child(`leaderboardPoints/${uid.toString()}/bal`).set(Firebase.database.ServerValue.increment(parseInt(-balanceChange, 10)));
                LeaderboardRef.child(`dailyLeaderboardPoints/${uid.toString()}/bal`).set(Firebase.database.ServerValue.increment(parseInt(-balanceChange, 10)));
                LeaderboardRef.child(`weekLeaderboardPoints/${uid.toString()}/bal`).set(Firebase.database.ServerValue.increment(parseInt(-balanceChange, 10)));
                LeaderboardRef.child(`monthLeaderboardPoints/${uid.toString()}/bal`).set(Firebase.database.ServerValue.increment(parseInt(-balanceChange, 10)));
                LeaderboardRef.child(`yearLeaderboardPoints/${uid.toString()}/bal`).set(Firebase.database.ServerValue.increment(parseInt(-balanceChange, 10)));

                UserStatsRef().child(`userBalHistory/${uid.toString()}`).push({
                  time: Date.now(),
                  type: 'adminChange',
                  change: balanceChange,
                  old: newBal - parseInt(balanceChange, 10),
                  new: newBal,
                });

                console.log('test2');

                const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
                const confirmAdminName = (await adminNamePromise)?.val() || null;

                AdminLogsRef().child('adminLogs/adminActions').push({
                  type: 'addUserBalance',
                  adminId: UID,
                  adminEmail,
                  adminName: confirmAdminName || adminName,
                  userId: uid.toString(),
                  userName: name || null,
                  data: {
                    old: newBal - parseInt(balanceChange, 10),
                    new: newBal,
                  },
                  date: Firebase.database.ServerValue.TIMESTAMP,
                });
              }
              resolve({ status: 'success' });
            }).catch((err) => {
              console.log(err);
              resolve({ status: 'error', message: 'Neizdevās labot' });
            });

        })
      }  catch (err) {
        resolve({ status: 'error', message: err.message });
      }
});
}


export function addPoints(uid, totalPntsChange) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!totalPntsChange && totalPntsChange !== 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav bilances' })); }

  return () => new Promise(resolve => FirebaseRef.child(`users/${uid.toString()}/name`).once('value', (snapshot) => {
    const name = snapshot.val() || null;

    FirebaseRef.child(`users/${uid.toString()}/totalPnts`)
      .transaction(totalPnts => (parseInt(totalPnts, 10) || 0) + parseInt(totalPntsChange, 10)).then(async (transactionRes) => {
        if (transactionRes.committed) {
          const newPoints = transactionRes.snapshot.val();

          UserStatsRef().child(`userPointsHistory/${uid.toString()}`).push({
            time: Date.now(),
            type: 'adminChange',
            change: totalPntsChange,
            old: newPoints - parseInt(totalPntsChange, 10),
            new: newPoints,
          });

        //  LeaderboardRef.child(`leaderboard/allTime/${uid.toString()}/totalPnts`).set(Firebase.database.ServerValue.increment(parseInt(-totalPntsChange, 10)));
          LeaderboardRef.child(`leaderboard/daily/${uid.toString()}/totalPnts`).set(Firebase.database.ServerValue.increment(parseInt(-totalPntsChange, 10)));
          LeaderboardRef.child(`leaderboard/week/${uid.toString()}/totalPnts`).set(Firebase.database.ServerValue.increment(parseInt(-totalPntsChange, 10)));
          LeaderboardRef.child(`leaderboard/month/${uid.toString()}/totalPnts`).set(Firebase.database.ServerValue.increment(parseInt(-totalPntsChange, 10)));
          LeaderboardRef.child(`leaderboard/year/${uid.toString()}/totalPnts`).set(Firebase.database.ServerValue.increment(parseInt(-totalPntsChange, 10)));

        //  LeaderboardRef.child(`leaderboardPoints/${uid.toString()}/tP`).set(Firebase.database.ServerValue.increment(parseInt(-totalPntsChange, 10)));
          LeaderboardRef.child(`dailyLeaderboardPoints/${uid.toString()}/tP`).set(Firebase.database.ServerValue.increment(parseInt(-totalPntsChange, 10)));
          LeaderboardRef.child(`weekLeaderboardPoints/${uid.toString()}/tP`).set(Firebase.database.ServerValue.increment(parseInt(-totalPntsChange, 10)));
          LeaderboardRef.child(`monthLeaderboardPoints/${uid.toString()}/tP`).set(Firebase.database.ServerValue.increment(parseInt(-totalPntsChange, 10)));
          LeaderboardRef.child(`yearLeaderboardPoints/${uid.toString()}/tP`).set(Firebase.database.ServerValue.increment(parseInt(-totalPntsChange, 10)));

          const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
          const confirmAdminName = (await adminNamePromise)?.val() || null;

          AdminLogsRef().child('adminLogs/adminActions').push({
            type: 'addUserPoints',
            adminId: UID,
            adminEmail,
            adminName: confirmAdminName || adminName,
            userId: uid.toString(),
            userName: name || null,
            data: {
              old: newPoints - parseInt(totalPntsChange, 10),
              new: newPoints,
            },
            date: Firebase.database.ServerValue.TIMESTAMP,
          });
        }
        resolve({ status: 'success' });
      }).catch(() => {
        resolve({ status: 'error', message: 'Neizdevās labot' });
      });
  }));
}

export function addGiftCode(data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return new Promise(resolve => resolve());

  const {
    code, expires, playerLimit, value,
  } = data;

  const expiresParsed = Date.parse(expires);
  const curDateParsed = Date.parse(new Date());
  const pattern = /^[a-zA-Z0-9]*$/;

  if (!code) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingGiftCode })); }
  if (code.match(pattern) === null) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.giftCodePatternFailed })); }
  if (code.length > 10 || code.length < 4) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.giftCodeLongFailed })); }
  if (!expiresParsed) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingExpire })); }
  if (!playerLimit || playerLimit < 0) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPlayerLimit })); }
  if (!value || value < 0) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingValue })); }

  return () => new Promise((resolve) => {
    FirebaseRef.child(`giftCodes/${code.toLowerCase()}`)
      .once('value', (giftCodeSnapshot) => {
        const giftCode = giftCodeSnapshot.val() || {};
        if (!giftCode.code) {
          const createGiftCodeFunction = Firebase.app().functions().httpsCallable('createGiftCode');

          return createGiftCodeFunction({
            code: code.toLowerCase(),
            expires: expiresParsed,
            playerLimit,
            value,
          }).then(async (result) => {
            if (result.data.status) {
              const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
              const confirmAdminName = (await adminNamePromise)?.val() || null;

              AdminLogsRef().child('adminLogs/adminActions').push({
                type: 'createGiftCode',
                adminId: UID,
                adminEmail,
                adminName: confirmAdminName || adminName,
                data: {
                  code: code.toLowerCase(),
                  expires: dateFormat(expires),
                  playerLimit,
                  value,
                },
                date: Firebase.database.ServerValue.TIMESTAMP,
              });

              return resolve({ status: 'success' });
            }
            return resolve({ status: 'error', message: result.data.error });
          }).catch(err => resolve({ status: 'error', message: err.message }));
        }

        if (giftCode.code === code.toLowerCase() && giftCode.expires < curDateParsed) {
          const createGiftCodeFunction = Firebase.app().functions().httpsCallable('createGiftCode');

          return createGiftCodeFunction({
            code: code.toLowerCase(),
            expires: expiresParsed,
            playerLimit,
            value,
          }).then(async (result) => {
            if (result.data.status) {
              const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
              const confirmAdminName = (await adminNamePromise)?.val() || null;

              AdminLogsRef().child('adminLogs/adminActions').push({
                type: 'createGiftCode',
                adminId: UID,
                adminEmail,
                adminName: confirmAdminName || adminName,
                data: {
                  code: code.toLowerCase(),
                  expires: dateFormat(expires),
                  playerLimit,
                  value,
                },
                date: Firebase.database.ServerValue.TIMESTAMP,
              });

              return resolve({ status: 'success' });
            }
            return resolve({ status: 'error', message: result.data.error });
          }).catch(err => resolve({ status: 'error', message: err.message }));
        }

        return resolve({ status: 'error', message: 'codeExist' });
      }).catch(err => resolve({ status: 'error', error: err }));
  });
}

export function editGiftCode({ data, oldData }) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  const {
    code, expires, playerLimit, value,
  } = data;

  const expiresParsed = Date.parse(expires);
  const pattern = /^[a-zA-Z0-9]*$/;
  const curDateParsed = Date.parse(new Date());

  if (!code) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingGiftCode })); }
  if (code.match(pattern) === null) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.giftCodePatternFailed })); }
  if (code.length > 10 || code.length < 3) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.giftCodeLongFailed })); }
  if (!expiresParsed) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingExpire })); }
  if (!playerLimit) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPlayerLimit })); }
  if (!value) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingValue })); }

  const dataToEdit = {
    code,
    expires: dateFormat(expires),
    playerLimit,
    value,
  };
  return () => new Promise((resolve) => {
    if (code !== oldData.code) {
      FirebaseRef.child(`giftCodes/${code.toLowerCase()}`)
        .once('value', (giftCodeSnapshot) => {
          const giftCode = giftCodeSnapshot.val() || {};
          if (!giftCode.code) {
            const editGiftCodeFunction = Firebase.app().functions().httpsCallable('editGiftCode');

            return editGiftCodeFunction({
              code: code.toLowerCase(),
              expires: expiresParsed,
              playerLimit,
              value,
            }).then(async (result) => {
              const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
              const confirmAdminName = (await adminNamePromise)?.val() || null;

              if (result.data.status === 'success') {
                if (dataToEdit.code === oldData.code) {
                  const changesObj = {};

                  Object.keys(dataToEdit).map((key) => {
                    if (oldData[key] !== dataToEdit[key]) {
                      changesObj[key] = { new: dataToEdit[key], old: oldData[key] };
                    }
                    return null;
                  });
                  let changedlog = '';

                  Object.keys(changesObj).map((key, index) => {
                    changedlog += `${key} ${key === 'expires' ? dateFormat(new Date(changesObj[key].old)) : changesObj[key].old} to ${key === 'expires' ? dateFormat(new Date(changesObj[key].new)) : changesObj[key].new}`;

                    if ((index + 1) !== Object.keys(changesObj).length) {
                      changedlog += ', ';
                    }
                    return null;
                  });

                  AdminLogsRef().child('adminLogs/adminActions').push({
                    type: 'editGiftCode',
                    adminId: UID,
                    adminEmail,
                    adminName: confirmAdminName || adminName,
                    giftCodeId: code.toLowerCase(),
                    data: {
                      ...dataToEdit,
                      changedlog,
                    },
                    date: Firebase.database.ServerValue.TIMESTAMP,
                  });
                } else {
                  AdminLogsRef().child('adminLogs/adminActions').push({
                    type: 'createGiftCode',
                    adminId: UID,
                    adminEmail,
                    adminName: confirmAdminName || adminName,
                    data: {
                      code: code.toLowerCase(),
                      expires: dateFormat(expires),
                      playerLimit,
                      value,
                    },
                    date: Firebase.database.ServerValue.TIMESTAMP,
                  });
                }
                return resolve({ status: 'success' });
              }
              return resolve({ status: 'error', message: result.data.error });
            }).catch(err => resolve({ status: 'error', message: err.message }));
          }

          if (giftCode.code === code.toLowerCase() && giftCode.expires < curDateParsed) {
            const editGiftCodeFunction = Firebase.app().functions().httpsCallable('editGiftCode');

            return editGiftCodeFunction({
              code: code.toLowerCase(),
              expires: expiresParsed,
              playerLimit,
              value,
            }).then(async (result) => {
              const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
              const confirmAdminName = (await adminNamePromise)?.val() || null;

              if (result.data.status === 'success') {
                if (dataToEdit.code === oldData.code) {
                  const changesObj = {};

                  Object.keys(dataToEdit).map((key) => {
                    if (oldData[key] !== dataToEdit[key]) {
                      changesObj[key] = { new: dataToEdit[key], old: oldData[key] };
                    }
                    return null;
                  });

                  let changedlog = '';

                  Object.keys(changesObj).map((key, index) => {
                    changedlog += `${key} ${key === 'expires' ? dateFormat(new Date(changesObj[key].old)) : changesObj[key].old} to ${key === 'expires' ? dateFormat(new Date(changesObj[key].new)) : changesObj[key].new}`;

                    if ((index + 1) !== Object.keys(changesObj).length) {
                      changedlog += ', ';
                    }
                    return null;
                  });

                  AdminLogsRef().child('adminLogs/adminActions').push({
                    type: 'editGiftCode',
                    adminId: UID,
                    adminEmail,
                    adminName: confirmAdminName || adminName,
                    giftCodeId: code.toLowerCase(),
                    data: {
                      ...dataToEdit,
                      changedlog,
                    },
                    date: Firebase.database.ServerValue.TIMESTAMP,
                  });
                } else {
                  AdminLogsRef().child('adminLogs/adminActions').push({
                    type: 'createGiftCode',
                    adminId: UID,
                    adminEmail,
                    adminName: confirmAdminName || adminName,
                    data: {
                      code: code.toLowerCase(),
                      expires: dateFormat(expires),
                      playerLimit,
                      value,
                    },
                    date: Firebase.database.ServerValue.TIMESTAMP,
                  });
                }
                return resolve({ status: 'success' });
              }
              return resolve({ status: 'error', message: result.data.error });
            }).catch(err => resolve({ status: 'error', message: err.message }));
          }

          return resolve({ status: 'error', message: 'codeExist' });
        }).catch(err => resolve({ status: 'error', error: err }));
    } else {
      const editGiftCodeFunction = Firebase.app().functions().httpsCallable('editGiftCode');
      editGiftCodeFunction({
        code: code.toLowerCase(),
        expires: expiresParsed,
        playerLimit,
        value,
      }).then(async (result) => {
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        if (result.data.status === 'success') {
          if (dataToEdit.code === oldData.code) {
            const changesObj = {};
            Object.keys(dataToEdit).map((key) => {
              if (oldData[key] !== dataToEdit[key]) {
                changesObj[key] = { new: dataToEdit[key], old: oldData[key] };
              }
              return null;
            });
            let changedlog = '';
            Object.keys(changesObj).map((key, index) => {
              changedlog += `${key} ${key === 'expires' ? dateFormat(new Date(changesObj[key].old)) : changesObj[key].old} to ${key === 'expires' ? dateFormat(new Date(changesObj[key].new)) : changesObj[key].new}`;

              if ((index + 1) !== Object.keys(changesObj).length) {
                changedlog += ', ';
              }
              return null;
            });
            AdminLogsRef().child('adminLogs/adminActions').push({
              type: 'editGiftCode',
              adminId: UID,
              adminEmail,
              adminName: confirmAdminName || adminName,
              giftCodeId: code.toLowerCase(),
              data: {
                ...dataToEdit,
                changedlog,
              },
              date: Firebase.database.ServerValue.TIMESTAMP,
            });
          } else {
            AdminLogsRef().child('adminLogs/adminActions').push({
              type: 'createGiftCode',
              adminId: UID,
              adminEmail,
              adminName: confirmAdminName || adminName,
              data: {
                code: code.toLowerCase(),
                expires: expiresParsed,
                playerLimit,
                value,
              },
              date: Firebase.database.ServerValue.TIMESTAMP,
            });
          }
          return resolve({ status: 'success' });
        }
        return resolve({ status: 'error', message: result.data.error });
      }).catch(err => resolve({ status: 'error', message: err.message }));
    }
  });
}

export function deleteGiftCode(code) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;
  if (!code) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingGiftCode })); }

  return () => new Promise(resolve => Firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      const deleteGiftCodeFunction = Firebase.app().functions().httpsCallable('deleteGiftCode');

      deleteGiftCodeFunction({
        code: code.toString(),
      }).then(async (result) => {
        if (result.data.status === 'success') {
          const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
          const confirmAdminName = (await adminNamePromise)?.val() || null;

          AdminLogsRef().child('adminLogs/adminActions').push({
            type: 'deleteGiftCode',
            adminId: UID,
            adminEmail,
            adminName: confirmAdminName || adminName,
            code,
            data: null,
            date: Firebase.database.ServerValue.TIMESTAMP,
          });
          resolve({ status: 'success' });
        } else {
          resolve({ status: 'error', message: result.data.error });
        }
      })
        .catch(err => resolve({ status: 'error', message: err.message }));
    }
  }));
}

export function saveEmailTemplate(name, design, html) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  console.log('saveEmailTemplate', { name, design, html });

  return () => new Promise(resolve => {
    FirebaseRef.child('emailTemplates').push({
      name,
      design,
      html,
      date: Firebase.database.ServerValue.TIMESTAMP,
    })
      .then(async () => {
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'saveEmailTemplate',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          data: { name, design, html },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });

        return resolve({ status: constants.SERVER_STATUS_CODE.success });
      })
      .catch((err) => { console.log(err); return resolve({ status: constants.SERVER_STATUS_CODE.error }); });
  });
}


export function getTemplateData() {
  return dispatch => new Promise((resolve) => {
    console.log('getTemplateData');

    FirebaseRef.child('eTemplates/verifyEmail').once('value', (snapshot) => {
      const verifyEmail = snapshot.val() || null;

      console.log('eTemplates/verifyEmail data', { verifyEmail });

      FirebaseRef.child('eTemplates/resetPassword').once('value', (snapshot2) => {
        const resetPassword = snapshot2.val() || null;

        console.log('eTemplates/resetPassword data', { resetPassword });


        FirebaseRef.child('eTemplates/resetEmail').once('value', (snapshot3) => {
          const resetEmail = snapshot3.val() || null;

          console.log('eTemplates/resetEmail data', { resetEmail });

          dispatch({
            type: 'TEMPLATE_DATA',
            data: { verifyEmail, resetEmail, resetPassword },
          });

          return resolve({ verifyEmail, resetEmail, resetPassword });
        }, (err) => { console.log(err); return resolve(); });
      }, (err) => { console.log(err); return resolve(); });
    }, (err) => { console.log(err); return resolve(); });
  });
}


export function updateTemplateData(type, data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise(async (resolve) => {
    console.log('updateTemplateData', { type, data });

    if (type === 'verifyEmail') {
      FirebaseRef.child('eTemplates/verifyEmail').set(data);
    } else if (type === 'resetEmail') {
      FirebaseRef.child('eTemplates/resetEmail').set(data);
    } else if (type === 'resetPassword') {
      FirebaseRef.child('eTemplates/resetPassword').set(data);
    }
    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'updateTemplateData',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      data: { type, data },
      date: Firebase.database.ServerValue.TIMESTAMP,
    });

    return resolve({ status: constants.SERVER_STATUS_CODE.success });
  })
}
export function addNewEvent(data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return new Promise(resolve => resolve());

  const {
    startDate, endDate, enTitle, lvTitle, ruTitle, enDescription, lvDescription, ruDescription, imageUrl, pageToOpen, showInBanner, devMode, bannerImageType, externalLink,
  } = data;

  const startParsedDate = Date.parse(startDate);
  const endParsedDate = Date.parse(endDate);

  if (startParsedDate > endParsedDate) {
    return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.wrongEventDate }));
  }
  if (!lvTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVTitle })); }
  if (!enTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENTitle })); }
  if (!ruTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUTitle })); }
  if (!lvDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVDescription })); }
  if (!enDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENDescription })); }
  if (!ruDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUDescription })); }
  if (!imageUrl && !bannerImageType) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }

  return () => new Promise((resolve) => {
    const createEventFunction = Firebase.app().functions().httpsCallable('createEvent');

    createEventFunction({
      startDate: startParsedDate,
      endDate: endParsedDate,
      titleEN: enTitle,
      titleLV: lvTitle,
      titleRU: ruTitle,
      descriptionEN: enDescription,
      descriptionLV: lvDescription,
      descriptionRU: ruDescription,
      imageUrl,
      pageToOpen,
      showInBanner,
      devMode,
      bannerImageType,
      externalLink,
    }).then(async (result) => {
      if (result.data.status === 'success') {
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'createNewEvent',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          data: {
            startDate: dateFormat(startDate),
            endDate: dateFormat(endDate),
            titleEN: enTitle,
            titleLV: lvTitle,
            titleRU: ruTitle,
            descriptionEN: enDescription,
            descriptionLV: lvDescription,
            descriptionRU: ruDescription,
            imageUrl,
            pageToOpen,
            showInBanner,
            devMode,
            externalLink,
          },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });

        return resolve({ status: 'success' });
      }
      return resolve({ status: 'error', message: result.data.error });
    }).catch(err => resolve({ status: 'error', message: err.message }));
  });
}

export function editSelectEvent(data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return new Promise(resolve => resolve());

  const {
    selectEventId, startDate, endDate, enTitle, lvTitle, ruTitle, enDescription, lvDescription, ruDescription, imageUrl, pageToOpen, showInBanner, oldData, devMode, bannerImageType, externalLink,
  } = data;

  const startParsedDate = Date.parse(startDate);
  const endParsedDate = Date.parse(endDate);

  if (startParsedDate > endParsedDate) {
    return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.wrongEventDate }));
  }
  if (!selectEventId) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingData })); }
  if (!lvTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVTitle })); }
  if (!enTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENTitle })); }
  if (!ruTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUTitle })); }
  if (!lvDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVDescription })); }
  if (!enDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENDescription })); }
  if (!ruDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUDescription })); }
  if (!imageUrl && !bannerImageType) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }
  console.log(selectEventId, 'devmode action');
  return () => new Promise((resolve) => {
    const editEventFunction = Firebase.app().functions().httpsCallable('editEvent');

    editEventFunction({
      eventId: selectEventId.toString(),
      startDate: startParsedDate,
      endDate: endParsedDate,
      titleEN: enTitle,
      titleLV: lvTitle,
      titleRU: ruTitle,
      descriptionEN: enDescription,
      descriptionLV: lvDescription,
      descriptionRU: ruDescription,
      imageUrl,
      pageToOpen,
      showInBanner,
      devMode,
      bannerImageType,
      externalLink,
    }).then(async (result) => {
      if (result.data.status === 'success') {
        if (startParsedDate !== Date.parse(oldData.startDate) || endParsedDate !== Date.parse(oldData.endDate) || enTitle !== oldData.titleEN || enDescription !== oldData.descriptionEN || pageToOpen !== oldData.pageToOpen || showInBanner !== oldData.showInBanner || devMode !== oldData.devMode) {
          const dataToEdit = {
            startDate: dateFormat(startDate),
            endDate: dateFormat(endDate),
            titleEN: enTitle,
            titleLV: lvTitle,
            titleRU: ruTitle,
            descriptionEN: enDescription,
            descriptionLV: lvDescription,
            descriptionRU: ruDescription,
            imageUrl,
            pageToOpen,
            showInBanner,
            devMode,
            externalLink,
          };
          const changesObj = {};
          Object.keys(dataToEdit).map((key) => {
            if ((oldData[key] !== dataToEdit[key] && (key !== 'startDate' && key !== 'endDate')) || (key === 'startDate' && dateFormat(new Date(oldData[key])) !== dataToEdit[key]) || (key === 'endDate' && dateFormat(new Date(oldData[key])) !== dataToEdit[key])) {
              if (key === 'externalLink' && oldData[key] === undefined && dataToEdit[key] === false) return null;
              changesObj[key] = { new: dataToEdit[key], old: oldData[key] };
            }
            return null;
          });
          console.log(changesObj, 'check old and data to edit');

          let changedlog = '';
          Object.keys(changesObj).map((key, index) => {
            changedlog += `${key} ${key === 'startDate' || key === 'endDate' ? dateFormat(new Date(changesObj[key].old)) : changesObj[key].old} to ${key === 'startDate' || key === 'endDate' ? changesObj[key].new : changesObj[key].new}`;

            if ((index + 1) !== Object.keys(changesObj).length) {
              changedlog += ', ';
            }
            return null;
          });

          const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
          const confirmAdminName = (await adminNamePromise)?.val() || null;

          AdminLogsRef().child('adminLogs/adminActions').push({
            type: 'editSelectEvent',
            adminId: UID,
            adminEmail,
            adminName: confirmAdminName || adminName,
            eventId: selectEventId,
            data: {
              ...dataToEdit,
              changedlog,
            },
            date: Firebase.database.ServerValue.TIMESTAMP,
          });
        }

        return resolve({ status: 'success' });
      }
      return resolve({ status: 'error', message: result.data.error });
    }).catch(err => resolve({ status: 'error', message: err.message }));
  });
}

export function getAllEvents(filterType) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const filterDate = Date.parse(new Date());

  FirebaseRef.child('events').off();

  return dispatch => new Promise(resolve => FirebaseRef.child('events')
    .on('value', (snapshot) => {
      const allEvents = snapshot.val() || {};
      const array = [];
      Object.keys(allEvents).map((key) => {
        if (filterType === 'PAST') {
          if (allEvents[key].endDate < filterDate) {
            array.push({ key, ...allEvents[key] });
            // return null;
          }
        } else if (filterType === 'CURRENT') {
          if (allEvents[key].startDate <= filterDate && allEvents[key].endDate >= filterDate) {
            array.push({ key, ...allEvents[key] });
            // return null;
          }
        } else if (filterType === 'PLAN') {
          if (allEvents[key].startDate > filterDate) {
            array.push({ key, ...allEvents[key] });
            // return null;
          }
        } else {
          array.push({ key, ...allEvents[key] });
          // return null;
        }
        return null;
      });

      array.sort((a, b) => (b.endDate - a.endDate));
      return resolve(dispatch({ type: 'ADMIN_EVENTS_REPLACE', data: array }));
    })).catch((err) => { console.log(err.message); });
}

export function deleteEvent(selectEventId, titleEn) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise(resolve => Firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      const deleteEventFunction = Firebase.app().functions().httpsCallable('deleteEvent');

      deleteEventFunction({
        eventId: selectEventId.toString(),
      }).then(async (result) => {
        if (result.data.status === 'success') {
          const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
          const confirmAdminName = (await adminNamePromise)?.val() || null;

          AdminLogsRef().child('adminLogs/adminActions').push({
            type: 'deleteEvent',
            adminId: UID,
            adminEmail,
            adminName: confirmAdminName || adminName,
            eventId: selectEventId.toString(),
            data: { eventId: selectEventId.toString(), titleEn },
            date: Firebase.database.ServerValue.TIMESTAMP,
          });
          resolve({ status: 'success' });
        } else {
          resolve({ status: 'error', message: result.data.error });
        }
      })
        .catch(err => resolve({ status: 'error', message: err.message }));
    }
  }));
}

export function getAllCampaigns(filterType) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const filterDate = Date.parse(new Date());

  FirebaseRef.child('campaigns').off();

  return dispatch => new Promise(resolve => FirebaseRef.child('campaigns')
    .on('value', (snapshot) => {
      const allCampaigns = snapshot.val() || {};
      const array = [];
      Object.keys(allCampaigns).map((key) => {
        if (filterType === 'PAST') {
          if (allCampaigns[key].endDate < filterDate) {
            array.push({ key, ...allCampaigns[key], filterType: 'past' });
            // return null;
          }
        } else if (filterType === 'CURRENT') {
          if (allCampaigns[key].startDate <= filterDate && allCampaigns[key].endDate >= filterDate) {
            array.push({ key, ...allCampaigns[key], filterType: 'current' });
            // return null;
          }
        } else if (filterType === 'PLAN') {
          if (allCampaigns[key].startDate > filterDate) {
            array.push({ key, ...allCampaigns[key], filterType: 'plan' });
            // return null;
          }
        } else {
          const type = allCampaigns[key].endDate < filterDate ? 'past' : (allCampaigns[key].startDate <= filterDate && allCampaigns[key].endDate >= filterDate) ? 'current' : (allCampaigns[key].startDate > filterDate) ? 'plan' : ''
          array.push({ key, ...allCampaigns[key], filterType: type });
          // return null;
        }
        return null;
      });

      array.sort((a, b) => (b.endDate - a.endDate));
      return resolve(dispatch({ type: 'ADMIN_CAMPAIGNS_REPLACE', data: array }));
    })).catch((err) => { console.log(err.message); });
}

export function getCampaignHistory() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return (dispatch) => new Promise((resolve) => {
    FirebaseRef.child('campaignHistory')
      .once('value', (snapshot) => {
        const campaignHistory = snapshot.val() || {};

        console.log(campaignHistory, "checkCampaignHistory")
        return resolve(dispatch({ type: 'ADMIN_CAMPAIGN_HISTORY_REPLACE', data: campaignHistory }));
    })
      .catch(err => resolve({ status: 'error', message: err.message }));
  });
}

export function getCampaignShowedHistory() {
  console.log('call getCampaignShowedHistory');
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return (dispatch) => new Promise((resolve) => {
    FirebaseRef.child('campaignShowedHistory')
      .once('value', (snapshot) => {
        const campaignShowedHistory = snapshot.val() || {};

        console.log(campaignShowedHistory, "checkCampaignShowedHistory")
        return resolve(dispatch({ type: 'ADMIN_CAMPAIGN_SHOWED_HISTORY_REPLACE', data: campaignShowedHistory }));
    })
      .catch(err => resolve({ status: 'error', message: err.message }));
  });
}

export function getSingleCampaignShowedHistory(id) {
  console.log('call getSingleCampaignShowedHistory', id);
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return (dispatch) => new Promise((resolve) => {
    /* FirebaseRef.child(`campaignHistory/${id}`)
      .on('value', (snapshot) => {
        const campaignHistory = snapshot.val() || {};

        console.log(campaignHistory, "campaignHistory")
        dispatch({ type: 'ADMIN_CAMPAIGN_HISTORY_REPLACE_SINGLE', id, data: campaignHistory });
      }); */

    FirebaseRef.child(`campaignShowedHistory/${id}`)
      .once('value', (snapshot) => {
        const campaignShowedHistory = snapshot.val() || {};

        console.log(campaignShowedHistory, "checkCampaignShowedHistory")
        return resolve(dispatch({ type: 'ADMIN_CAMPAIGN_SHOWED_HISTORY_REPLACE_SINGLE', id, data: campaignShowedHistory }));
      });
  });
}

export function getSingleCampaignShowedHistory2(id) {
  console.log('call getSingleCampaignShowedHistory2', id);
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return (dispatch) => new Promise((resolve) => {
    FirebaseRef.child(`campaignHistory/${id}`)
      .once('value', (snapshot) => {
        const campaignHistory = snapshot.val() || {};

        console.log(campaignHistory, "test data campaignHistory");
        dispatch({ type: 'ADMIN_CAMPAIGN_HISTORY_SINGLE', id, data: campaignHistory });

        FirebaseRef.child(`campaignHistory/${id}`)
          .on('child_added', (snapshot) => {
            const key = snapshot.key;
            if (!campaignHistory[key]) {
              const change = snapshot.val() || {};

              console.log(change, "test data campaignHistory")
              dispatch({ type: 'ADMIN_CAMPAIGN_HISTORY_SINGLE_ADDED', id, key, data: change });
            } else {
              // console.log('ignore campaignHistory', key);
            }
          });
      });

    FirebaseRef.child(`campaignShowedHistory/${id}`)
      .once('value', (snapshot) => {
        const campaignShowedHistory = snapshot.val() || {};

        console.log(Object.keys(campaignShowedHistory).length, "test data checkCampaignShowedHistory");

        FirebaseRef.child(`campaignShowedHistory/${id}`)
          .on('child_added', (snapshot) => {
            const key = snapshot.key;
            if (!campaignShowedHistory[key]) {
              const change = snapshot.val() || {};

              console.log(change, "test data checkCampaignShowedHistory");
              dispatch({ type: 'ADMIN_CAMPAIGN_SHOWED_HISTORY_SINGLE_ADDED', key, id, data: change });
            } else {
              // console.log('ignore checkCampaignShowedHistory', key);
            }
          });

  return resolve(dispatch({ type: 'ADMIN_CAMPAIGN_SHOWED_HISTORY_SINGLE', id, data: campaignShowedHistory }));
      });




  });
}

export function closeSingleCampaignShowedHistory(id) {
  console.log('call closeSingleCampaignShowedHistory', id);
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return (dispatch) => new Promise((resolve) => {
    FirebaseRef.child(`campaignHistory/${id}`).off();
    FirebaseRef.child(`campaignShowedHistory/${id}`).off();
  });
}

export function deleteCampaign(selectCampaignId, title) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise((resolve) => {
    FirebaseRef.child(`campaigns/${selectCampaignId}`).remove().then(async () => {
      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'deleteCampaign',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        campaignId: selectCampaignId.toString(),
        data: { campaignId: selectCampaignId.toString(), title },
        date: Firebase.database.ServerValue.TIMESTAMP,
      });

      resolve({ status: 'success', message: 'success' });
    })
      .catch(err => resolve({ status: 'error', message: err.message }));
  });
}

export function editSelectCampaign(data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return new Promise(resolve => resolve());

  const {
    selectCampaignId,
    startDate,
    endDate,
    selectedLocations,
    selectedDesigns,
    selectedEnvs,
    selectedPlatforms,
    imageUrl,
    imageUrlEn,
    imageUrlRu,
    pageToOpen,
    oldData,
    adFormMeasure,
    externalBanner,
    overflowBackgroundColor,
    title,
  } = data;

  const startParsedDate = Date.parse(startDate);
  const endParsedDate = Date.parse(endDate);

  if (startParsedDate > endParsedDate) {
    return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.wrongEventDate }));
  }
  if (!selectCampaignId) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingData })); }
  if (!selectedLocations || !selectedLocations.length) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLocations })); }
  if (!selectedDesigns || !selectedDesigns.length) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.selectedDesigns })); }
  if (!selectedEnvs || !selectedEnvs.length) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.selectedEnvs })); }
  if (!selectedPlatforms || !selectedPlatforms.length) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.selectedPlatforms })); }
  if ((!externalBanner) && (!imageUrl || !imageUrlEn || !imageUrlRu)) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }
  // if (!title) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.title })); }

  return () => new Promise((resolve, reject) => {
    FirebaseRef.child(`campaigns/${selectCampaignId}`).update({
      startDate: startParsedDate,
      endDate: endParsedDate,
      selectedLocations,
      selectedPlatforms,
      selectedDesigns,
      selectedEnvs,
      imageUrl,
      imageUrlEn,
      imageUrlRu,
      externalBanner,
      overflowBackgroundColor: overflowBackgroundColor || null,
      pageToOpen,
      adFormMeasure,
      title,
    })
      .then(async () => {
        if (startParsedDate !== Date.parse(oldData.startDate) || endParsedDate !== Date.parse(oldData.endDate) || !isEqual(selectedLocations, oldData.selectedLocations) || !isEqual(selectedDesigns, oldData.selectedDesigns) || !isEqual(selectedPlatforms, oldData.selectedPlatforms) || !isEqual(selectedEnvs, oldData.selectedEnvs) || pageToOpen !== oldData.pageToOpen || adFormMeasure !== oldData.adFormMeasure) {
          const dataToEdit = {
            startDate: dateFormat(startDate),
            endDate: dateFormat(endDate),
            selectedDesigns,
            selectedLocations,
            selectedPlatforms,
            selectedEnvs,
            imageUrl,
            imageUrlEn,
            imageUrlRu,
            externalBanner,
            overflowBackgroundColor: overflowBackgroundColor || null,
            title: title || null,
            pageToOpen,
            adFormMeasure,
          };
          const changesObj = {};
          Object.keys(dataToEdit).forEach((key) => {
            const newValue = dataToEdit[key];
            let oldValue = oldData[key];

            if ((key === 'startDate' || key === 'endDate') && oldData[key] !== undefined && oldData[key] !== null) {
              oldValue = dateFormat(new Date(oldData[key]));
            }

            if (isEmptyEquivalent(oldValue) && isEmptyEquivalent(newValue)) {
              return;
            }

            if (!isEqual(oldValue, newValue)) {
              changesObj[key] = { new: newValue, old: oldValue };
            }
          });

          // let changedlog = '';
          // Object.keys(changesObj).map((key, index) => {
          //   changedlog += `${key} ${changesObj[key].old} to ${changesObj[key].new}`;

          //   if ((index + 1) !== Object.keys(changesObj).length) {
          //     changedlog += ', ';
          //   }
          //   return null;
          // });
          const changedlog = Object.keys(changesObj).map((key) => {
            const { old, new: newValue } = changesObj[key];
            return `${key}: ${formatLogValue(old)} to ${formatLogValue(newValue)}`;
          }).join(', ');

          const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
          const confirmAdminName = (await adminNamePromise)?.val() || null;

          AdminLogsRef().child('adminLogs/adminActions').push({
            type: 'editSelectCampaign',
            adminId: UID,
            adminEmail,
            adminName: confirmAdminName || adminName,
            campaignId: selectCampaignId,
            data: {
              ...dataToEdit,
              changedlog,
            },
            date: Firebase.database.ServerValue.TIMESTAMP,
            userName: title,
          });
        }
        return resolve({ status: constants.SERVER_STATUS_CODE.success, message: constants.SERVER_STATUS_CODE.error });
      })
      .catch(() => reject({ status: constants.SERVER_STATUS_CODE.error, message: constants.SERVER_STATUS_CODE.error }));
  });
}

export function addNewCampaign(data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  console.log('addNewCampaign', data);

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return new Promise(resolve => resolve());

  const {
    startDate, endDate, selectedLocations, selectedPlatforms, selectedDesigns, selectedEnvs, imageUrl, imageUrlEn, imageUrlRu, pageToOpen, adFormMeasure, externalBanner, overflowBackgroundColor, title,
  } = data;

  const startParsedDate = Date.parse(startDate);
  const endParsedDate = Date.parse(endDate);

  if (startParsedDate > endParsedDate) {
    return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.wrongEventDate }));
  }

  if (!selectedLocations || !selectedLocations.length) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLocations })); }
  if (!selectedPlatforms || !selectedPlatforms.length) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPlatforms })); }
  if (!selectedDesigns || !selectedDesigns.length) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingDesigns })); }
  if (!selectedEnvs || !selectedEnvs.length) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingEnvs })); }

  console.log('addNewCampaign test 1');

  if (!externalBanner) {
    if (!imageUrl) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }
    if (!imageUrlEn) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }
    if (!imageUrlRu) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }
    return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto }));
  }

  console.log('addNewCampaign test 2');

  return () => new Promise((resolve, reject) => {
    // return resolve({ status: constants.SERVER_STATUS_CODE.success, message: constants.SERVER_STATUS_CODE.success });

    FirebaseRef.child('campaigns').push({
      startDate: startParsedDate,
      endDate: endParsedDate,
      selectedLocations,
      selectedPlatforms,
      selectedDesigns,
      selectedEnvs,
      imageUrl,
      imageUrlEn,
      imageUrlRu,
      externalBanner,
      overflowBackgroundColor: overflowBackgroundColor || null,
      pageToOpen,
      adFormMeasure,
      title: title || null,
    })
      .then(async () => {
        let changedlog = '';
        Object.keys(data).map((key, index) => {
          changedlog += `${key}: `;
          if (isArray(data[key])) {
            data[key].map((item, idx) => {
              if (item.value) {
                changedlog += `${item.value}`;
              }
              if (idx !== data[key].length) {
                changedlog += ', ';
              }
            })
          } else {
            changedlog += `${data[key]}`;
          }
          if ((index + 1) !== Object.keys(data).length) {
            changedlog += ', ';
          }
          return null;
        });

        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'addNewCampaign',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          data: { ...data, changedlog },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });
        return resolve({ status: constants.SERVER_STATUS_CODE.success, message: constants.SERVER_STATUS_CODE.success });
      })
      .catch(() => reject({ status: constants.SERVER_STATUS_CODE.error, message: constants.SERVER_STATUS_CODE.error }));
  });
}

export function addShopDiscount(data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return new Promise(resolve => resolve());

  const {
    startDate, endDate, enTitle, lvTitle, ruTitle, enDescription, lvDescription, ruDescription, imageUrl, type, value, showInBanner, devMode, specialPrice, discountPrice, selectedDiscountPackage,
  } = data;

  const startParsedDate = Date.parse(startDate);
  const endParsedDate = Date.parse(endDate);

  if (startParsedDate > endParsedDate) {
    return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.wrongEventDate }));
  }
  if (!lvTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVTitle })); }
  if (!enTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENTitle })); }
  if (!ruTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUTitle })); }
  if (!lvDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVDescription })); }
  if (!enDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENDescription })); }
  if (!ruDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUDescription })); }
  if (!imageUrl) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }
  if (type === constants.SPECIALPRICE) {
    map(constants.SHOP_PRODUCT_TYPES, (item) => {
      if (specialPrice[item.label] || type === constants.BONUS) {
        return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingValue }));
      }
      return null;
    });
  }
  if ((type === constants.DISCOUNTPRICE) && (!discountPrice && discountPrice !== 0)) {
    return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingValue }));
  }

  return () => new Promise((resolve) => {
    const createDiscountFunction = Firebase.app().functions().httpsCallable('createDiscount');

    createDiscountFunction({
      startDate: startParsedDate,
      endDate: endParsedDate,
      titleEN: enTitle,
      titleLV: lvTitle,
      titleRU: ruTitle,
      descriptionEN: enDescription,
      descriptionLV: lvDescription,
      descriptionRU: ruDescription,
      imageUrl,
      type,
      value: 10,
      showInBanner,
      devMode,
      specialPrice,
      discountPrice,
      selectedDiscountPackage,
    }).then(async (result) => {
      if (result.data.status === 'success') {
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'createDiscount',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          data: {
            startDate: dateFormat(startDate),
            endDate: dateFormat(endDate),
            titleEN: enTitle,
            titleLV: lvTitle,
            titleRU: ruTitle,
            descriptionEN: enDescription,
            descriptionLV: lvDescription,
            descriptionRU: ruDescription,
            imageUrl,
            type,
            value,
            showInBanner,
            devMode,
            specialPrice,
            discountPrice,
            selectedDiscountPackage: selectedDiscountPackage || [],
          },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });

        return resolve({ status: 'success' });
      } else {
        return resolve({ status: 'error', message: result.data.error });
      }
    }).catch((err) => {
      resolve({ status: 'error', message: err.message });
    });
  });
}
export function editShopDiscount(data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return new Promise(resolve => resolve());

  const {
    selectEventId, startDate, endDate, enTitle, lvTitle, ruTitle, enDescription, lvDescription, ruDescription, imageUrl, type, value, showInBanner, oldData, devMode, discountPrice, specialPrice, selectedDiscountPackage,
  } = data;

  const startParsedDate = Date.parse(startDate);
  const endParsedDate = Date.parse(endDate);

  if (startParsedDate > endParsedDate) {
    return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.wrongEventDate }));
  }
  if (!selectEventId) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingData })); }
  if (!lvTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVTitle })); }
  if (!enTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENTitle })); }
  if (!ruTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUTitle })); }
  if (!lvDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVDescription })); }
  if (!enDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENDescription })); }
  if (!ruDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUDescription })); }
  if (!imageUrl) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }

  if (type === constants.SPECIALPRICE || type === constants.BONUS) {
    map(constants.SHOP_PRODUCT_TYPES, (item) => {
      if (specialPrice[item.label]) {
        return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingValue }));
      }
      return null;
    });
  }
  if ((type === constants.DISCOUNTPRICE) && (!discountPrice && discountPrice !== 0)) {
    return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingValue }));
  }

  return () => new Promise((resolve) => {
    const editEventFunction = Firebase.app().functions().httpsCallable('editDiscount');

    editEventFunction({
      discountId: selectEventId.toString(),
      startDate: startParsedDate,
      endDate: endParsedDate,
      titleEN: enTitle,
      titleLV: lvTitle,
      titleRU: ruTitle,
      descriptionEN: enDescription,
      descriptionLV: lvDescription,
      descriptionRU: ruDescription,
      imageUrl,
      type,
      value: 10,
      showInBanner,
      devMode,
      specialPrice,
      discountPrice,
      selectedDiscountPackage,
    }).then(async (result) => {
      if (result.data.status === 'success') {
        if (startParsedDate !== Date.parse(oldData.startDate) || endParsedDate !== Date.parse(oldData.endDate) || enTitle !== oldData.titleEN || enDescription !== oldData.descriptionEN || type !== oldData.type || value !== oldData.value || showInBanner !== oldData.showInBanner || devMode !== oldData.devMode) {
          const dataToEdit = {
            startDate: dateFormat(startDate),
            endDate: dateFormat(endDate),
            titleEN: enTitle,
            titleLV: lvTitle,
            titleRU: ruTitle,
            descriptionEN: enDescription,
            descriptionLV: lvDescription,
            descriptionRU: ruDescription,
            imageUrl,
            type,
            value,
            showInBanner,
            devMode,
            specialPrice: (type === constants.SPECIALPRICE || type === constants.BONUS) ? specialPrice : null,
            discountPrice,
            selectedDiscountPackage: selectedDiscountPackage || [],
          };
          const changesObj = {};
          Object.keys(dataToEdit).map((key) => {
            if (oldData[key] !== dataToEdit[key]) {
              changesObj[key] = { new: dataToEdit[key], old: oldData[key] };
            }
            return null;
          });

          let changedlog = '';
          Object.keys(changesObj).map((key, index) => {
            changedlog += `${key} ${changesObj[key].old} to ${changesObj[key].new}`;

            if ((index + 1) !== Object.keys(changesObj).length) {
              changedlog += ', ';
            }
            return null;
          });

          const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
          const confirmAdminName = (await adminNamePromise)?.val() || null;

          AdminLogsRef().child('adminLogs/adminActions').push({
            type: 'editDiscount',
            adminId: UID,
            adminEmail,
            adminName: confirmAdminName || adminName,
            eventId: selectEventId,
            data: {
              ...dataToEdit,
              changedlog,
            },
            date: Firebase.database.ServerValue.TIMESTAMP,
          });
        }
        return resolve({ status: 'success' });
      }
      return resolve({ status: 'error', message: result.data.error });
    }).catch(err => resolve({ status: 'error', message: err.message }));
  });
}

export function getAllShopDiscounts(filterType) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const filterDate = Date.parse(new Date());

  FirebaseRef.child('discounts').off();

  return dispatch => new Promise(resolve => FirebaseRef.child('discounts')
    .on('value', (snapshot) => {
      const allShopDiscount = snapshot.val() || {};
      const array = [];
      Object.keys(allShopDiscount).map((key) => {
        if (filterType === 'PAST') {
          if (allShopDiscount[key].endDate < filterDate) {
            array.push({ key, ...allShopDiscount[key] });
            // return null;
          }
        } else if (filterType === 'CURRENT') {
          if (allShopDiscount[key].startDate <= filterDate && allShopDiscount[key].endDate >= filterDate) {
            array.push({ key, ...allShopDiscount[key] });
            // return null;
          }
        } else if (filterType === 'PLAN') {
          if (allShopDiscount[key].startDate > filterDate) {
            array.push({ key, ...allShopDiscount[key] });
            // return null;
          }
        } else {
          array.push({ key, ...allShopDiscount[key] });
          // return null;
        }
        return null;
      });

      array.sort((a, b) => (b.endDate - a.endDate));
      return resolve(dispatch({ type: 'ADMIN_DISCOUNTS_REPLACE', data: array }));
    })).catch((err) => { console.log(err.message); });
}

export function deleteShopDiscount(selectEventId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise(resolve => Firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      const deleteEventFunction = Firebase.app().functions().httpsCallable('deleteDiscount');

      deleteEventFunction({
        discountId: selectEventId.toString(),
      }).then(async (result) => {
        if (result.data.status === 'success') {
          const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
          const confirmAdminName = (await adminNamePromise)?.val() || null;

          AdminLogsRef().child('adminLogs/adminActions').push({
            type: 'deleteDiscount',
            adminId: UID,
            adminEmail,
            adminName: confirmAdminName || adminName,
            discountId: selectEventId,
            data: null,
            date: Firebase.database.ServerValue.TIMESTAMP,
          });
          resolve({ status: 'success' });
        } else {
          resolve({ status: 'error', message: result.data.error });
        }
      })
        .catch(err => resolve({ status: 'error', message: err.message }));
    }
  }));
}

export function editBan(uid, endDate, reason) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  const endDate2 = new Date(endDate);

  const endDateParsed = Date.parse(endDate2);

  if (!uid) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav id' })); }
  if (!reason) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav iemesla' })); }
  if (!endDateParsed || !(endDate2 instanceof Date)) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Nav beigu laika' })); }

  let blocked = false;
  if (endDate > Date.now()) {
    blocked = true;
  }

  return () => new Promise(resolve => FirebaseRef.child(`bans/${uid.toString()}`).update({
    endDate: endDateParsed,
    reason,
    blocked,
  }).then(async () => {
    FirebaseRef.child(`users/${uid}`).update({
      banEndDate: endDateParsed,
      banReason: reason,
      blocked,
    });

    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'editBan',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      userId: uid.toString(),
      data: {
        endDate: endDateParsed,
        reason,
        blocked,
      },
      date: Firebase.database.ServerValue.TIMESTAMP,
    });

    resolve({ status: 'success' });
  }).catch((err) => {
    resolve({ status: 'error', message: err });
  }));
}

const isdigit = (value) => {
  const val = !!Number(value);
  return val;
};

function normalizeToMinute(timestamp) {
  const date = new Date(timestamp);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date.getTime();
}

export function addTournament(data) {
  console.log('addTournament', data);
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return new Promise(resolve => resolve({ status: 'error', message: 'Nav UID' }));
  const {
    name,
    titleLV,
    titleEN,
    titleRU,
    entryFee,
    bonus,
    startDate,
    registerTime,
    winnerPercent,
    parasta,
    G,
    atra,
    veryFast,
    lightning,
    unlimited,
    pro,
    maxPlayers,
    maza,
    rounds,
    roundLength,
    newRoundPause,
    bet,
    privateTournament,
    devTournament,
    password,
    sponsorImageUrl,
    prizeImageUrl,
    playerPerRoomLimit,
    bannerPrizeChecked,
    bannerPrizeImageUrl,
    bannerShowChecked,
    bannerStartDate,
    bannerEndDate,
    specialPrizeLV,
    specialPrizeEN,
    specialPrizeRU,
    repetitiveTournament,
    multiDates,
    tournamentType,
    restrictions,
    levelFrom,
    levelTo,
    pointsFrom,
    pointsTo,
    balanceFrom,
    balanceTo,
    playedGamesFrom,
    playedGamesTo,
  } = data;
  const startDateParsed = Date.parse(startDate);

  if (privateTournament && (!password || (typeof password !== 'string') || (password && password.length !== 4) || (!isdigit(password)))) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Wrong password' })); }

  if (!titleLV || !titleEN || !titleRU) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Missing title' })); }
  if (!entryFee) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Missing entry fee' })); }
  if (!rounds) { return () => new Promise(resolve => resolve({ status: 'error', message: 'No starting tokens' })); }
  if (!roundLength) { return () => new Promise(resolve => resolve({ status: 'error', message: 'No round length' })); }
  if (registerTime < 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Start date cant be same as or before register date' })); }

  const regTime = startDateParsed - (1000 * 60 * registerTime);
  const bannerTime = Date.parse(bannerStartDate);

  const regTimeNormalized = normalizeToMinute(regTime);
  const bannerTimeNormalized = normalizeToMinute(bannerTime);
  const nowTimeNormalized = normalizeToMinute(Date.now());

  if (bannerShowChecked && regTimeNormalized >= nowTimeNormalized && bannerTimeNormalized >= nowTimeNormalized) {
    if (regTimeNormalized > bannerTimeNormalized) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Banner start time cant be before registration' })); }
  }

  //if (bannerShowChecked && startDateParsed - (1000 * 60 * registerTime) >= Date.parse(bannerStartDate)) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Banner start time cant be before registration' })); }

  if (!winnerPercent) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Missing winning percent' })); }
  if (!maxPlayers) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Missing maximum players' })); }
  if (restrictions && (parseInt(levelFrom) > parseInt(levelTo) || parseInt(pointsFrom) > parseInt(pointsTo) || parseInt(balanceFrom) > parseInt(balanceTo) || parseInt(playedGamesFrom) > parseInt(playedGamesTo))) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Wrong values' })); }

  if (Number.isNaN(Number(entryFee)) || parseInt(entryFee, 10) <= 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Entry fee has to be positive number' })); }
  if (Number.isNaN(Number(rounds)) || parseInt(rounds, 10) <= 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Rounds per tournament has to be positive number' })); }
  if (Number.isNaN(Number(roundLength)) || parseInt(roundLength, 10) < 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Round length has to be positive number' })); }
  if (!startDateParsed || !(startDate instanceof Date)) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Missing date' })); }
  if (Number.isNaN(Number(winnerPercent)) || parseInt(winnerPercent, 10) <= 0 || parseInt(winnerPercent, 10) > 100) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Winning percent has to be positive number' })); }

  let gameType = 'P';
  if (parasta) {
    gameType = 'P';
  } else if (G) {
    gameType = 'G';
  }

  let newState;

  if (!repetitiveTournament) {
    if (startDateParsed && registerTime) {
      if (startDateParsed - (1000 * 60 * registerTime) > Date.now()) {
        newState = 'pending';
      } else if (startDateParsed - (1000 * 60 * registerTime) < Date.now() && startDateParsed > Date.now()) {
        newState = 'registration';
      } else {
        return () => new Promise(resolve => resolve({ status: 'error', message: 'Start time cannot be in the past' }));
      }
    } else {
      return () => new Promise(resolve => resolve({ status: 'error', message: 'Start time / register time error' }));
    }
  }

  newState = 'pending';

  /*
  let roundLengthTime = 20;

  if (roundLength > 24) {
    roundLengthTime = 60;
  } else if (roundLength > 12) {
    roundLengthTime = 40;
  } */

  let speed = 'normal';

  if (atra) {
    speed = 'atra';
  } else if (lightning) {
    speed = 'lightning';
  } else if (veryFast) {
    speed = 'veryFast'
  }

  let roundLengthTime = constants.CALC_TOURNAMENT_ROUND_LENGTH(roundLength, speed);

  const maxLengthTime = (roundLengthTime * rounds) + ((newRoundPause || 0) * (rounds - 1));
  const maxLengthTimeRounded = Math.ceil(maxLengthTime / 10) * 10;

  console.log('maxLengthTimeRounded', maxLengthTimeRounded, maxLengthTime);

  const bannerStartDateParsed = Date.parse(bannerStartDate);
  const bannerEndDateParsed = Date.parse(bannerEndDate);

  const tournamentData = {
    params: {
      name: titleLV,
      titleEN: titleEN,
      titleLV: titleLV,
      titleRU: titleRU,
      bet: bet || '1:10',
      currentState: newState,
      currentRound: 1,
      entryFee: parseInt(entryFee, 10),
      bonus: parseInt(bonus, 10) || 0,
      rounds: parseInt(rounds, 10),
      roundLength: parseInt(roundLength, 10),
      roundLengthTime: roundLengthTime || null,
      startDate: startDateParsed,
      registerTime,
      winnerPercent,
      maxPlayers,
      maxLengthTime: maxLengthTimeRounded || null,
      gameType,
      fastGame: atra || null,
      veryFastGame: veryFast || null,
      lightningGame: lightning || null,
      unlimitedGame: unlimited || null,
      smallGame: maza,
      proGame: pro,
      newRoundPause,
      totalBank: 0,
      open: true,
      privateTournament: privateTournament || null,
      devTournament: devTournament || null,
      password: password || null,
      sponsorImg: sponsorImageUrl,
      prizeImg: prizeImageUrl,
      playerPerRoomLimit: playerPerRoomLimit ? (playerPerRoomLimit === 'none' ? null : playerPerRoomLimit) : null,
      bannerPrizeImageUrl: bannerPrizeImageUrl || null,
      bannerPrizeChecked: bannerPrizeChecked || null,
      bannerShowChecked: bannerShowChecked || null,
      bannerStartDate: bannerStartDateParsed || null,
      bannerEndDate: bannerEndDateParsed || null,
      specialPrizeLV: bannerPrizeChecked ? (specialPrizeLV || null) : null,
      specialPrizeEN: bannerPrizeChecked ? (specialPrizeEN || null) : null,
      specialPrizeRU: bannerPrizeChecked ? (specialPrizeRU || null) : null,
      tournamentType,
      restrictions,
      levelFrom,
      levelTo,
      pointsFrom,
      pointsTo,
      balanceFrom,
      balanceTo,
      playedGamesFrom,
      playedGamesTo,
    }
  };

  const eventData = {
    startDate: bannerStartDateParsed,
    endDate: bannerEndDateParsed,
    tournamentStartDate: startDateParsed,
    name: titleLV,
    titleEN: titleEN,
    titleLV: titleLV,
    titleRU: titleRU,
    descriptionEN: titleEN,
    descriptionLV: titleLV,
    descriptionRU: titleRU,
    // descriptionTournamentId: key,
    bannerPrizeChecked,
    imageUrl: (bannerPrizeChecked && bannerPrizeImageUrl) ? bannerPrizeImageUrl : null,
    pageToOpen: 'plannedTournaments',
    showInBanner: bannerShowChecked,
    devMode: devTournament,
    bannerImageType: null,
    externalLink: null,
    specialPrizeLV: bannerPrizeChecked ? (specialPrizeLV || null) : null,
    specialPrizeEN: bannerPrizeChecked ? (specialPrizeEN || null) : null,
    specialPrizeRU: bannerPrizeChecked ? (specialPrizeRU || null) : null,
    tournamentType,
    restrictions,
    levelFrom,
    levelTo,
    pointsFrom,
    pointsTo,
    balanceFrom,
    balanceTo,
    playedGamesFrom,
    playedGamesTo,
  }

  const multiTournamentData = [];
  const multiEventData = [];

  if (repetitiveTournament) {
    for (const dateObj of multiDates) {
      const dateStr = `${padToTwoDigits(dateObj.day)}.${padToTwoDigits(dateObj.month.number)}.${padToTwoDigits(dateObj.year)}`;

      // Check if the date is today
      const today = new Date();
      const todayStr = `${padToTwoDigits(today.getDate())}.${padToTwoDigits(today.getMonth() + 1)}.${padToTwoDigits(today.getFullYear())}`;

      // Skip if date is today and registration time has already passed (registerTime < 0 means registration time is in the past)

      // if (multiDates.length > 1) {
      //   if (startDateParsed <= Date.parse(registerTime)) {
      //     continue; // Skip this date and continue to the next one
      //   }
      // } else {
      if (dateStr === todayStr && (startDateParsed <= Date.parse(registerTime) || startDateParsed < Date.now())) {
        return () => new Promise(resolve => resolve({ status: 'error', message: 'Start time cannot be in the past' }));
      }
      // }
      console.log(dateStr, todayStr, registerTime, new Date(startDateParsed), Date.parse(registerTime), startDateParsed, "registerTidme====================");
      const tempTournamentData = {
        params: {
          ...tournamentData.params,
          name: `${titleLV}: ${dateStr}`,
          titleEN: `${titleEN}: ${dateStr}`,
          titleLV: `${titleLV}: ${dateStr}`,
          titleRU: `${titleRU}: ${dateStr}`,
          startDate: Date.parse(new Date(dateObj.year, dateObj.month.index, dateObj.day, startDate.getHours(), startDate.getMinutes())),
          bannerStartDate: bannerStartDateParsed ? Date.parse(new Date(dateObj.year, dateObj.month.index, dateObj.day, bannerStartDate.getHours(), bannerStartDate.getMinutes())) : null,
          bannerEndDate: bannerEndDateParsed ? Date.parse(new Date(dateObj.year, dateObj.month.index, dateObj.day, bannerEndDate.getHours(), bannerEndDate.getMinutes())) : null,
        }
      }
      multiTournamentData.push(tempTournamentData);

      if (bannerShowChecked) {
        const tempEventData = {
          ...eventData,
          startDate: Date.parse(new Date(dateObj.year, dateObj.month.index, dateObj.day, bannerStartDate.getHours(), bannerStartDate.getMinutes())),
          endDate: Date.parse(new Date(dateObj.year, dateObj.month.index, dateObj.day, bannerEndDate.getHours(), bannerEndDate.getMinutes())),
          tournamentStartDate: startDateParsed,
          name: `${titleLV}: ${dateStr}`,
          titleEN: `${titleEN}: ${dateStr}`,
          titleLV: `${titleLV}: ${dateStr}`,
          titleRU: `${titleRU}: ${dateStr}`,
        }
        multiEventData.push(tempEventData);
      }
    }
  }

  return () => new Promise(async (resolve) => {
    const tournamentPromises = [];

    if (!repetitiveTournament) {
      tournamentPromises.push(TournamentsRef().child('newTournaments').push(tournamentData));
    } else {
      for (let i = 0; i < multiTournamentData.length; i++) {
        tournamentPromises.push(TournamentsRef().child('newTournaments').push(multiTournamentData[i]));
      }
    }
    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    Promise.all(tournamentPromises).then(async (responses) => {
      const promises = [];
      responses.forEach(async (res, responseIndex) => {
        const { key } = res;

        if (key) {
          if (bannerShowChecked) {
            const createEventFunction = Firebase.app().functions().httpsCallable('createEvent');
            const newEventData = {
              ...(!repetitiveTournament ? eventData : multiEventData[responseIndex]),
              descriptionTournamentId: key,
            }
            await createEventFunction(newEventData);
          }

          promises.push(TournamentsRef().child(`newTournamentsList/${key}`).set(!repetitiveTournament ? tournamentData.params : multiTournamentData[responseIndex].params));
          promises.push(AdminLogsRef().child('adminLogs/adminActions').push({
            type: 'createdTournament',
            adminId: UID,
            adminEmail,
            adminName: confirmAdminName || adminName,
            tournamentId: key,
            data: !repetitiveTournament ? tournamentData.params : multiTournamentData[responseIndex].params,
            date: Firebase.database.ServerValue.TIMESTAMP,
          }));
        }
      });

      Promise.allSettled(promises).then(() => {
        resolve({ status: 'success' });
      }).catch((err) => {
        resolve({ status: 'error' , message: err});
      });
    }).catch((err) => {
      resolve({ status: 'error', message: err });
    });
  });
}


export function editTournament({ data, oldData }) {
  console.log('editTournament', data, oldData);

  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

//  const {
//    prevState, tournamentToEdit, name, entryFee, bonus, startDate, registerTime, winnerPercent, parasta, G, atra, lightning, unlimited, pro, maxPlayers, maza, rounds, roundLength, newRoundPause, bet, privateTournament, devTournament, password, sponsorImageUrl, prizeImageUrl, playerPerRoomLimit,
//  } = data;

  const {
    prevState,
    tournamentToEdit,
    sponsorImageUrl,
    prizeImageUrl,
    titleLV,
    titleEN,
    titleRU,
    entryFee,
    bonus,
    startDate,
    registerTime,
    winnerPercent,
    parasta,
    G,
    atra,
    veryFast,
    lightning,
    unlimited,
    pro,
    maxPlayers,
    maza,
    rounds,
    roundLength,
    newRoundPause,
    bet,
    password,
    privateTournament,
    devTournament,
    playerPerRoomLimit,
    bannerPrizeChecked,
    bannerPrizeImageUrl,
    bannerShowChecked,
    bannerStartDate,
    bannerEndDate,
    specialPrizeLV,
    specialPrizeEN,
    specialPrizeRU,
    tournamentType,
    restrictions,
    levelFrom,
    levelTo,
    pointsFrom,
    pointsTo,
    balanceFrom,
    balanceTo,
    playedGamesFrom,
    playedGamesTo,
  } = data;

  const startDateParsed = Date.parse(startDate);

  if (!tournamentToEdit) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Error editing tournament' })); }
  if (!titleLV || !titleEN || !titleRU) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Missing title' })); }
  if (!entryFee) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Missing entry fee' })); }
  if (!rounds) { return () => new Promise(resolve => resolve({ status: 'error', message: 'No starting tokens' })); }
  if (!roundLength) { return () => new Promise(resolve => resolve({ status: 'error', message: 'No round length' })); }
  if (registerTime < 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Start date cant be same as or before register date' })); }

  const regTime = startDateParsed - (1000 * 60 * registerTime);
  const bannerTime = Date.parse(bannerStartDate);

  const regTimeNormalized = normalizeToMinute(regTime);
  const bannerTimeNormalized = normalizeToMinute(bannerTime);
  const nowTimeNormalized = normalizeToMinute(Date.now());

  if (bannerShowChecked && regTimeNormalized >= nowTimeNormalized && bannerTimeNormalized >= nowTimeNormalized) {
    if (regTimeNormalized > bannerTimeNormalized) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Banner start time cant be before registration' })); }
  }
  // if (bannerShowChecked && startDateParsed - (1000 * 60 * registerTime) > Date.parse(bannerStartDate)) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Banner start time cant be before registration' })); }

  if (!winnerPercent) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Missing winning percent' })); }
  if (!maxPlayers) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Missing maximum players' })); }
  if (restrictions && (parseInt(levelFrom) > parseInt(levelTo) || parseInt(pointsFrom) > parseInt(pointsTo) || parseInt(balanceFrom) > parseInt(balanceTo) || parseInt(playedGamesFrom) > parseInt(playedGamesTo))) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Wrong values' })); }

  if (Number.isNaN(Number(entryFee)) || parseInt(entryFee, 10) <= 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Entry fee has to be positive number' })); }
  if (Number.isNaN(Number(rounds)) || parseInt(rounds, 10) <= 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Rounds per tournament has to be positive number' })); }
  if (Number.isNaN(Number(roundLength)) || parseInt(roundLength, 10) < 0) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Round length has to be positive number' })); }
  if (!startDateParsed || !(startDate instanceof Date)) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Missing date' })); }
  if (Number.isNaN(Number(winnerPercent)) || parseInt(winnerPercent, 10) <= 0 || parseInt(winnerPercent, 10) > 100) { return () => new Promise(resolve => resolve({ status: 'error', message: 'Winning percent has to be positive number' })); }

  let gameType = 'P';
  if (parasta) {
    gameType = 'P';
  } else if (G) {
    gameType = 'G';
  }

  let newState;

  if (startDateParsed && registerTime) {
    if (startDateParsed - (1000 * 60 * registerTime) > Date.now()) {
      newState = 'pending';
    } else if (startDateParsed - (1000 * 60 * registerTime) < Date.now() && startDateParsed > Date.now()) {
      newState = 'registration';
    } else {
      return () => new Promise(resolve => resolve({ status: 'error', message: 'Start time cannot be in the past' }));
    }
  } else {
    return () => new Promise(resolve => resolve({ status: 'error', message: 'Start time / register time error' }));
  }
  newState = 'pending';

  /*
  let roundLengthTime = 20;

  if (roundLength > 24) {
    roundLengthTime = 60;
  } else if (roundLength > 12) {
    roundLengthTime = 40;
  } */

  let speed = 'normal';

  if (atra) {
    speed = 'atra';
  } else if (lightning) {
    speed = 'lightning';
  } else if (veryFast) {
    speed = 'veryFast';
  }

  let roundLengthTime = constants.CALC_TOURNAMENT_ROUND_LENGTH(roundLength, speed);

  const bannerStartDateParsed = Date.parse(bannerStartDate);
  const bannerEndDateParsed = Date.parse(bannerEndDate);

  // const maxLengthTime = roundLengthTime * rounds;

  const maxLengthTime = (roundLengthTime * rounds) + ((newRoundPause || 0) * (rounds - 1));
  const maxLengthTimeRounded = Math.ceil(maxLengthTime / 10) * 10;

  console.log('maxLengthTimeRounded', maxLengthTimeRounded, maxLengthTime);

  const dataToEdit = {
    currentState: newState,
    name: titleLV,
    titleEN: titleEN,
    titleLV: titleLV,
    titleRU: titleRU,
    bet: bet || '1:10',
    entryFee: parseInt(entryFee, 10),
    bonus: parseInt(bonus, 10) || 0,
    rounds: parseInt(rounds, 10),
    roundLength: parseInt(roundLength, 10),
    roundLengthTime: roundLengthTime || null,
    startDate: startDateParsed,
    registerTime,
    winnerPercent,
    sponsorImg: sponsorImageUrl || null,
    prizeImg: prizeImageUrl || null,
    maxPlayers,
    maxLengthTime: maxLengthTimeRounded || null,
    gameType,
    fastGame: atra || null,
    veryFastGame: veryFast || null,
    lightningGame: lightning || null,
    unlimitedGame: unlimited || null,
    smallGame: maza,
    proGame: pro,
    newRoundPause,
    open: true,
    privateTournament: privateTournament || null,
    devTournament: devTournament || null,
    playerPerRoomLimit: playerPerRoomLimit ? (playerPerRoomLimit === 'none' ? null : playerPerRoomLimit) : null,
    bannerPrizeImageUrl: bannerPrizeImageUrl || null,
    bannerPrizeChecked: bannerPrizeChecked || null,
    bannerShowChecked: bannerShowChecked || null,
    bannerStartDate: bannerStartDateParsed || null,
    bannerEndDate: bannerEndDateParsed || null,
    specialPrizeLV: bannerPrizeChecked ? (specialPrizeLV || null) : null,
    specialPrizeEN: bannerPrizeChecked ? (specialPrizeEN || null) : null,
    specialPrizeRU: bannerPrizeChecked ? (specialPrizeRU || null) : null,
    tournamentType,
    restrictions,
    levelFrom,
    levelTo,
    pointsFrom,
    pointsTo,
    balanceFrom,
    balanceTo,
    playedGamesFrom,
    playedGamesTo,
  };

  if (!privateTournament) {
    dataToEdit.password = null;
  }

  if (privateTournament && password) {
    dataToEdit.password = password;
  }

  console.log('UID 0', { UID, tournamentToEdit, dataToEdit });

  return () => new Promise(resolve => FirebaseRef.child('events').orderByChild('descriptionTournamentId').equalTo(tournamentToEdit).limitToLast(1).once('value', (snapshot) => {
    const eventData = snapshot.val() || null;

    console.log('eventData', eventData);

    TournamentsRef().child(`newTournaments/${tournamentToEdit}/params`).update(dataToEdit).then(async () => {
      const promises = [];

      if (eventData) {
        const eventKey = (eventData && Object.keys(eventData).length > 0) ? Object.keys(eventData)[0] : null;

        console.log('already has an event, update exisitng one', eventKey);


        if (eventKey) {
          const editEventFunction = Firebase.app().functions().httpsCallable('editEvent');

          console.log('call edit banner', bannerShowChecked, bannerPrizeChecked, bannerPrizeImageUrl, bannerStartDate, bannerEndDate, startDateParsed)

          console.log("bannerPrizeChecked", bannerPrizeChecked, bannerPrizeImageUrl);

          await editEventFunction({
            eventId: eventKey,
            startDate: bannerStartDateParsed,
            endDate: bannerEndDateParsed,
            tournamentStartDate: startDateParsed,
            name: titleLV,
            titleEN: titleEN,
            titleLV: titleLV,
            titleRU: titleRU,
            descriptionEN: titleEN,
            descriptionLV: titleLV,
            descriptionRU: titleRU,
            descriptionTournamentId: tournamentToEdit,
            bannerPrizeChecked,
            imageUrl: (bannerPrizeChecked && bannerPrizeImageUrl) ? bannerPrizeImageUrl : null,
            pageToOpen: 'plannedTournaments',
            showInBanner: bannerShowChecked,
            devMode: devTournament,
            bannerImageType: null,
            externalLink: null,
            specialPrizeLV: bannerPrizeChecked ? (specialPrizeLV || null) : null,
            specialPrizeEN: bannerPrizeChecked ? (specialPrizeEN || null) : null,
            specialPrizeRU: bannerPrizeChecked ? (specialPrizeRU || null) : null,
            tournamentType,
            restrictions,
            levelFrom,
            levelTo,
            pointsFrom,
            pointsTo,
            balanceFrom,
            balanceTo,
            playedGamesFrom,
            playedGamesTo,
          });

        }/* else {
          // Delete event
          const deleteEventFunction = Firebase.app().functions().httpsCallable('deleteEvent');

          if (eventKey) {
            await deleteEventFunction({
              eventId: eventKey,
            });
          }
        }*/

      } else {
        console.log('has no event, add a new one');

        if (bannerShowChecked) {
          const createEventFunction = Firebase.app().functions().httpsCallable('createEvent');

          console.log('call create banner', bannerShowChecked, bannerPrizeChecked, bannerPrizeImageUrl, bannerStartDate, bannerEndDate, startDateParsed)

        //  const bannerStartDateParsed = Date.parse(bannerStartDate);
        //  const bannerEndDateParsed = Date.parse(bannerEndDate);

          console.log("bannerPrizeChecked", bannerPrizeChecked, bannerPrizeImageUrl);

          await createEventFunction({
            startDate: bannerStartDateParsed,
            endDate: bannerEndDateParsed,
            tournamentStartDate: startDateParsed,
            name: titleLV,
            titleEN: titleEN,
            titleLV: titleLV,
            titleRU: titleRU,
            descriptionEN: titleEN,
            descriptionLV: titleLV,
            descriptionRU: titleRU,
            descriptionTournamentId: tournamentToEdit,
            bannerPrizeChecked,
            imageUrl: (bannerPrizeChecked && bannerPrizeImageUrl) ? bannerPrizeImageUrl : null,
            pageToOpen: 'plannedTournaments',
            showInBanner: bannerShowChecked,
            devMode: devTournament,
            bannerImageType: null,
            externalLink: null,
            specialPrizeLV: bannerPrizeChecked ? (specialPrizeLV || null) : null,
            specialPrizeEN: bannerPrizeChecked ? (specialPrizeEN || null) : null,
            specialPrizeRU: bannerPrizeChecked ? (specialPrizeRU || null) : null,
            tournamentType,
            restrictions,
            levelFrom,
            levelTo,
            pointsFrom,
            pointsTo,
            balanceFrom,
            balanceTo,
            playedGamesFrom,
            playedGamesTo,
          });
        }
      }

      /* if (bannerShowChecked) {
        const createEventFunction = Firebase.app().functions().httpsCallable('createEvent');

        console.log('call create banner', bannerShowChecked, bannerPrizeChecked, bannerPrizeImageUrl, bannerStartDate, bannerEndDate, startDateParsed)

        const bannerStartDateParsed = Date.parse(bannerStartDate);
        const bannerEndDateParsed = Date.parse(bannerEndDate);

        console.log("bannerPrizeChecked", bannerPrizeChecked, bannerPrizeImageUrl);

        await createEventFunction({
          startDate: bannerStartDateParsed,
          endDate: bannerEndDateParsed,
          tournamentStartDate: startDateParsed,
          name: titleLV,
          titleEN: titleEN,
          titleLV: titleLV,
          titleRU: titleRU,
          descriptionEN: titleEN,
          descriptionLV: titleLV,
          descriptionRU: titleRU,
          descriptionTournamentId: tournamentToEdit,
          bannerPrizeChecked,
          imageUrl: (bannerPrizeChecked && bannerPrizeImageUrl) ? bannerPrizeImageUrl : null,
          pageToOpen: 'plannedTournaments',
          showInBanner: bannerShowChecked,
          devMode: devTournament,
          bannerImageType: null,
          externalLink: null,
        });
      } */

      if (newState === 'pending') {
        promises.push(TournamentsRef().child(`newTournaments/${tournamentToEdit}/players`).once('value', (snapshot) => {
          const players = snapshot.val();

          TournamentsRef().child(`newTournamentsList/${tournamentToEdit}/roomsResolved`).remove();

          TournamentsRef().child(`newTournaments/${tournamentToEdit}/params/roomsResolved`).remove();

          if (players) {
            Object.keys(players).map((key) => {
              FirebaseRef.child(`users/${key.toString()}/activeTournament`).remove();
              return null;
            });
          }
        }));
      } else if (newState === 'registration') {
        if (startDateParsed && startDateParsed - (1000 * 60 * 5) > Date.now()) {
          promises.push(TournamentsRef().child(`newTournaments/${tournamentToEdit}/players`).once('value', (snapshot) => {
            const players = snapshot.val();

            TournamentsRef().child(`newTournamentsList/${tournamentToEdit}/roomsResolved`).remove();

            TournamentsRef().child(`newTournaments/${tournamentToEdit}/params/roomsResolved`).remove();

            if (players) {
              Object.keys(players).map((key) => {
                FirebaseRef.child(`users/${key.toString()}/activeTournament`).remove();
                return null;
              });
            }
          }));
        }
      }

      if (newState && prevState === 'closed') {
        TournamentsRef().child(`newTournaments/${tournamentToEdit}/players`).remove();
        TournamentsRef().child(`newTournaments/${tournamentToEdit}/playersStaticData`).remove();
        TournamentsRef().child(`newTournaments/${tournamentToEdit}/params`).update({
          registeredPlayers: 0,
          activePlayers: 0,
          leftPlayers: 0,
          pausedPlayers: 0,
          totalBank: 0,
          currentRound: 1,
        });
        TournamentsRef().child(`newTournamentsList/${tournamentToEdit}`).update({
          registeredPlayers: 0,
          activePlayers: 0,
          leftPlayers: 0,
          pausedPlayers: 0,
          totalBank: 0,
          currentRound: 1,
        });
      }

      promises.push(TournamentsRef().child(`newTournamentsList/${tournamentToEdit}`).update({
        currentState: newState,
        name: titleLV,
        titleEN: titleEN,
        titleLV: titleLV,
        titleRU: titleRU,
        bet: bet || '1:10',
        entryFee: parseInt(entryFee, 10),
        bonus: parseInt(bonus, 10) || 0,
        rounds: parseInt(rounds, 10),
        roundLength: parseInt(roundLength, 10),
        roundLengthTime: roundLengthTime || null,
        startDate: startDateParsed,
        registerTime,
        winnerPercent,
        sponsorImg: sponsorImageUrl || null,
        prizeImg: prizeImageUrl || null,
        maxPlayers,
        maxLengthTime: maxLengthTimeRounded || null,
        gameType,
        fastGame: atra || null,
        veryFastGame: veryFast || null,
        lightningGame: lightning || null,
        unlimitedGame: unlimited || null,
        smallGame: maza,
        proGame: pro,
        newRoundPause,
        open: true,
        privateTournament: privateTournament || null,
        devTournament: devTournament || null,
        playerPerRoomLimit: playerPerRoomLimit ? (playerPerRoomLimit === 'none' ? null : playerPerRoomLimit) : null,
        bannerPrizeImageUrl: bannerPrizeImageUrl || null,
        bannerPrizeChecked: bannerPrizeChecked || null,
        bannerShowChecked: bannerShowChecked || null,
        bannerStartDate: bannerStartDateParsed || null,
        bannerEndDate: bannerEndDateParsed || null,
        specialPrizeLV: bannerPrizeChecked ? (specialPrizeLV || null) : null,
        specialPrizeEN: bannerPrizeChecked ? (specialPrizeEN || null) : null,
        specialPrizeRU: bannerPrizeChecked ? (specialPrizeRU || null) : null,
        tournamentType,
        restrictions,
        levelFrom,
        levelTo,
        pointsFrom,
        pointsTo,
        balanceFrom,
        balanceTo,
        playedGamesFrom,
        playedGamesTo,
      }));

      const dateKeys = new Set(['startDate', 'bannerStartDate', 'bannerEndDate']);

      const changesObj = {};

      Object.keys(dataToEdit).forEach((key) => {
        if (key === 'open') return;

        const oldValue = oldData[key];
        const newValue = dataToEdit[key];

        if (isEmptyEquivalent(oldValue) && isEmptyEquivalent(newValue)) {
          return;
        }

        if (!isEqual(oldValue, newValue)) {
          changesObj[key] = { new: newValue, old: oldValue };
        }
      });

      const formatTournamentLogValue = (key, value) => {
        if (dateKeys.has(key)) {
          if (isEmptyEquivalent(value)) return '';
          return dateFormat(new Date(value));
        }
        return formatLogValue(value);
      };

      const changedlog = Object.keys(changesObj).map((key) => {
        const { old, new: newValue } = changesObj[key];
        return `${key} ${formatTournamentLogValue(key, old)} to ${formatTournamentLogValue(key, newValue)}`;
      }).join(', ');

      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'editedTournament',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        tournamentId: tournamentToEdit,
        data: { ...dataToEdit, changedlog },
        userName: titleLV,
        date: Firebase.database.ServerValue.TIMESTAMP,
      });

      Promise.all(promises).then(() => resolve({ status: 'success' }));
    }).catch((err) => resolve({ status: 'error', message: err }));
  }));
}

export function deleteTournament(tournamentId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  // return () => new Promise(resolve => Firebase.auth().onAuthStateChanged((user) => {

  return () => new Promise(resolve => FirebaseRef.child('events').orderByChild('descriptionTournamentId').equalTo(tournamentId).limitToLast(1).once('value', async (snapshot) => {
    const eventData = snapshot.val() || null;

    console.log('eventData', eventData);

    const eventKey = (eventData && Object.keys(eventData).length > 0) ? Object.keys(eventData)[0] : null;

    console.log('already has an event, update exisitng one', eventKey);

    if (eventKey) {
      const deleteEventFunction = Firebase.app().functions().httpsCallable('deleteEvent');

      console.log('call delete banner');

      await deleteEventFunction({
        eventId: eventKey,
      });
    }

    if (UID) {
      TournamentsRef().child(`newTournamentsList/${tournamentId}`).remove();

      TournamentsRef().child(`tournamentPlayerHistory/${tournamentId}`).remove();

      TournamentsRef().child(`newTournaments/${tournamentId}`).remove().then(() => {
        resolve({ status: 'success' });
      });

      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'deletedTournament',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        tournamentId,
        data: null,
        date: Firebase.database.ServerValue.TIMESTAMP,
      });
    }
  }));
}

export function setCheckingStatus(pairKey, status, pairNames) {
  if (Firebase === null || !pairKey) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise(async (resolve) => {
    AdminLogsRef().child(`suspiciousSameIP/players/${pairKey}`).update({
      checkingStatus: status
    });

    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'setCheckingStatus',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      pairKey,
      data: null,
      date: Firebase.database.ServerValue.TIMESTAMP,
      userId: pairKey,
      userName: pairNames,
    });

    resolve('success');
  });
}

export function getRoomLog(roomId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    const promise1 = AdminLogsRef().child(`adminLogs/rooms/${roomId}`).once('value');
    const promise2 = RoomsRef.child(`roomsPoints/${roomId}/points`).once('value');
    const promise3 = AdminLogsRef().child(`adminLogs/roomIds/${roomId}/privateRoom`).once('value');

    return Promise.all([promise1, promise2, promise3]).then((promisesRes) => {
      let data;
      let roomsPoints;
      let privateRoom;
      let roomPlayersSameIP = [];

      promisesRes.map((resp, index) => {
        if (index === 0) {
          data = resp.val();

          const startLogs = data[1] || {};
          const joinedPlayerUids = Object.values(startLogs)
            .map(log => log?.data?.joinedPlayerUid)
            .filter(uid => uid);

          for (let i = 0; i < joinedPlayerUids.length; i++) {
            for (let j = i + 1; j < joinedPlayerUids.length; j++) {
              const player1 = joinedPlayerUids[i];
              const player2 = joinedPlayerUids[j];

              if (player1 === player2) continue;

              const key1 = `${player1}--${player2}`;
              const key2 = `${player2}--${player1}`;

              const ref1 = AdminLogsRef().child(`suspiciousSameIP/playerRooms/${key1}/${roomId}`).once('value');
              const ref2 = AdminLogsRef().child(`suspiciousSameIP/playerRooms/${key2}/${roomId}`).once('value');

              Promise.all([ref1, ref2]).then(([snap1, snap2]) => {
                const val1 = snap1.val();
                const val2 = snap2.val();

                if ((val1 && val1.player1Ip && val1.player2Ip) || (val2 && val2.player1Ip && val2.player2Ip)) {
                  if (!roomPlayersSameIP.includes(player1)) roomPlayersSameIP.push(player1);
                  if (!roomPlayersSameIP.includes(player2)) roomPlayersSameIP.push(player2);
                }
              });
            }
          }

        } else if (index === 1) {
          roomsPoints = resp.val();
        } else if (index === 2) {
          privateRoom = resp.val();
        }
        return null;
      });

      return resolve(dispatch({
        type: 'ADMIN_ROOM_LOGS',
        data,
        roomId,
        roomsPoints,
        privateRoom,
        roomPlayersSameIP,
      }));
    }).catch((err) => { console.log(err.message); });
  });
}


export function getUserGamesHistory(userId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  const promises = [];
  const stats = {};

  return dispatch => new Promise((resolve) => {
    for (let i = 1; i < 30; i += 1) {
      const today = new Date();
      today.setDate(today.getDate() - i);

      const year = today.getFullYear();
      let month = today.getMonth() + 1;
      let date = today.getDate();

      if (month < 10) {
        month = `0${month}`;
      }
      if (date < 10) {
        date = `0${date}`;
      }

      const dateString = `${year}-${month}-${date}`;


      
      promises.push(UserStatsRef().child(`userRoomsResults/${dateString}/${userId.toString()}`)
        .once('value', (snapshot) => {
          const history = snapshot.val() || {};
          console.log("userRoomsResults dateString", dateString, history)
          stats[dateString] = history;
        }));
    }

    const today2 = new Date();

    const year2 = today2.getFullYear();
    let month2 = today2.getMonth() + 1;
    let date2 = today2.getDate();

    if (month2 < 10) {
      month2 = `0${month2}`;
    }
    if (date2 < 10) {
      date2 = `0${date2}`;
    }

    const dateString2 = `${year2}-${month2}-${date2}`;

    Promise.all(promises).then(() => {
      const promises2 = [];
      promises2.push(new Promise((resolve2) => {
        // todayUserResults
        UserStatsRef().child(`todayUserResults/${userId.toString()}`)
          .once('value', (todayUserResultsSnapshot) => {
            const todayUserResults = todayUserResultsSnapshot.val() || {};

            console.log('total result todayUserResults', todayUserResults);

        UserStatsRef().child(`todayRoomResults/playerRooms/${userId.toString()}`)
          .once('value', (snapshot) => {
            const history = snapshot.val() || {};
            let todayStats = {};
            const uid = userId;

            Object.keys(history).map((key) => {
              const { totalResults, totalBalChange, totalPointsChange } = history[key];

              if (totalResults && totalResults[uid]) {
                todayStats = {
                  ...todayStats,
                  wins: (todayStats.wins || 0) + ((totalResults[uid] && totalResults[uid].wins) ? totalResults[uid].wins : 0),
                  largeWins: (todayStats.largeWins || 0) + ((totalResults[uid] && totalResults[uid].largeWins) ? totalResults[uid].largeWins : 0),
                  smallWins: (todayStats.smallWins || 0) + ((totalResults[uid] && totalResults[uid].smallWins) ? totalResults[uid].smallWins : 0),
                  smallZoleWins: (todayStats.smallZoleWins || 0) + ((totalResults[uid] && totalResults[uid].smallZoleWins) ? totalResults[uid].smallZoleWins : 0),
                  zoleWins: (todayStats.zoleWins || 0) + ((totalResults[uid] && totalResults[uid].zoleWins) ? totalResults[uid].zoleWins : 0),
                  loses: (todayStats.loses || 0) + ((totalResults[uid] && totalResults[uid].loses) ? totalResults[uid].loses : 0),
                  largeLoses: (todayStats.largeLoses || 0) + ((totalResults[uid] && totalResults[uid].largeLoses) ? totalResults[uid].largeLoses : 0),
                  smallLoses: (todayStats.smallLoses || 0) + ((totalResults[uid] && totalResults[uid].smallLoses) ? totalResults[uid].smallLoses : 0),
                  smallZoleLoses: (todayStats.smallZoleLoses || 0) + ((totalResults[uid] && totalResults[uid].smallZoleLoses) ? totalResults[uid].smallZoleLoses : 0),
                  zoleLoses: (todayStats.zoleLoses || 0) + ((totalResults[uid] && totalResults[uid].zoleLoses) ? totalResults[uid].zoleLoses : 0),
                  galdinsLoses: (todayStats.galdinsLoses || 0) + ((totalResults[uid] && totalResults[uid].galdinsLoses) ? totalResults[uid].galdinsLoses : 0),
                  galdinsWins: (todayStats.galdinsWins || 0) + ((totalResults[uid] && totalResults[uid].galdinsWins) ? totalResults[uid].galdinsWins : 0),


                  roomsPlayed: (todayStats.roomsPlayed || 0) + 1,
                  roundsPlayed: (todayStats.roundsPlayed || 0) + ((totalResults[uid] && totalResults[uid].roundsPlayed) ? totalResults[uid].roundsPlayed : 0),

                  balChange: (todayStats.balChange || 0) + (totalBalChange[uid] || 0),
                  pointsChange: (todayStats.pointsChange || 0) + (totalPointsChange[uid] || 0),
                };
              } else {
                todayStats = {
                  ...todayStats,
                  balChange: ((todayStats && todayStats.balChange) ? todayStats.balChange : 0) + (totalBalChange[uid] || 0),
                  pointsChange: ((todayStats && todayStats.pointsChange) ? todayStats.pointsChange : 0) + (totalPointsChange[uid] || 0),
                };
              }

              return null;
            });
            if (!isNaN(todayUserResults.bonusSpin)) {
              todayStats.bonusSpin = todayUserResults.bonusSpin;
            }

            console.log('dateString2', dateString2, todayStats);

            stats[dateString2] = todayStats;

            return resolve2();
          });
        });
      }));
      console.log('total result', stats);

      Promise.all(promises2).then(() => {
        resolve(dispatch({
          type: 'USER_GAMES_HISTORY',
          data: stats,
        }));
      });
    });
  });
}

export function getUserBalanceHistory(userId, startAt, endAt) {
  console.log('getUserBalanceHistory', { userId, startAt, endAt });
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  console.log('test 1');

  if (!UID) return () => new Promise(resolve => resolve());

  console.log('test 2');

  return dispatch => new Promise(resolve => UserStatsRef().child(`userBalHistory/${userId.toString()}`)
    .orderByChild('time')
    .startAt(startAt)
    .endAt(endAt)
    .once('value', (snapshot) => {
      const history = snapshot.val() || {};
      console.log('history', { history });

      resolve(dispatch({
        type: 'USER_BAL_HISTORY',
        data: history,
      }));
    })
    .catch((err) => { console.log(err); }));
}

export function getUserPointsHistory(userId, startAt, endAt) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => UserStatsRef().child(`userPointsHistory/${userId.toString()}`)
    .orderByChild('time')
    .startAt(startAt)
    .endAt(endAt)
    .once('value', (snapshot) => {
      const history = snapshot.val() || {};

      resolve(dispatch({
        type: 'USER_POINTS_HISTORY',
        data: history,
      }));
    }, ((err) => {
      console.log(err);
      return resolve(null);
    })));
}

export function setNextDealCards(roomId, cards) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  console.log('setNextDealCards', cards);

  return () => new Promise((resolve) => {
    const setNextDealCardsFunction = Firebase.app().functions().httpsCallable('setNextDealCards');

    setNextDealCardsFunction({
      roomId,
      cards,
      playerCards: {
        ...cards,
      },
    }).then((result) => {
      resolve(result);
    });
  });
}
export function setUserBal(roomId, userId, userPos, newBal) {
  if (Firebase === null || !roomId || !userId || !userPos || !newBal) return () => new Promise(resolve => resolve());

  if (Number.isNaN(newBal)) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return () => new Promise((resolve) => {
    FirebaseRef.child(`users/${userId}`).update({
      bal: parseInt(newBal, 10),
    });

    resolve('success');
  });
}


export function setUserTournamentBal(roomId, tournamentId, userId, userPos, newBal) {
  if (Firebase === null || !roomId || !userId || !userPos || !newBal) return () => new Promise(resolve => resolve());

  if (Number.isNaN(newBal)) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return () => new Promise((resolve) => {
    RoomsRef.child(`rooms/${roomId}/players/${userPos}`).update({
      bal: parseInt(newBal, 10),
    });

    RoomsRef.child(`rooms/${roomId}/playersList/${userPos}`).update({
      bal: parseInt(newBal, 10),
    });

    FirebaseRef.child(`tourPlayerData/${userId}/${tournamentId}`).update({
      bal: parseInt(newBal, 10),
    });

    FirebaseRef.child(`tourPlayers/${tournamentId}/${userId}`).update({
      bal: parseInt(newBal, 10),
    });

    resolve('success');
  });
}

export function disableTimer(roomId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return () => new Promise(resolve => RoomsRef.child(`rooms/${roomId}/globalParams/disableTimer`).once('value', (disabledSnapshot) => {
    const disabled = disabledSnapshot.val() || false;
    RoomsRef.child(`rooms/${roomId}/globalParams`).update({
      disableTimer: !disabled,
    });

    resolve('success');
  }));
}

export function toggleAutomation(roomId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return () => new Promise(resolve => RoomsRef.child(`rooms/${roomId}/globalParams/automated`).once('value', (disabledSnapshot) => {
    const disabled = disabledSnapshot.val() || false;
    RoomsRef.child(`rooms/${roomId}/globalParams`).update({
      automated: !disabled,
    });

    resolve('success');
  }));
}

export function getSmartLookEnabled() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  FirebaseRef.child('smartLookEnabled').off();

  return dispatch => new Promise(resolve => FirebaseRef.child('smartLookEnabled')
    .on('value', (snapshot) => {
      const smartLookEnabled = snapshot.val() || false;

      resolve(dispatch({
        type: 'SMARTLOOK_STATUS',
        data: smartLookEnabled,
      }));
    }));
}

export function changeSmartLook(value) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  return () => new Promise((resolve) => {
    FirebaseRef.child('smartLookEnabled').set(value);

    return resolve();
  });
}


export function getAdmins() {
  if (Firebase === null) return () => new Promise(resolve => resolve());


  return dispatch => new Promise((resolve) => {
    FirebaseRef.child('users').off();

    const promise1 = FirebaseRef.child('users').orderByChild('role').equalTo('admin').once('value');
    const promise2 = FirebaseRef.child('users').orderByChild('role').equalTo('tester').once('value');

    Promise.all([promise1, promise2]).then((promisesRes) => {
      let admins;
      let testers;

      promisesRes.map((resp, index) => {
        if (index === 0) {
          admins = resp.val();
        } else if (index === 1) {
          testers = resp.val();
        }
        return null;
      });

      const users = { ...admins, ...testers };

      return resolve(dispatch({ type: 'ADMIN_LIST_REPLACE', data: users }));
    });
  }).catch((err) => { console.log(err.message); });
}


export function getBotUsers() {
  if (Firebase === null) return () => new Promise(resolve => resolve());


  return dispatch => new Promise((resolve) => {
    FirebaseRef.child('users').off();

    console.log('users fetch getBotUsers');

    const promise1 = FirebaseRef.child('users').orderByChild('botUser').equalTo(true).once('value');

    Promise.all([promise1]).then((promisesRes) => {
      let bots;

      promisesRes.map((resp, index) => {
        if (index === 0) {
          bots = resp.val();
        }
        return null;
      });

      return resolve(dispatch({ type: 'BOTS_LIST_REPLACE', data: bots }));
    });
  }).catch((err) => { console.log(err.message); });
}

export function getAdminActionLog(start, end) {

  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    AdminLogsRef().child('adminLogs/adminActions')
      .orderByChild('index')
      .startAt(start)
      .endAt(end)
      .on('value', async (snapshot) => {
        const adminActionLogs = snapshot.val() || {};
        console.log('Admin Actioin Logs', adminActionLogs);

        //>>>>>>>>>>>>>>>>>>
        // const updatedLogs = {};

        // const fetchAdminName = async (adminId) => {
        //   const nameSnapshot = await FirebaseRef.child(`users/${adminId}/name`).once('value');
        //   return nameSnapshot.val();
        // };

        // for (const [id, log] of Object.entries(adminActionLogs)) {
        //   try {
        //     const adminName = await fetchAdminName(log.adminId);
        //     updatedLogs[id] = {
        //       ...log,
        //       adminName
        //     };
        //   } catch (error) {
        //     updatedLogs[id] = {
        //       ...log,
        //       adminName: log.adminName
        //     };
        //     console.error(`Failed to fetch name for adminId ${log.adminId}: `, error);
        //   }
        // }
        //<<<<<<<<<<<<<<<<<<<<<<

        return resolve(dispatch({
          type: 'ADMIN_ACTION_LOGS',
          data: adminActionLogs,
        }));
      }, (err) => { console.log(err); });
  })
    .catch((err) => { console.log(err); });
}

export function getAdminActionLogCount() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('statistics/adminActionsCount')
    .once('value', (snapshot) => {
      const logsCount = snapshot.val() || {};

      AdminLogsRef().child('adminLogs/adminActions').off();

      AdminLogsRef().child('adminLogs/adminActions')
        .orderByChild('index')
        .startAt(logsCount)
        .on('child_added', (snapshot2) => {
          const adminActionLogs = snapshot2.val() || {};
          const { key } = snapshot2;
          FirebaseRef.child('statistics/adminActionsCount')
            .once('value', (snapshot3) => {
              const logsCount2 = snapshot3.val() || {};
              dispatch({ type: 'ADMIN_ACTION_LOGS_COUNT', data: logsCount2 });
            });
          dispatch({
            type: 'ADMIN_ACTION_LOG',
            data: { log: adminActionLogs, key },
          });
        });
      console.log('logsCount!', logsCount);
      return resolve(dispatch({ type: 'ADMIN_ACTION_LOGS_COUNT', data: logsCount }));
    })).catch((err) => { console.log(err.message); });
}

export function updateRole(editUid, selectedRole, actionType, selectedName) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;


  if (!editUid || !selectedRole || selectedRole !== 'admin' || selectedRole !== 'tester' || selectedRole !== 'player') {
    return () => new Promise((resolve) => {
      FirebaseRef.child(`users/${editUid}/role`).set(selectedRole);

      try {
        AdminLogsRef().child(`admins/${editUid}/role`).set(selectedRole);
      } catch (error) {
        console.error('Error setting role:', error);
      }

      FirebaseRef.child(`users/${editUid}/name`).once('value').then(async (snapshot) => {
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        const userName = snapshot.val();
        AdminLogsRef().child('adminLogs/adminActions').push({
          type: actionType === 'addNewAdmin' ? 'addNewAdminPermission' : 'changeAdminPermission',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          data: {
            uid: editUid,
            role: selectedRole,
            name: userName || null,
          },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });
      });

      try {
        LeaderboardRef.child(`admins/${editUid}/role`).set(selectedRole);
      } catch (error) {
        console.error('Error setting role on Leaderboard:', error);
      }

      try {
        RoomsRef.child(`admins/${editUid}/role`).set(selectedRole);
      } catch (error) {
        console.error('Error setting role on Rooms:', error);
      }

      try {
        UserStatsRef().child(`admins/${editUid}/role`).set(selectedRole);
      } catch (error) {
        console.error('Error setting role on UserStats:', error);
      }

      try {
        TournamentsRef().child(`admins/${editUid}/role`).set(selectedRole);
      } catch (error) {
        console.error('Error setting role on Tournaments:', error);
      }

      try {
        StatusRef.child(`admins/${editUid}/role`).set(selectedRole);
      } catch (error) {
        console.error('Error setting role on Status:', error);
      }

      return resolve();
    });
  }

  return () => new Promise(resolve => resolve());
}


export function updateRoleArray(editUids = [], selectedRole) {
  if (!Array.isArray(editUids) || editUids.length === 0) {
    return () => Promise.resolve({ success: false, error: 'editUids missing' });
  }

  if (Firebase === null) {
    return () => Promise.resolve({ success: false, error: 'firebase null' });
  }

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return () => Promise.resolve({ success: false, error: 'admin UID error' });

  const adminEmail = Firebase?.auth()?.currentUser?.email || null;
  const adminName = Firebase?.auth()?.currentUser?.displayName || null;

  const isPermissionRole = Object.values(constants.PERMISSION_ROLES).includes(selectedRole);
  const isRankRole = Object.values(constants.RANK_ROLES).includes(selectedRole);

  if (!isPermissionRole && !isRankRole) {
    return () => Promise.resolve({ success: false, error: 'invalid role' });
  }

  return async () => {
    try {
      const usersData = [];
      const filteredUsersUpdates = {};

      const promises = editUids.map(async (uid) => {
        const userDataSnapshot = await FirebaseRef.child(`users/${uid}`).once('value');
        const userData = userDataSnapshot.val();

        if (isPermissionRole) {

          try {
            await FirebaseRef.child(`users/${uid}/role`).set(selectedRole);
            await AdminLogsRef().child(`admins/${uid}/role`).set(selectedRole);
            filteredUsersUpdates[uid] = { role: selectedRole };
          } catch (error) {
            console.log('error setting role:', error);
          }
        } else {

          if (selectedRole === constants.RANK_ROLES.vip) {
            const rankVIP = userData.rankVIP;
            const newRankVIP = !rankVIP;

            try {
              await FirebaseRef.child(`users/${uid}/rankVIP`).set(newRankVIP);
              filteredUsersUpdates[uid] = { rankVIP: newRankVIP };
            } catch (error) {
              console.log('error setting role:', error);
            }
          } else if (selectedRole === constants.RANK_ROLES.grasshopper) {
            const rankG = userData.rankG;
            const newRankG = !rankG;

            try {
              await FirebaseRef.child(`users/${uid}/rankG`).set(newRankG);
              filteredUsersUpdates[uid] = { rankG: newRankG };
            } catch (error) {
              console.log('error setting role:', error);
            }
          } else if (selectedRole === constants.RANK_ROLES.snail) {
            const rankS = userData.rankS;
            const newRankS = !rankS;

            try {
              await FirebaseRef.child(`users/${uid}/rankS`).set(newRankS);
              filteredUsersUpdates[uid] = { rankS: newRankS };
            } catch (error) {
              console.log('error setting role:', error);
            }
          } else if (selectedRole === constants.RANK_ROLES.curser) {
            const cursor = userData.cursor;
            const newCursor = !cursor;
            const newCursorExpire = newCursor ? Date.now() + 9999 * 24 * 60 * 60 * 1000 : undefined;

            try {
              await FirebaseRef.child(`users/${uid}`).update({
                cursor: newCursor,
                cursorExpire: newCursorExpire
              });
              filteredUsersUpdates[uid] = { cursor: newCursor, cursorExpire: newCursorExpire };
            } catch (error) {
              console.log('error setting role:', error);
            }
          }
        }

        usersData.push({
          uid,
          name: userData.name || null,
        });
      });

      await Promise.all(promises);

      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      await AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'changeUserRolesMultiple',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        data: {
          role: selectedRole,
          users: usersData.map(item => `uid: ${item.uid}, name: ${item.name}`).join('; ')
        },
        date: Firebase.database.ServerValue.TIMESTAMP,
      });

      return { success: true, filteredUsersUpdates };
    } catch (error) {
      return { success: false, error };
    }
  };
}





export function getStatistic(id, time, roundStart, roundTo, selectDate) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  if (roundStart === '') { roundStart = constants.STATISTICS_RANGE.start; }
  if (roundTo === '') { roundTo = constants.STATISTICS_RANGE.end; }
  let idStrings = '';

  idStrings = statisticsConst.statisticsTypes.filter(type => type.id === id)[0].link;

  console.log('getStatistic', id, time, roundStart, roundTo, idStrings, selectDate);

  // let endString;
  // let startString;
  // let endDate;
  // let startDate;
  // let startBalance;
  // let endBalance;

  const endString = new Date(Date.now()).toLocaleString('en-US', { timeZone: 'Europe/Riga' });
  let startString = new Date(constants.CALC_ACTIVATE_DATE_BY_TIME(time)).toLocaleString('en-US', { timeZone: 'Europe/Riga' });

  // For statistics that are filtered by month in front end only fetch data for coresponding month to optimize loading time
  // Select startString based on selectDate option in UI
  if (time.toString() === statisticsConst.STATISTICS_PERIOD_TIME.month.toString() && selectDate) {
    startString = new Date(selectDate).toLocaleString('en-US', { timeZone: 'Europe/Riga' });
  }

  console.log('startString', startString);

  const yyyy = new Date(endString).getFullYear().toString();
  let MM = (new Date(endString).getMonth() + 1).toString();
  let dd = new Date(endString).getDate().toString();
  let hh = new Date(endString).getHours().toString();

  if (MM < 10) { MM = `0${MM}`; }
  if (dd < 10) { dd = `0${dd}`; }
  if (hh < 10) { hh = `0${hh}`; }

  const endDate = `${yyyy}-${MM}-${dd}-${hh}`;

  const yyyy2 = new Date(startString).getFullYear().toString();
  let MM2 = (new Date(startString).getMonth() + 1).toString();
  let dd2 = new Date(startString).getDate().toString();
  let hh2 = new Date(startString).getHours().toString();

  if (MM2 < 10) { MM2 = `0${MM2}`; }
  if (dd2 < 10) { dd2 = `0${dd2}`; }
  if (hh2 < 10) { hh2 = `0${hh2}`; }

  // Fix so month statistics always start at 0 hour of first date
  if (time.toString() === statisticsConst.STATISTICS_PERIOD_TIME.month.toString() && selectDate) {
    hh2 = '00';
  }

  const startDate = `${yyyy2}-${MM2}-${dd2}-${hh2}`;

  console.log('startDate', startDate);

  return dispatch => new Promise((resolve) => {
    const promises = [];
    if (id === statisticsConst.LASTONLINEPLAYERS) {
      idStrings.map((idString) => {
        let endAt;
        let startAt;
        if (time === '1') {
          endAt = Date.now();
          startAt = constants.CALC_ACTIVATE_DATE_BY_TIME(7);
        } else if (time === '2') {
          endAt = constants.CALC_ACTIVATE_DATE_BY_TIME(7);
          startAt = constants.CALC_ACTIVATE_DATE_BY_TIME(30);
        } else if (time === '3') {
          endAt = constants.CALC_ACTIVATE_DATE_BY_TIME(30);
          startAt = constants.CALC_ACTIVATE_DATE_BY_TIME(90);
        } else if (time === '4') {
          endAt = constants.CALC_ACTIVATE_DATE_BY_TIME(90);
          startAt = constants.CALC_ACTIVATE_DATE_BY_TIME(180);
        } else if (time === '5') {
          endAt = constants.CALC_ACTIVATE_DATE_BY_TIME(180);
          startAt = constants.CALC_ACTIVATE_DATE_BY_TIME(360);
        } else if (time === '6') {
          endAt = constants.CALC_ACTIVATE_DATE_BY_TIME(360);
          startAt = '';
        }

        let firebaseProm;

        console.log('idString', idString);

        firebaseProm = UserStatsRef().child(`${idString}`)
          .orderByValue();

        if (time !== '6') {
          firebaseProm = firebaseProm.startAt(startAt).endAt(endAt);
        } else {
          firebaseProm = firebaseProm.endAt(endAt);
        }

        firebaseProm = firebaseProm.once('value', (snapshot) => {
          const statistics = snapshot.val() || {};
          const split = idString.split('/');
          dispatch({ type: 'ADMIN_STATISTICS_REPLACE', data: statistics, key: split[1] });
        });

        promises.push(firebaseProm);
        return null;
      });
    } else {
      idStrings.map((idString) => {
        let firebaseProm;

        console.log('time.toString()', time.toString());

        if (time.toString() === statisticsConst.STATISTICS_PERIOD_TIME.month.toString()) {
          if (id === statisticsConst.USERSCOINANALYSIS) {
            if (idString === 'players/activePlayersDay') {
              firebaseProm = AdminLogsRef().child(`statistics/${idString}`).orderByKey();
            } else {
              firebaseProm = AdminLogsRef().child(`statistics/${idString}`).orderByChild('date');
            }
          } else {
            // If has available startDate/endDate use these to filter, to dowloand only needed data.
            if (startDate && endDate) {
              firebaseProm = AdminLogsRef().child(`statistics/${idString}`).orderByKey().startAt(startDate).endAt(endDate);
            } else {
              firebaseProm = AdminLogsRef().child(`statistics/${idString}`).orderByKey();
            }
            // firebaseProm = AdminLogsRef().child(`statistics/${idString}`).orderByKey();
          }
        } else {
          if (id === statisticsConst.USERSCOINANALYSIS) {
            if (idString === filter(statisticsConst.statisticsTypes, ['id', statisticsConst.ACTIVEPLAYERDAY])[0].link) {
              firebaseProm = AdminLogsRef().child(`statistics/${idString}`).orderByKey()
            } else {
              if (idString === 'players/activePlayersDay' || idString === 'players/playersPerScreenSizeForEachScreenMode' || idString === 'players/playersPerScreenSizeForEachDesign') {
                firebaseProm = AdminLogsRef().child(`statistics/${idString}`).orderByKey();
                firebaseProm = firebaseProm.startAt(startDate).endAt(endDate);
              } else {
                firebaseProm = AdminLogsRef().child(`statistics/${idString}`)
                  .orderByChild('date')
                  .startAt(constants.CALC_ACTIVATE_DATE_BY_TIME(time))
                  .endAt(Date.now());
              }
            }
          } else {
            firebaseProm = AdminLogsRef().child(`statistics/${idString}`).orderByKey();

            if (idString.slice(-7) !== statisticsConst.STATISTICS_FILTER_TYPE.history) {
              firebaseProm = firebaseProm.startAt(startDate).endAt(endDate);
            }
          }
        }

        console.log('USERSCOINANALYSIS test4');

        firebaseProm = firebaseProm.once('value', (snapshot) => {
          const statistics = snapshot.val() || {};
          const split = idString.split('/');

          console.log('firebaseProm statistics');


          if (idString.slice(-12) === statisticsConst.STATISTICS_FILTER_TYPE.roundsPlayed) {
            Object.keys(statistics).map((key) => {
              let filtered = statistics[key];
              filtered = Object.keys(filtered).filter(key1 => (parseInt(key1, 10) >= parseInt(roundStart, 10) && parseInt(key1, 10) <= parseInt(roundTo, 10)))
                .reduce((obj, key2) => {
                  obj[key2] = filtered[key2];
                  return obj;
                }, {});
              statistics[key] = filtered;
              return null;
            });
          }
          console.log(time, "statistics test", statistics, idString, split);

          dispatch({ type: 'ADMIN_STATISTICS_REPLACE', data: statistics, key: split[split.length - 1] });
        });

        promises.push(firebaseProm);
        return null;
      });
    }

    Promise.all(promises).then(() => resolve());
  }).catch((err) => { console.log(err.message); });
}

// export function getStatisticPageViews(date, selectedEnvOption) {
//   if (Firebase === null) return () => new Promise(resolve => resolve());

//   const formattedDate = epochToDateString(date.getTime());

//   return dispatch => new Promise(resolve => AdminLogsRef().child(`statistics/players/viewsPerScreenNew/${formattedDate}/${selectedEnvOption.value}`)
//     .once('value', (snapshot) => {
//       const statisticsPageViews = snapshot.val() || {};
//       resolve(dispatch({
//         type: 'STATISTICS_PAGE_VIEWS',
//         data: statisticsPageViews,
//       }));
//     }));
// }


export function getStatisticPageViews(date, selectedEnvOption) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  
  const formattedDate = epochToDateString(date.getTime(), true);
  
  return dispatch => new Promise(resolve => {
    const promises = [];
    
    for (let hour = 0; hour < 24; hour++) {
      const hourString = hour.toString().padStart(2, '0');
      const dateWithHour = `${formattedDate}-${hourString}`;

      promises.push(
        AdminLogsRef()
          .child(`statistics/players/viewsPerScreenNew/${dateWithHour}/${selectedEnvOption.value}`)
          .once('value')
      );
    }
    
    Promise.all(promises).then(snapshots => {
      const totalData = {};
      
      snapshots.forEach(snapshot => {
        const hourlyData = snapshot.val() || {};
        
        Object.keys(hourlyData).forEach(platform => {
          if (!totalData[platform]) {
            totalData[platform] = {};
          }
          
          Object.keys(hourlyData[platform]).forEach(designMode => {
            if (!totalData[platform][designMode]) {
              totalData[platform][designMode] = {};
            }
            
            Object.keys(hourlyData[platform][designMode]).forEach(screenViewId => {
              if (!totalData[platform][designMode][screenViewId]) {
                totalData[platform][designMode][screenViewId] = {};
              }
              
              Object.keys(hourlyData[platform][designMode][screenViewId]).forEach(uid => {
                const currentCount = totalData[platform][designMode][screenViewId][uid] || 0;
                totalData[platform][designMode][screenViewId][uid] = 
                  currentCount + hourlyData[platform][designMode][screenViewId][uid];
              });
            });
          });
        });
      });
      
      resolve(dispatch({
        type: 'STATISTICS_PAGE_VIEWS',
        data: totalData,
      }));
    });
  });
}



export function getAllGifts() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('gifts2')
    .once('value', (snapshot) => {
      const gifts = snapshot.val() || {};
      resolve(dispatch({
        type: 'GET_ALL_GIFTS',
        data: gifts,
      }));
    }));
}

export function getAllDrinkGifts() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('drinks')
    .once('value', (snapshot) => {
      const drinkGifts = snapshot.val() || {};
      resolve(dispatch({
        type: 'GET_ALL_DRINK_GIFTS',
        data: drinkGifts,
      }));
    }));
}

export function setMobileVersion(version, platform, dev) {
  console.log('setMobileVersion', version, platform, dev);
  if (!Firebase) {
    return () => Promise.resolve({ status: 'error', message: 'firebase not initialized' });
  }

  if (!version || !platform) {
    return () => Promise.resolve({ status: 'error', message: 'missing version or platform' });
  }

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise((resolve) => {
    const key = dev
      ? `settings/${platform}VersionDev`
      : `settings/${platform}Version`;

    return FirebaseRef.child(key)
      .set(version)
      .then(async () => {
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'changeMobileVersion',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          data: {
            version,
            platform,
            dev: dev ? 'dev' : 'prod',
          },
          date: Firebase.database.ServerValue.TIMESTAMP,
        })
          .then(() => resolve({ status: 'success' }))
      })
      .catch((error) => resolve({ status: 'error', message: error.message }));
  });
}

export function getMobileVersion(platform, dev) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  if (dev) {
    return () => new Promise(resolve => FirebaseRef.child(`settings/${platform}VersionDev`).once('value', (snapshot) => {
      const mobileVersion = snapshot.val() || null;

      return resolve({ data: mobileVersion });
    }));
  }
  return () => new Promise(resolve => FirebaseRef.child(`settings/${platform}Version`).once('value', (snapshot) => {
    const mobileVersion = snapshot.val() || null;

    return resolve({ data: mobileVersion });
  }));
}


export function setTreasureChestEnabled(value) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise(async (resolve) => {
    if (value) {
      FirebaseRef.child('settings/treasureChestEnabled').set(true);
    } else {
      FirebaseRef.child('settings/treasureChestEnabled').remove();
    }

    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'changeTreasureChestEnabled',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      data: {
        status: value ? 'enabled' : 'disabled',
      },
      date: Firebase.database.ServerValue.TIMESTAMP,
    });

    return resolve();
  });
}

export function getTreasureChestEnabled() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return () => new Promise(resolve => FirebaseRef.child('settings/treasureChestEnabled').once('value', (snapshot) => {
    const treasureChestEnabled = snapshot.val() || null;

    return resolve({ data: treasureChestEnabled });
  }));
}


export function getUserAchievements(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    let userAchievements;
    let claimedAchievements;
    let claimedAchievementsHistory;

    let gamesPlayed;
    let gamesWon;

    const promises = [];

    promises.push(new Promise(resolve2 => FirebaseRef.child(`users/${uid}/gPlayed`)
      .once('value', (snapshot) => {
        gamesPlayed = snapshot.val() || 0;

        return resolve2();
      }, (err) => {
        console.log(err);
        gamesPlayed = 0;
        return resolve2();
      })));

    promises.push(new Promise(resolve2 => FirebaseRef.child(`users/${uid}/gWon`)
      .once('value', (snapshot) => {
        gamesWon = snapshot.val() || 0;

        return resolve2();
      }, (err) => {
        console.log(err);
        gamesWon = 0;
        return resolve2();
      })));

    promises.push(new Promise(resolve2 => FirebaseRef.child(`userAchievements/${uid}`)
      .once('value', (snapshot) => {
        userAchievements = snapshot.val() || {};

        return resolve2();
      }, (err) => {
        console.log(err);
        userAchievements = {};
        return resolve2();
      })));

    promises.push(new Promise(resolve2 => FirebaseRef.child(`claimedAchievements/${uid}`)
      .once('value', (snapshot) => {
        claimedAchievements = snapshot.val() || {};

        return resolve2();
      }, (err) => {
        console.log(err);
        claimedAchievements = {};
        return resolve2();
      })));

    promises.push(new Promise(resolve2 => FirebaseRef.child(`claimedAchievementsHistory/${uid}`)
      .once('value', (snapshot) => {
        claimedAchievementsHistory = snapshot.val() || {};

        return resolve2();
      }, (err) => {
        console.log(err);
        claimedAchievementsHistory = {};
        return resolve2();
      })));

    return Promise.all(promises).then(() => resolve(dispatch({
      type: 'USER_ACHIEVEMENTS',
      data: {
        userAchievements,
        claimedAchievements,
        claimedAchievementsHistory,
        gamesPlayed,
        gamesWon,
      },
    })));
  });
}

export function getUserSettings(uid) {
  console.log('getUserSettings', uid);

  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return () => new Promise(async (resolve) => {
    let usersSettings;
    let mobileNotifcationSettings;

    const promises = [];

    await new Promise((resolve2) => FirebaseRef.child(`usersSettings/${uid}`)
      .once('value', (snapshot) => {
        usersSettings = snapshot.val() || null;

        console.log('snapshot.val() ', snapshot.val());

        return resolve2();
      }, (err) => {
        console.log('err', err);
        usersSettings = null;
        return resolve2();
      }));

    console.log('usersSettings1', usersSettings);

    if (!usersSettings || !usersSettings.notificationSettings) {
      promises.push(new Promise((resolve2) => FirebaseRef.child(`userSettings/${uid}`)
        .once('value', (snapshot2) => {
          mobileNotifcationSettings = snapshot2.val() || null;

          console.log('mobileNotifcationSettings', mobileNotifcationSettings);

          return resolve2();
        }, (err) => {
          console.log('mobileNotifcationSettings err', err);
          mobileNotifcationSettings = null;
          return resolve2();
        })));
    }

    return Promise.all(promises).then(() => {
      console.log('usersSettings2', usersSettings);

      let finalUsersSettings;

      if (mobileNotifcationSettings) {
        if (usersSettings) {
          finalUsersSettings = { ...usersSettings, notificationSettings: mobileNotifcationSettings };
        } else {
          finalUsersSettings = { notificationSettings: mobileNotifcationSettings };
        }
      } else {
        finalUsersSettings = { ...usersSettings };
      }
      console.log('usersSettings 2', finalUsersSettings);

      resolve(finalUsersSettings)
    });
  });
};

export function getAutoPlayOtherUser(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return () => new Promise((resolve) => {
    let disabledAutoPlay;

    const promises = [];

    promises.push(new Promise((resolve2) => FirebaseRef.child(`users/${uid}/disableAutoPlay`)
      .once('value', (snapshot) => {
        disabledAutoPlay = snapshot.val() || false;

        return resolve2();
      }, (err) => {
        disabledAutoPlay = false;
        return resolve2();
      })));

    return Promise.all(promises).then(() => resolve(disabledAutoPlay));
  });
}

export function updateProfile(formData) {
  const {
    // userId,
    firstName,
    lastName,
    photo,
  } = formData;

  return () => new Promise(async (resolve, reject) => {
    // Are they a user?
    const UID = Firebase.auth().userId;

    if (!UID) {
      return reject({
        // message: errorMessages.missingFirstName
      });
    }

    // Validation rules
    if (!firstName) {
      return reject({
        // message: errorMessages.missingFirstName
      });
    }
    if (!lastName) {
      return reject({
        // message: errorMessages.missingLastName
      });
    }

    const updateProfileFunction = Firebase.app()
      .functions()
      .httpsCallable('updateProfile');

    return updateProfileFunction({
      firstName,
      lastName,
      photo,
    })
      .then(() => {
        // getUserData(dispatch);
        // console.log('###############', res);
        // if (res.data.message == 'maxNameChangeLimit' && res.data.status == 'error') {
        //   return resolve({ status: 'error', message: 'maxNameChangeLimit' });
        // }
        // return resolve({ status: 'success' });
      })
      .catch(() => reject({
        // message: errorMessages.errorUpdating
      }));
  }).catch((err) => {
    console.log(err);
    throw err;
  });
}

export function fetchFeedbackHistory(selectedId, design, platform) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  // FirebaseRef.child(`feedbackHistory/${selectedId}`).off();

  return dispatch => new Promise(resolve => FirebaseRef.child(`feedbackHistory/${selectedId}`)
    .once('value', (snapshot) => {
      const allFeedbackHistory = snapshot.val() || {};
      const array = [];
      let totalBal = 0;
      forEach(allFeedbackHistory, (item, key) => {
        if (item.design === design.value && item.platform === platform.value && parseFloat(item.rating) > 0) {
          array.push({ key, selectedId, ...item });
          totalBal += parseFloat(item.rating) > 0 ? parseFloat(item.rating) : 0;
        }
      });
      array.sort((a, b) => (b.lastFeedback - a.lastFeedback));
      return resolve(dispatch({ type: 'ADMIN_FEEDBACKS_HISTORY_REPLACE', data: array, totalRating: totalBal }));
    })).catch((err) => { console.log(err.message); });
}

export function getAllFeedbacks() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  FirebaseRef.child('feedbackHistory').off();

  return dispatch => new Promise(resolve => FirebaseRef.child(`feedbackHistory`)
    .on('value', (snapshot) => {
      const allFeedbackHistory = snapshot.val() || {};
      const array = [];
      let totalBal = 0;
      forEach(allFeedbackHistory, (items, key) => {
        forEach(items, (item, idx) => {
          if (item.rating && parseFloat(item.rating) > 0) {
            array.push({ key, feedbackId: idx, ...item });
            totalBal += parseFloat(item.rating) > 0 ? parseFloat(item.rating) : 0;
          }
        });
      });
      array.sort((a, b) => (b.lastFeedback - a.lastFeedback));
      return resolve(dispatch({ type: 'ADMIN_FEEDBACKS_REPLACE', data: array, totalRating: totalBal }));
    })).catch((err) => { console.log(err.message); });
}

export function getFeedbacks() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  return dispatch => new Promise(resolve => {
    dispatch({ type: 'ADMIN_MULTIPLE_FEEDBACKS_REPLACE', data: {}, feedbackLoading: true });

    FirebaseRef.child('feedback').off();

    FirebaseRef.child('feedback')
    .on('value', (snapshot) => {
      const allFeedbacks = snapshot.val() || {};
      console.log(allFeedbacks, "check===========")
      return resolve(dispatch({ type: 'ADMIN_MULTIPLE_FEEDBACKS_REPLACE', data: allFeedbacks, feedbackLoading: false }));
    })
  }).catch((err) => { console.log(err.message); });
}

export function getFeedbacksResults() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  return dispatch => new Promise(resolve => {
    dispatch({ type: 'ADMIN_MULTIPLE_FEEDBACKS_RESULTS_REPLACE', data: {}, feedbackResultsLoading: true });

    FirebaseRef.child('feedbackResults').off();

    FirebaseRef.child('feedbackResults')
    .on('value', (snapshot) => {
      const allFeedbackResults = snapshot.val() || {};
      return resolve(dispatch({ type: 'ADMIN_MULTIPLE_FEEDBACKS_RESULTS_REPLACE', data: allFeedbackResults, feedbackResultsLoading: false }));
    })
  }).catch((err) => { console.log(err.message); });
}


export function getEditorData() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  return dispatch => new Promise(resolve => FirebaseRef.child('versionHistory')
    .orderByChild('versionDate')
    .once('value', (snapshot) => {
      const data = snapshot.val() || null;

      const array = [];

      Object.keys(data).map((key) => {
        array.push({ key, ...data[key] });
        return null;
      });

      array.sort((a, b) => (b.versionDate - a.versionDate));

      return resolve(dispatch({ type: 'ADMIN_VERSION_REPLACE', data: array }));
    }).catch((err) => {
      console.log(err);
      return resolve(null);
    }));
}

export function updateEditorData(selectId, data, versionDate) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;


  if (!UID) return () => new Promise(resolve => resolve());
  if (!data || !versionDate) return () => new Promise(resolve => resolve());
  const versionFormatDate = Date.parse(versionDate);
  return () => new Promise((resolve, reject) => {
    FirebaseRef.child(`versionHistory/${selectId}`).update({
      versionDate: versionFormatDate,
      [constants.sendLanguage.lv]: data.lv,
      [constants.sendLanguage.en]: data.en,
      [constants.sendLanguage.ru]: data.ru,
    })
      .then(async () => {
        const actionData = {
          versionDate: dateFormat(versionFormatDate),
          [constants.sendLanguage.lv]: stripHtmlTags(data.lv),
          [constants.sendLanguage.en]: stripHtmlTags(data.en),
          [constants.sendLanguage.ru]: stripHtmlTags(data.ru),
        }
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'editVersionHistory',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          versionId: selectId,
          data: { ...actionData, versionId: selectId },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });
        resolve({ status: constants.SERVER_STATUS_CODE.success })
      })
      .catch((err) => { console.log(err); return reject({ status: constants.SERVER_STATUS_CODE.error }); });
  });
}

export function addEditerData(data, versionDate) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;


  if (!UID) return () => new Promise(resolve => resolve());

  if (!data || !versionDate) return () => new Promise(resolve => resolve());
  const versionFormatDate = Date.parse(versionDate);
  return () => new Promise((resolve, reject) => {
    console.log('update path', { data, versionDate });
    //  return resolve();
    // const versionFormatDate = dateFormatMoment(versionDate, constants.FORMAT_DATE_TYPE.pointsfullDate);
    FirebaseRef.child('versionHistory').push({
      versionDate: versionFormatDate,
      [constants.sendLanguage.lv]: data.lv,
      [constants.sendLanguage.en]: data.en,
      [constants.sendLanguage.ru]: data.ru,
    })
      .then(async () => {
        const actionData = {
          versionDate: dateFormat(versionFormatDate),
          [constants.sendLanguage.lv]: stripHtmlTags(data.lv),
          [constants.sendLanguage.en]: stripHtmlTags(data.en),
          [constants.sendLanguage.ru]: stripHtmlTags(data.ru),
        }
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'addVersionHistory',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          data: { ...actionData },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });
        resolve({ status: constants.SERVER_STATUS_CODE.success })
      })
      .catch((err) => { console.log(err, "version history"); return reject({ status: constants.SERVER_STATUS_CODE.error }); });
  });
}

export function deleteEditor(selectId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;
  return () => new Promise((resolve, reject) => {
    FirebaseRef.child(`versionHistory/${selectId}`)
      .remove()
      .then(async () => {
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'deleteVersionHistory',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          data: { versionId: selectId },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });
        resolve({ status: constants.SERVER_STATUS_CODE.success })
      })
      .catch((err) => { console.log(err); return reject({ status: constants.SERVER_STATUS_CODE.error }); });
  });
}

export function blogImageFileUpload(fileUpload) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  if (fileUpload !== '') {
    return () => new Promise((resolve) => {
      const uploadTask = FirebaseStorage.ref(`/blogImages/${(Date.now().toString())}`)
        .put(fileUpload);

      uploadTask.on('state_changed',
        (snapshot) => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log('File available at', downloadURL);
            resolve({ status: 'success', url: downloadURL });
          });
        });
    });
  }
  return () => new Promise(resolve => resolve());
}

export function addBlogEditerData(data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return () => new Promise(resolve => resolve());

  const {
    blogDate, enTitle, lvTitle, ruTitle, enDescription, lvDescription, ruDescription, imageUrl,
  } = data;

  const blogFormatDate = Date.parse(blogDate);

  if (!lvTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVTitle })); }
  if (!enTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENTitle })); }
  if (!ruTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUTitle })); }
  if (!lvDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVDescription })); }
  if (!enDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENDescription })); }
  if (!ruDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUDescription })); }
  if (!imageUrl) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }

  return () => new Promise((resolve, reject) => {
    FirebaseRef.child('blogs').push({
      blogDate: blogFormatDate,
      titleLV: lvTitle,
      titleEN: enTitle,
      titleRU: ruTitle,
      descriptionLV: lvDescription,
      descriptionEN: enDescription,
      descriptionRU: ruDescription,
      imageUrl,
      urlString: toUrlString(enTitle),
    })
      .then(async () => {
        const actionData = {
          blogDate: dateFormat(blogFormatDate),
          titleLV: lvTitle,
          titleEN: enTitle,
          titleRU: ruTitle,
          descriptionLV: stripHtmlTags(lvDescription),
          descriptionEN: stripHtmlTags(enDescription),
          descriptionRU: stripHtmlTags(ruDescription),
          imageUrl,
        };

        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        return AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'addBlog',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          date: Firebase.database.ServerValue.TIMESTAMP,
          data: { ...actionData },
        });
      })
      .then(() => resolve({ status: constants.SERVER_STATUS_CODE.success }))
      .catch((err) => {
        console.log(err);
        return reject({ status: constants.SERVER_STATUS_CODE.error });
      });
  });
}

export function getBlogEditorData() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  return dispatch => new Promise(resolve => FirebaseRef.child('blogs')
    .orderByKey()
    .once('value', (snapshot) => {
      const data = snapshot.val() || {};
      const array = [];

      Object.keys(data).map((key) => {
        array.push({ key, ...data[key] });
        return null;
      });

      array.sort((a, b) => (b.blogDate - a.blogDate));

      return resolve(dispatch({ type: 'ADMIN_BLOGS_REPLACE', data: array }));
    }).catch((err) => {
      console.log(err);
      return resolve(null);
    }));
}

export function updateBlogEditorData(data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return () => new Promise(resolve => resolve());
  const {
    selectId, blogDate, enTitle, lvTitle, ruTitle, enDescription, lvDescription, ruDescription, imageUrl,
  } = data;

  if (!selectId) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingData })); }
  if (!lvTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVTitle })); }
  if (!enTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENTitle })); }
  if (!ruTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUTitle })); }
  if (!lvDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVDescription })); }
  if (!enDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENDescription })); }
  if (!ruDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUDescription })); }
  if (!imageUrl) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }

  const blogFormatDate = Date.parse(blogDate);
  return () => new Promise((resolve, reject) => {
    FirebaseRef.child(`blogs/${selectId}`).update({
      blogDate: blogFormatDate,
      titleLV: lvTitle,
      titleEN: enTitle,
      titleRU: ruTitle,
      descriptionLV: lvDescription,
      descriptionEN: enDescription,
      descriptionRU: ruDescription,
      imageUrl,
      urlString: toUrlString(enTitle),
    })
      .then(async () => {
        const actionData = {
          blogDate: dateFormat(blogFormatDate),
          titleLV: lvTitle,
          titleEN: enTitle,
          titleRU: ruTitle,
          descriptionLV: stripHtmlTags(lvDescription),
          descriptionEN: stripHtmlTags(enDescription),
          descriptionRU: stripHtmlTags(ruDescription),
          imageUrl,
        };

        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        return AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'updateBlog',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          date: Firebase.database.ServerValue.TIMESTAMP,
          data: { id: selectId, ...actionData },
        });
      })
      .then(() => resolve({ status: constants.SERVER_STATUS_CODE.success }))
      .catch((err) => {
        console.log(err);
        reject({ status: constants.SERVER_STATUS_CODE.error });
      });
  });
}

export function deleteBlogEditor(selectId, titleEn) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise((resolve, reject) => {
    FirebaseRef.child(`blogs/${selectId}`)
      .remove()
      .then(async () => {
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        return AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'deleteBlog',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          date: Firebase.database.ServerValue.TIMESTAMP,
          data: { id: selectId, titleEn },
        });
      })
      .then(() => resolve({ status: constants.SERVER_STATUS_CODE.success }))
      .catch((err) => {
        console.log(err);
        return reject({ status: constants.SERVER_STATUS_CODE.error });
      });
  });
}

export function deleteUserFeedback(userId, selectId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return () => new Promise((resolve, reject) => {
    FirebaseRef.child(`feedback/${userId}/${selectId}`)
      .remove()
      .then(() => resolve({ status: constants.SERVER_STATUS_CODE.success }))
      .catch((err) => { console.log(err); return reject({ status: constants.SERVER_STATUS_CODE.error }); });
  });
}

// Possibly unnused anymore, should remove
export function checkFeedbackTimeToDelete() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('settings/feedback')
    .once('value', (snapshot) => {
      const feedbackSetting = snapshot.val() || {};

      console.log({ feedbackSetting });
      let feedbackStartTime = false;
      const nowDate = Date.parse(new Date());
      if (feedbackSetting && feedbackSetting.feedbackStart) {
        if (feedbackSetting.feedbackStartTime) {
          feedbackStartTime = nowDate > constants.CALC_ACTIVE_FEEDBACK_TIME(feedbackSetting.feedbackStartTime, constants.FEEDBACK_SHOW_TIME_RANGE.end);
        } else {
          feedbackStartTime = true;
        }
      } else {
        feedbackStartTime = true;
      }

      const previousFeedbackTime = feedbackSetting.feedbackStartTime || 0;
      return resolve(dispatch({ type: 'START_FEEDBACK_TIME', data: feedbackStartTime, previousFeedbackTime }));
    }).catch((err) => {
      console.log(err);
      return resolve(null);
    }));
}

/*
function generateRandom(min = 0, max = 100) {
  const difference = max - min;
  let rand = Math.random();
  rand = Math.floor(rand * difference);
  rand += min;
  return rand;
} */

// Possibly unnused anymore, should remove
export function startFeedbackToDelete() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());
  return () => new Promise((resolve, reject) => {
    FirebaseRef.child('settings/feedback').set({
      feedbackStartTime: Date.parse(new Date()),
      feedbackStart: true,
      devModal: true,
    })
      .then(() => resolve({ status: constants.SERVER_STATUS_CODE.success })).catch((err) => {
        console.log(err);
        return reject({ status: constants.SERVER_STATUS_CODE.error });
      });
  });
}

// Possibly unnused anymore, should remove
export function stopFeedbackToDelete() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());
  return () => new Promise((resolve, reject) => {
    FirebaseRef.child('settings/feedback').set({
      feedbackStart: false,
    })
      .then(() => resolve({ status: constants.SERVER_STATUS_CODE.success })).catch((err) => {
        console.log(err);
        return reject({ status: constants.SERVER_STATUS_CODE.error });
      });
  });
}



export function getSuspicisousTransactionsPlayers() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const endString = Date.now();
  const startString = constants.CALC_ACTIVATE_DATE_BY_TIME(constants.WEEKLY_VALUE.twoWeek);
  return dispatch => new Promise(resolve => FirebaseRef.child('completedPayments')
    .orderByChild('dateInitiated')
    .startAt(startString)
    .endAt(endString)
    .once('value', async (snapshot) => {
      const suspiciousTransactions = snapshot.val() || {};

      const dateTransactions = {};
      const dateSuspiciousPlayers = {};

      map(suspiciousTransactions, async (trans, key) => {
        const transDate = moment(new Date(trans.dateInitiated).toLocaleString(statisticsConst.STATISTICS_ADMIN_TIMEZONE.timelocal, { timeZone: statisticsConst.STATISTICS_ADMIN_TIMEZONE.timezone })).format(constants.FORMAT_DATE_TYPE.fullDayMonth);
        dateTransactions[key] = {
          ...trans,
          formatDate: transDate,
        };
      });

      if (dateTransactions) {
        await Promise.all(map(dateTransactions, async (item, key) => {
          const userFirebaseProm = await FirebaseRef.child(`users/${item.userUid}`).once('value');
          const user = userFirebaseProm.val();
          if (user) {
            if (!find(dateSuspiciousPlayers, findItem => findItem.formatDate === item.formatDate && findItem.userUid === item.userUid)) {
              const filterData = filter(dateTransactions, filterItem => filterItem.formatDate === item.formatDate && filterItem.userUid === item.userUid);
              if (size(filterData) >= 5) {
                const userName = user.name || '--';
                dateSuspiciousPlayers[key] = {
                  formatDate: item.formatDate,
                  count: size(filterData),
                  userUid: item.userUid,
                  name: userName,
                  dateInitiated: item.dateInitiated,
                };
              }
            }
          }
        }));
      }
      return resolve(dispatch({ type: 'ADMIN_SUSPICISOUS_TRANSACTIONS_REPLACE', data: dateSuspiciousPlayers, allSuspiciousTransactions: dateTransactions }));
    })).catch((err) => { console.log(err.message); });
}

export function getSuspiciousFoldPlayers() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const endString = Date.now();
  const startString = constants.CALC_ACTIVATE_DATE_BY_TIME(constants.WEEKLY_VALUE.twoWeek);

  console.log('getSuspiciousFoldPlayers', endString, startString)

  return dispatch => new Promise(resolve => AdminLogsRef().child('roomsTogether/quitRounds')
    .orderByChild('dateAdded')
    .startAt(startString)
    .endAt(endString)
    .once('value', async (snapshot) => {
      const data = snapshot.val() || {};
      const array = [];

      console.log('getSuspiciousFoldPlayers data', data);

      await Promise.all(Object.keys(data).map(async (key) => {
        const globalRoomData = await AdminLogsRef().child(`roomsTogether/rooms/${data[key].roomId}`).once('value');
        const userFirebaseProm = await FirebaseRef.child(`users/${data[key].uid}/name`).once('value');
        const userName = userFirebaseProm.val();
        const roomData = globalRoomData.val();

        console.log("roomData", roomData);

        const checkUser = userName ? userName : '--';
        let checkRoom = false;
        if (roomData && roomData.date) {
          checkRoom = true;
        }

        console.log('checkUser', checkUser, key);

        if (data[key].count >= 5) {
          array.push({ key, ...data[key], supiciousFold: true, userName: checkUser });
        }
      }));

      console.log('getSuspiciousFoldPlayers array', array);

      await array.sort((a, b) => (b.dateAdded - a.dateAdded));

      return resolve(dispatch({ type: 'SUSPICIOUS_FOLD_PLAYERS', data: filter(array, item => item.supiciousFold) }));
    }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
}

export function getGlobalRoomData(roomId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    AdminLogsRef().child(`roomsTogether/rooms/${roomId}`).once('value', (snapShot) => {
      const data = snapShot.val() || {};

      console.log('getGlobalRoomData data', data);

      if (data) {
        AdminLogsRef().child(`roomsTogether/playerRooms/${data.player1}/${data.player2}`)
          .orderByChild('roomId')
          .equalTo(roomId)
          .once('value', (snapshot) => {
            const rooms = snapshot.val() || {};

            console.log('getGlobalRoomData rooms', rooms);

            return resolve(dispatch({ type: 'ADMIN_ROOM_GLOBAL_PARAMS', data: rooms }));
          });
      }
    });
  });
}
export function editUserDob(editUserId, dob) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (dob) {
    if (Date.parse(dob) < Date.parse(constants.LIMIT_DATE_RANGE.minDate) || Date.parse(dob) > Date.parse(constants.LIMIT_DATE_RANGE.maxDate)) {
      return () => new Promise(resolve => resolve({ status: constants.SERVER_STATUS_CODE.error, message: errorMessages.wrongDate }));
    }
  }

  const birthday = dob ? Date.parse(dob) : null;
  return () => new Promise((resolve) => {
    FirebaseRef.child(`users/${editUserId.toString()}`).update({
      birthday,
    }).then(() => {
      FirebaseRef.child(`users/${editUserId.toString()}/name`).once('value').then(async (snapshot) => {
        const userName = snapshot.val();
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'editDob',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          userId: editUserId.toString(),
          userName,
          data: {
            birthday: dob ? dateFormat(dob) : null,
          },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });

        return resolve({ status: constants.SERVER_STATUS_CODE.success });
      });
    }).catch((err) => {
      console.log(err);
      return resolve({ status: constants.SERVER_STATUS_ERROR.error });
    });
  });
}

export function editUserNote(editUserId, userNote, userName) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise((resolve) => {
    FirebaseRef.child(`users/${editUserId.toString()}`).update({
      userNote,
    }).then(async (res) => {
      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'addNote',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        userId: editUserId.toString(),
        userName,
        data: {
          userNote,
        },
        date: Firebase.database.ServerValue.TIMESTAMP,
      });
      return resolve({ status: constants.SERVER_STATUS_CODE.success });
    }).catch((err) => {
      console.log(err);
      return resolve({ status: constants.SERVER_STATUS_ERROR.error });
    });
  });
}

export function getUserLastIp(userUid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return null;

  return dispatch => new Promise(resolve => FirebaseRef.child(`usersLastIp/${userUid}`)
    .once('value', (snapshot) => {
      const lastIpData = snapshot.val() ? { userUid: userUid, IP: snapshot.val() } : {};

      return resolve(dispatch({ type: 'ADMIN_LAST_IP_REPLACE', data: lastIpData }));
    })).catch((err) => { console.log(err.message); });
}

export function getNotifications() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return null;

  FirebaseRef.child('notifications').off();

  return dispatch => new Promise(resolve => FirebaseRef.child('notifications')
    .on('value', (snapshot) => {
      const allNotifications = snapshot.val() || {};

      console.log(allNotifications, 'all notifications');

      return resolve(dispatch({ type: 'ADMIN_NOTIFICATIONS_REPLACE', data: allNotifications }));
    })).catch((err) => { console.log(err.message); });
}

export function addNotification(data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const {
    lvTitle, enTitle, ruTitle, lvText, enText, ruText, notifyIdentifier, notificationDate, notificationType, showNotification,
  } = data;

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise((resolve, reject) => {
    FirebaseRef.child('notifications').push({
      lvTitle,
      enTitle,
      ruTitle,
      lvText,
      enText,
      ruText,
      notifyIdentifier,
      notificationDate: Date.parse(notificationDate),
      notificationType,
      showNotification,
    })
      .then(async () => {
        const logsData = { ...data, notificationDate: dateFormat(notificationDate) };

        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'addNotification',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          data: { ...logsData },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });
        return resolve({ status: constants.SERVER_STATUS_CODE.success });
      })
      .catch(() => reject({ status: constants.SERVER_STATUS_CODE.error }));
  });
}

export function editNotification({ data, oldData }) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const {
    selectNotificationId, lvTitle, enTitle, ruTitle, lvText, enText, ruText, notifyIdentifier, notificationDate, notificationType, showNotification,
  } = data;
  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise(resolve => FirebaseRef.child(`notifications/${selectNotificationId}`).update({
    lvTitle,
    enTitle,
    ruTitle,
    lvText,
    enText,
    ruText,
    notifyIdentifier,
    notificationDate: Date.parse(notificationDate),
    notificationType,
    showNotification,
  }).then(async () => {
    const changesObj = {};
    Object.keys(data).map((key) => {
      if ((key !== 'notificationDate' && oldData[key] !== data[key]) || (key === 'notificationDate' && Date.parse(oldData[key]) !== Date.parse(data[key]))) {
        changesObj[key] = { new: data[key], old: oldData[key] };
      }
      return null;
    });
    let changedlog = '';
    Object.keys(changesObj).map((key, index) => {
      changedlog += `${key} ${key === 'notificationDate' ? dateFormat(new Date(changesObj[key].old)) : changesObj[key].old} to ${key === 'notificationDate' ? dateFormat(new Date(changesObj[key].new)) : changesObj[key].new}`;

      if ((index + 1) !== Object.keys(changesObj).length) {
        changedlog += ', ';
      }
      return null;
    });
    console.log(changedlog, 'check edit notification data');

    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'editNotification',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      notificationId: selectNotificationId,
      data: {
        ...data,
        changedlog,
      },
      date: Firebase.database.ServerValue.TIMESTAMP,
    });

    return resolve({ status: constants.SERVER_STATUS_CODE.success });
  })).catch((err) => { console.log(err.message); });
}

export function deleteNotification(selectNotificationId, notifyIdentifier) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise(resolve => Firebase.auth().onAuthStateChanged(() => {
    FirebaseRef.child(`notifications/${selectNotificationId}`).remove().then(async () => {
      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'deleteNotification',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        selectNotificationId,
        data: {
          selectNotificationId,
          notifyIdentifier,
        },
        date: Firebase.database.ServerValue.TIMESTAMP,
      });
      return resolve({ status: constants.SERVER_STATUS_CODE.success });
    });
  }));
}


const getMultiAccountPairsFunction = (dispatch) => {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return new Promise(resolve => FirebaseRef.child('multiAccounts').once('value', (snapshot) => {
    const data = snapshot.val() || {};

    resolve(dispatch({
      type: 'MULTI_ACCOUNTS',
      data,
    }));
  }).catch(() => {
    resolve();
  }));
};

export function getMultiAccountPairs() {
  return dispatch => getMultiAccountPairsFunction(dispatch);
}

export function addMultiAccountsArray(uids = []) {
  if (Firebase === null) return () => Promise.resolve();
  if (!Array.isArray(uids) || uids.length < 2) return () => Promise.resolve();

  return dispatch => new Promise(async (resolve) => {
    try {
      const UID = Firebase?.auth()?.currentUser?.uid || null;
      const adminEmail = Firebase?.auth()?.currentUser?.email || null;
      const adminName = Firebase?.auth()?.currentUser?.displayName || null;

      const rootUid = uids[0];

      const namePromises = uids.map(uid =>
        FirebaseRef.child(`users/${uid}/name`).once("value")
      );

      const nameSnapshots = await Promise.all(namePromises);

      const namesMap = {};
      nameSnapshots.forEach((snap, index) => {
        namesMap[uids[index]] = snap.val() || null;
      });

      const existingRootSnap = await FirebaseRef.child(`multiAccounts/${rootUid}/${rootUid}`).once("value");
      const existingRoot = existingRootSnap.val() || null;

      await FirebaseRef.child(`multiAccounts/${rootUid}/${rootUid}`).update({
        uid: rootUid,
        name: namesMap[rootUid],
        date: Firebase.database.ServerValue.TIMESTAMP,
        ...(existingRoot ? {} : { dateCreated: Firebase.database.ServerValue.TIMESTAMP })
      });

      for (const uid of uids) {
        if (uid === rootUid) continue;
        await FirebaseRef.child(`multiAccounts/${rootUid}/${uid}`).update({
          uid,
          name: namesMap[uid],
          date: Firebase.database.ServerValue.TIMESTAMP,
        });
      }

      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child("adminLogs/adminActions").push({
        type: "addMultiAccountArray",
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        data: {
          players: uids
            .map(currentUid => `uid: ${currentUid}, name: ${namesMap[currentUid] || null}`)
            .join("; ")
        },
        date: Firebase.database.ServerValue.TIMESTAMP,
      });

      await getMultiAccountPairsFunction(dispatch);

      resolve();

    } catch (err) {
      console.error("addMultiAccounts error:", err);
      resolve();
    }
  });
}

export function addMultiAccountPair(uid1, uid2, isNewGroup) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  if (!uid1 || !uid2) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  const promise1 = FirebaseRef.child(`users/${uid1}/name`).once('value');
  const promise2 = FirebaseRef.child(`users/${uid2}/name`).once('value');
  const promise3 = FirebaseRef.child(`multiAccounts/${uid1}/${uid1}`).once('value');

  return dispatch => new Promise(resolve => Promise.all([promise1, promise2, promise3]).then(async (promisesRes) => {
    let name1;
    let name2;
    let exisitngMultiAccounts;

    promisesRes.map((resp, index) => {
      if (index === 0) {
        name1 = resp.val() || null;
      } else if (index === 1) {
        name2 = resp.val() || null;
      } else if (index === 2) {
        exisitngMultiAccounts = resp.val() || null;
      }
      return null;
    });

    console.log('exisitngMultiAccounts', exisitngMultiAccounts, uid1, uid2);

    await FirebaseRef.child(`multiAccounts/${uid1}/${uid2}`).update({
      uid: uid2,
      name: name2,
      date: Firebase.database.ServerValue.TIMESTAMP,
    }).then(async () => {
      if (exisitngMultiAccounts) {
        await FirebaseRef.child(`multiAccounts/${uid1}/${uid1}`).update({
          uid: uid1,
          name: name1,
          date: Firebase.database.ServerValue.TIMESTAMP,
        });
      } else {
        await FirebaseRef.child(`multiAccounts/${uid1}/${uid1}`).update({
          uid: uid1,
          name: name1,
          date: Firebase.database.ServerValue.TIMESTAMP,
          dateCreated: Firebase.database.ServerValue.TIMESTAMP,
        });
      }

      const userId = `uid1: ${uid1}, uid2: ${uid2}`;
      const userName = `name1: ${name1}, name2: ${name2}`;
      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: isNewGroup ? 'addMultiAccountPair' : 'addMultiAccount',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        uid1: uid1 || null,
        uid2: uid2 || null,
        userId,
        userName,
        data: { uid1, uid2, name1, name2 },
        date: Firebase.database.ServerValue.TIMESTAMP,
      });

      await getMultiAccountPairsFunction(dispatch);

      return resolve();
    }).catch(() => {
      resolve();
    });
  }));
}


export function removeMultiAccountPair(uid1, uid2, length) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  if (!uid1 || !uid2) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (uid1 !== uid2) {
    console.log('removing not root');
    return dispatch => new Promise(resolve => FirebaseRef.child(`multiAccounts/${uid1}/${uid2}`).remove().then(async () => {
      if (length <= 2) {
        await FirebaseRef.child(`multiAccounts/${uid1}/${uid1}`).remove();
      }

      const name1Promise = FirebaseRef.child(`users/${uid1}/name`).once('value');
      const name2Promise = FirebaseRef.child(`users/${uid2}/name`).once('value');

      try {
        const [name1Snapshot, name2Snapshot] = await Promise.all([name1Promise, name2Promise]);
        const name1 = name1Snapshot.val() || null;
        const name2 = name2Snapshot.val() || null;
        console.log(name1, name2, "check name1");

        const userId = `uid1: ${uid1}, uid2: ${uid2}`;
        const userName = `name1: ${name1}, name2: ${name2}`;
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: length === 2 ? 'removeMultiAccountPair' : 'removeMultiAccount',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          uid1: uid1 || null,
          uid2: uid2 || null,
          userId,
          userName,
          data: { uid1, uid2, name1, name2 },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });

        await getMultiAccountPairsFunction(dispatch);
        resolve();
      } catch (error) {
        console.error('Error in removeMultiAccount:', error);
        resolve();
      }
    }).catch((error) => {
      console.error('Error removing multi-account:', error);
      resolve();
    }));
  }
  const promise1 = FirebaseRef.child(`multiAccounts/${uid1}`).once('value');

  return dispatch => new Promise(resolve => Promise.all([promise1]).then(async (promisesRes) => {
    let multiAccountsData;

    promisesRes.map((resp, index) => {
      if (index === 0) {
        multiAccountsData = resp.val() || null;
      }
      return null;
    });

    let newId2 = Object.keys(multiAccountsData)[0];

    if (newId2 === uid1) {
      newId2 = Object.keys(multiAccountsData)[1];
    }

    delete multiAccountsData[uid1];

    FirebaseRef.child(`multiAccounts/${uid1}`).remove().then(async () => {
      if (length > 2) {
        await FirebaseRef.child(`multiAccounts/${newId2}`).set(multiAccountsData);
      }

      const name1Promise = FirebaseRef.child(`users/${uid1}/name`).once('value');
      const name2Promise = FirebaseRef.child(`users/${uid2}/name`).once('value');
      try {
        const [name1Snapshot, name2Snapshot] = await Promise.all([name1Promise, name2Promise]);
        const name1 = name1Snapshot.val() || null;
        const name2 = name2Snapshot.val() || null;
        console.log(name1, name2, "check name1");

        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: length === 2 ? 'removeMultiAccountPair' : 'removeMultiAccount',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          uid1: uid1 || null,
          uid2: uid2 || null,
          data: { uid1, uid2, name1, name2 },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });

        await getMultiAccountPairsFunction(dispatch);
        resolve();
      } catch (error) {
        console.error('Error in removeMultiAccount:', error);
        resolve();
      }
    });
  }).catch(() => {
    resolve();
  }));
}

export function removeMultiAccount(uid1) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  if (!uid1) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid)
    ? Firebase.auth().currentUser.uid
    : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email)
    ? Firebase.auth().currentUser.email
    : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName)
    ? Firebase.auth().currentUser.displayName
    : null;

  return dispatch =>
    new Promise(async resolve => {
      try {
        const multiSnapshot = await FirebaseRef.child(`multiAccounts/${uid1}`).once('value');
        const multiData = multiSnapshot.val() || {};
        const linkedAccounts = Object.keys(multiData);

        const namePromises = linkedAccounts.map(uid =>
          FirebaseRef.child(`users/${uid}/name`).once('value')
            .then(snap => ({ uid, name: snap.val() || null }))
        );

        const players = await Promise.all(namePromises);

        await FirebaseRef.child(`multiAccounts/${uid1}`).remove();

        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'removeMultiAccountGroup',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,

          uid1,
          linkedAccounts,

          data: {
            // players: players.map(p => ({
            //   playerUid: p.uid,
            //   playerName: p.name,
            // })),
            players: players
              .map(p => `uid: ${p.uid}, name: ${p.name}`)
              .join("; ")
          },

          date: Firebase.database.ServerValue.TIMESTAMP,
        });

        await getMultiAccountPairsFunction(dispatch);

        resolve();
      } catch (error) {
        console.log('Error in removeMultiAccount:', error);
        resolve();
      }
    });
}


export function getAllHints() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  FirebaseRef.child('hints').off();

  return dispatch => new Promise(resolve => FirebaseRef.child('hints')
    .on('value', (snapshot) => {
      const allHints = snapshot.val() || {};
      const array = [];
      Object.keys(allHints).map((key) => {
        array.push({ key, ...allHints[key] });
        return null;
      });
      return resolve(dispatch({ type: 'ADMIN_HINTS_REPLACE', data: array }));
    })).catch((err) => { console.log(err.message); });
}

export function getAllHintsOld() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  FirebaseRef.child('hints').off();

  return dispatch => new Promise(resolve => FirebaseRef.child('hints')
    .orderByChild('hintType')
    .equalTo(constants.OLD_DESIGN)
    .on('value', (snapshot) => {
      const allHints = snapshot.val() || {};
      const array = [];
      Object.keys(allHints).map((key) => {
        array.push({ key, ...allHints[key] });
        return null;
      });
      return resolve(dispatch({ type: 'ADMIN_HINTS_OLD_REPLACE', data: array }));
    })).catch((err) => { console.log(err.message); });
}

export function getAllHintsNew() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  FirebaseRef.child('hints').off();

  return dispatch => new Promise(resolve => FirebaseRef.child('hints')
    .orderByChild('hintType')
    .equalTo(constants.NEW_DESIGN)
    .on('value', (snapshot) => {
      const allHints = snapshot.val() || {};
      const array = [];
      Object.keys(allHints).map((key) => {
        array.push({ key, ...allHints[key] });
        return null;
      });
      return resolve(dispatch({ type: 'ADMIN_HINTS_NEW_REPLACE', data: array }));
    })).catch((err) => { console.log(err.message); });
}

export function addNewHint(data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return new Promise(resolve => resolve());

  const {
    showOptions, enTitle, lvTitle, ruTitle, enDescription, lvDescription, ruDescription, enImageUrl, lvImageUrl, ruImageUrl, devMode, hintType,
  } = data;

  if (!lvTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVTitle })); }
  if (!enTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENTitle })); }
  if (!ruTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUTitle })); }
  if (!lvDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVDescription })); }
  if (!enDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENDescription })); }
  if (!ruDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUDescription })); }
  if (!enImageUrl) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }
  if (!lvImageUrl) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }
  if (!ruImageUrl) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }
  if (!hintType) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingData })); }

  return () => new Promise((resolve, reject) => {
    FirebaseRef.child('hints').push({
      showOptions,
      titleLV: lvTitle,
      titleEN: enTitle,
      titleRU: ruTitle,
      descriptionLV: lvDescription,
      descriptionEN: enDescription,
      descriptionRU: ruDescription,
      enImageUrl,
      lvImageUrl,
      ruImageUrl,
      devMode,
      hintType,
    })
      .then(async (res) => {
        console.log('addHint=', res);
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'createNewHint',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          data: {
            showOptions,
            titleEN: enTitle,
            titleLV: lvTitle,
            titleRU: ruTitle,
            descriptionEN: enDescription,
            descriptionLV: lvDescription,
            descriptionRU: ruDescription,
            enImageUrl,
            lvImageUrl,
            ruImageUrl,
            devMode,
            hintType,
          },
          date: Firebase.database.ServerValue.TIMESTAMP,
        });
        return resolve({ status: constants.SERVER_STATUS_CODE.success });
      })
      .catch((err) => { console.log(err); return reject({ status: constants.SERVER_STATUS_CODE.error }); });
  });
}

export function editSelectHint(data) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  if (!UID) return new Promise(resolve => resolve());

  const {
    selectHintId, showOptions, enTitle, lvTitle, ruTitle, enDescription, lvDescription, ruDescription, enImageUrl, lvImageUrl, ruImageUrl, oldData, devMode, hintType,
  } = data;

  if (!selectHintId) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingData })); }
  if (!lvTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVTitle })); }
  if (!enTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENTitle })); }
  if (!ruTitle) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUTitle })); }
  if (!lvDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingLVDescription })); }
  if (!enDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingENDescription })); }
  if (!ruDescription) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingRUDescription })); }
  if (!enImageUrl) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }
  if (!lvImageUrl) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }
  if (!ruImageUrl) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingPhoto })); }
  if (!hintType) { return () => new Promise(resolve => resolve({ status: 'error', message: errorMessages.missingData })); }

  return () => new Promise((resolve) => {
    FirebaseRef.child(`hints/${selectHintId}`).update({
      showOptions,
      titleLV: lvTitle,
      titleEN: enTitle,
      titleRU: ruTitle,
      descriptionLV: lvDescription,
      descriptionEN: enDescription,
      descriptionRU: ruDescription,
      enImageUrl,
      lvImageUrl,
      ruImageUrl,
      devMode,
      hintType,
    }).then(async () => {
      const dataToEdit = {
        showOptions,
        titleEN: enTitle,
        titleLV: lvTitle,
        titleRU: ruTitle,
        descriptionEN: enDescription,
        descriptionLV: lvDescription,
        descriptionRU: ruDescription,
        enImageUrl,
        ruImageUrl,
        lvImageUrl,
        devMode,
        hintType,
      };
      const changesObj = {};
      Object.keys(dataToEdit).map((key) => {
        if (oldData[key] !== dataToEdit[key]) {
          changesObj[key] = { new: dataToEdit[key], old: oldData[key] };
        }
        return null;
      });

      let changedlog = '';
      Object.keys(changesObj).map((key, index) => {
        changedlog += `${key} ${changesObj[key].old} to ${changesObj[key].new}`;

        if ((index + 1) !== Object.keys(changesObj).length) {
          changedlog += ', ';
        }
        return null;
      });

      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'editSelectHint',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        eventId: selectHintId,
        data: {
          ...dataToEdit,
          changedlog,
        },
        userName: lvTitle,
        date: Firebase.database.ServerValue.TIMESTAMP,
      });

      return resolve({ status: constants.SERVER_STATUS_CODE.success });
    }).catch(err => resolve({ status: 'error', message: err.message }));
  });
}

export function deleteHint(hindId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise(resolve => Firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      FirebaseRef.child(`hints/${hindId}`).remove().then(async () => {
        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'deleteHint',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          hindId,
          data: null,
          date: Firebase.database.ServerValue.TIMESTAMP,
        });
        return resolve({ status: constants.SERVER_STATUS_CODE.success });
      })
        .catch(err => resolve({ status: 'error', message: err.message }));
    }
  }));
}

export function getAllReportedPlayers() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  // const filterDate = Date.parse(new Date());

  FirebaseRef.child('reportPlayers').off();

  return dispatch => new Promise(resolve => FirebaseRef.child('reportPlayers')
    .on('value', (snapshot) => {
      const allReportedPlayers = snapshot.val() || {};

      return resolve(dispatch({ type: 'ADMIN_REPORTED_PLAYERS_REPLACE', data: allReportedPlayers }));
    })).catch((err) => { console.log(err.message); });
}

export function getAllReportedMessages() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  // const filterDate = Date.parse(new Date());

  FirebaseRef.child('reportMessages').off();

  return dispatch => new Promise(resolve => FirebaseRef.child('reportMessages')
    .on('value', (snapshot) => {
      const allReportedMessages = snapshot.val() || {};
      console.log('allReportedMessages', allReportedMessages);

      return resolve(dispatch({ type: 'ADMIN_REPORTED_MESSAGES_REPLACE', data: allReportedMessages }));
    })).catch((err) => { console.log(err.message); });
}

export function checkAdminReportPlayers(key, reporterId, reporterName, reportedId, reportedName, reason) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;
  console.log(key, 'checkAdminView');
  return () => new Promise(async () => {
    FirebaseRef.child(`reportPlayers/${key.toString()}`)
      .update({
        adminView: true,
      });

    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;
    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'reportPlayers',
      adminId: UID,
      adminEmail,
      userId: key,
      adminName: confirmAdminName || adminName,
      userName: reporterName,
      data: {
        reportedId,
        reportedName,
        reason,
        adminView: 'Done',
      },
      date: Firebase.database.ServerValue.TIMESTAMP,
    });
  });
}
export function checkAdminReportMessages(key, reporterId, reporterName, reportedId, reportedName, message) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;
  console.log(key, reporterId, reporterName, reportedId, reportedName, message, 'checkAdminView');
  return () => new Promise(async () => {
    FirebaseRef.child(`reportMessages/${key.toString()}`)
      .update({
        adminView: true,
      });

    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;
    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'reportMessages',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      date: Firebase.database.ServerValue.TIMESTAMP,
      userId: key,
      userName: reporterName,
      data: {
        reportedId,
        reportedName,
        message,
        adminView: 'Done',
      },
    });
  });
}

export function getConfirmedPlayersCount() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => FirebaseRef.child('users')
    .orderByChild('verifiedEmail')
    .equalTo(true)
    .once('value', (snapshot) => {
      const data = snapshot.val() || {};
      console.log(size(data), 'admin verified users action');

      const filteredUsers = data ? filter(data, item => item.verifiedEmailSent) : {};

      return resolve(dispatch({ type: 'ADMIN_VERIFIED_COUNT_REPLACE', data: size(filteredUsers) }));
    })).catch((err) => { console.log(err.message); });
}

export function checkAutoForCompensation(uid, name) {
  console.log('checkAutoForCompensation', uid, name);
  if (!uid) return () => new Promise(resolve => resolve());

  if (Firebase === null) return () => new Promise(resolve => resolve());

  /*
  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  const test = Date.now();

   let d = new Date(test);

   d.setHours(24, 0, 0, 0);
   d = Date.parse(d);

  const startAt = d - (1000 * 60 * 60 * 72);
  const endAt = d;
  const totalPenalty = 0;
  const percentPenalty = 0;
  const adminChangeAuto = false;
  const previousChangeAuto = {};
  console.log('adminPenaltyBonus3'); */

  return () => new Promise(() => {
    const delay = [1, 2, 3, 4, 5];
    const random = Math.floor(Math.random() * delay.length);

    FirebaseRef.child(`checkAutoForCompensation/${uid}`).set({ time: Firebase.database.ServerValue.TIMESTAMP, delay: delay[random] });
  });
}

// export function getRoomChats(filterType, filterVal) {
//   if (Firebase === null) return () => new Promise(resolve => resolve());

//   const d = Date.now();
//   /* let startAt;
//   let endAt;
//   let roomData;
//   const roomMsg = [];
//   let filterRoomData; */

//   const startAt = d - (1000 * 60 * 60 * 24 * constants.WEEKLY_VALUE.twoWeek);
//   const endAt = d;

//   return dispatch => new Promise(async (resolve) => {
//     dispatch({ type: 'PLAYER_ROOM_CHAT_MESSAGE', data: [], chatLoading: true });

//     FirebaseRef.child('playerChat')
//       .orderByChild('time')
//       .startAt(startAt)
//       .endAt(endAt)
//       .once('value', (snapshot) => {
//         const data = snapshot.val();
//         let roomChats = [];
//         if (filterType === constants.ROOMID && filterVal !== '') {
//           roomChats = filter(data, item => item.roomId === filterVal);
//         } else if (filterType === constants.USERID && filterVal !== '') {
//           roomChats = filter(data, item => item.userUid === filterVal);
//         } else {
//           Object.keys(data).map((key) => {
//             roomChats.push({ key, ...data[key] });
//             return null;
//           });
//         }
//         if (size(roomChats) > 0) {
//           roomChats.sort((a, b) => (b.time - a.time));
//         }
//         return resolve(dispatch({ type: 'PLAYER_ROOM_CHAT_MESSAGE', data: roomChats, chatLoading: false }));
//       });
//   });
// }

export function getRoomChats(filterType, filterVal) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const startAt = Date.now() - (1000 * 60 * 60 * 24 * constants.WEEKLY_VALUE.twoWeek);

  FirebaseRef.child('playerChat').off();

  return dispatch => {
    const unsubscribe = FirebaseRef.child('playerChat')
      .orderByChild('time')
      .startAt(startAt)
      .on('value', async (snapshot) => {
        const data = snapshot.val();
        let roomChats = [];

        if (filterType === constants.ROOMID && filterVal !== '') {
          roomChats = filter(data, item => item.roomId === filterVal);
        } else if (filterType === constants.USERID && filterVal !== '') {
          roomChats = filter(data, item => item.userUid === filterVal);
        } else {
          Object.keys(data).map((key) => {
            roomChats.push({ key, ...data[key] });
            return null;
          });
        }

        const updatedRoomChats = await Promise.all(roomChats.map(async (chat) => {
          const banSnapshot = await FirebaseRef.child(`bans/${chat.userUid}`).once('value');
          const banData = banSnapshot.val();
          return {
            ...chat,
            blocked: banData ? banData.blocked : false
          };
        }));

        if (size(updatedRoomChats) > 0) {
          updatedRoomChats.sort((a, b) => (b.time - a.time));
        }

        return dispatch({ type: 'PLAYER_ROOM_CHAT_MESSAGE', data: updatedRoomChats, chatLoading: false });
      });

    return () => unsubscribe();
  };
}

export function getLogRocketUsers() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  return dispatch => new Promise(resolve => FirebaseRef.child('users')
    .orderByChild('enableLogRocket')
    .equalTo(true)
    .once('value', (userSnapshot) => {
      const enableLogRocketUsers = userSnapshot.val() || {};

      const sortedUids = Object.entries(enableLogRocketUsers)
        .sort(([, a], [, b]) => {
          const aHasDate = typeof a.enableLogRocketDate === 'number';
          const bHasDate = typeof b.enableLogRocketDate === 'number';

          if (!aHasDate && !bHasDate) return 0;
          if (!aHasDate) return 1;
          if (!bHasDate) return -1;

          return b.enableLogRocketDate - a.enableLogRocketDate;
        })
        .map(([uid]) => uid);

      return resolve(dispatch({
        type: 'ENABLED_LOG_LOCKET_USERS',
        data: {
          logRocketUsers: enableLogRocketUsers,
          logRocketUsersOrder: sortedUids,
        }
      }));
    }));
}

export function addWarningMark(playerUid, curWarningMark, warningPlayerName) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;
  console.log(playerUid, curWarningMark || 0, 'checkAdminView');
  const updateWarningMark = curWarningMark ? curWarningMark + 1 : 1;
  const cursorExpireDate = Date.parse(moment(new Date()).add(30 * 24, 'hours'));

  return () => new Promise(async (resolve) => {
    if (curWarningMark === 0 || !curWarningMark) {
      FirebaseRef.child(`warningPlayers/${playerUid.toString()}`)
        .update({
          warning: updateWarningMark,
          warningDate: Date.now(),
          adminActivated: true,
        });
    } else {
      FirebaseRef.child(`warningPlayers/${playerUid.toString()}`)
        .update({
          warning: updateWarningMark,
          warningDate: Date.now(),
          adminActivated: true,
          cursor: (updateWarningMark > 0 && updateWarningMark % 10 === 0) || null,
          cursorExpire: (updateWarningMark > 0 && updateWarningMark % 10 === 0) ? cursorExpireDate : null,
        });
    }

    FirebaseRef.child(`users/${playerUid.toString()}`)
      .update({
        warning: updateWarningMark,
        warningDate: Date.now(),
        cursor: (updateWarningMark > 0 && updateWarningMark % 10 === 0) || null,
        cursorExpire: (updateWarningMark > 0 && updateWarningMark % 10 === 0) ? cursorExpireDate : null,
      });
    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'warningMark',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      date: Firebase.database.ServerValue.TIMESTAMP,
      userId: playerUid,
      userName: warningPlayerName,
      data: {
        warning: updateWarningMark,
      },
    });
    return resolve({ status: constants.SERVER_STATUS_CODE.success });

  });
}

export function getWarningPlayers() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());

  FirebaseRef.child('warningPlayers').off();

  return dispatch => new Promise(async resolve => FirebaseRef.child('warningPlayers')
    .orderByKey()
    .on('value', (userSnapshot) => {
      const warningPlayers = userSnapshot.val() || {};
      const warningPlayersList = {};

      map(warningPlayers, (item, key) => {
        if (item?.cursor && Date.now() > item?.cursorExpire) {
          FirebaseRef.child(`users/${key.toString()}`).update({
            cursorExpire: null,
            cursor: null,
          });
          FirebaseRef.child(`warningPlayers/${key.toString()}`).update({
            cursorExpire: null,
            cursor: null,
          });
        } else {
          warningPlayersList[key] = {
            ...item,
          };
        }
      })

      return resolve(dispatch({ type: 'REPLACE_WARNING_PLAYERS', data: warningPlayersList }));
    }));
}

export function getDesignPlatforms() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return () => new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    dispatch({ type: 'REPLACE_DESIGN_PLATFORMS', data: [], designPlatformsLoading: true });
    FirebaseRef.child('designPlatforms')
      .orderByKey()
      .once('value', (userSnapshot) => {
        const designPlatforms = userSnapshot.val() || {};
        return resolve(dispatch({ type: 'REPLACE_DESIGN_PLATFORMS', data: designPlatforms, designPlatformsLoading: false }));
      }).catch(() => {
        return resolve(dispatch({ type: 'REPLACE_DESIGN_PLATFORMS', data: {}, designPlatformsLoading: false }));
      });
  });
}

export function updateDesignPlatform(id, design, value, otherData) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise((resolve) => {
    dispatch({ type: 'REPLACE_DESIGN_PLATFORMS', data: [], designPlatformsLoading: true });
    FirebaseRef.child(`designPlatforms/${id}`).update({
      [design]: value,
      setFrequency: design === 'frequency' && value > 0 ? Date.now() : null,
    }).then(async () => {
      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'designPlatform',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        date: Firebase.database.ServerValue.TIMESTAMP,
        data: {
          [design]: value,
          ...otherData,
        },
      });

      FirebaseRef.child('designPlatforms')
        .orderByKey()
        .once('value', (userSnapshot) => {
          const designPlatforms = userSnapshot.val() || {};

          dispatch({ type: 'GET_DESIGN_PLATFORM', data: designPlatforms });
          return resolve(dispatch({ type: 'REPLACE_DESIGN_PLATFORMS', data: designPlatforms, designPlatformsLoading: false }));
        }).catch(() => {
          return resolve(dispatch({ type: 'REPLACE_DESIGN_PLATFORMS', data: {}, designPlatformsLoading: false }));
        });
    });
  });
};

export function getSurveys() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(async (resolve) => {
    await FirebaseRef.child('surveys').off();

    FirebaseRef.child('surveys')
      .on('value', (snapshot) => {
        const allSurveys = snapshot.val() || {};

        console.log('getSurveys allSurveys', allSurveys);

        return resolve(dispatch({ type: 'REPLACE_SURVEY_PLATFORMS', data: allSurveys }));
      });
  }).catch((err) => { console.log(err.message); });
  }

export function getSurveyHistory() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());

  return dispatch => new Promise(async (resolve) => {
    dispatch({ type: 'REPLACE_SURVEY_HISTORY_PLATFORMS', data: [], loading: true });
    await FirebaseRef.child('surveyHistory').off();

    FirebaseRef.child('surveyHistory')
      .on('value', (userSnapshot) => {
        const surveyHistory = userSnapshot.val() || {};

        console.log('getSurveysHistory surveyHistory', surveyHistory);

        return resolve(dispatch({ type: 'REPLACE_SURVEY_HISTORY_PLATFORMS', data: surveyHistory, loading: false }));
      });
    });
}

export function createSurveyFunc({startDate, endDate, question, description, questionType, devMode, answerList, selectedDesigns, disableAnswer}) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child('surveys').push({
      startDate: Date.parse(startDate),
      endDate: Date.parse(endDate),
      question,
      description,
      questionType,
      devMode: devMode || null,
      answerList,
      selectedDesigns,
      disableAnswer
    }).then(async (res) => {
      let answerListData = '';
      answerList.map(item => answerListData += item.value ? `${item.value},` : '');
      let selectedDesignsData = '';
      selectedDesigns.map(item => selectedDesignsData += item.label ? `${item.label},` : '');

      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'createSurvey',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        date: Firebase.database.ServerValue.TIMESTAMP,
        data: {
          startDate: moment(startDate).format('DD-MM-YYYY HH:MM:SS'),
          endDate: moment(endDate).format('DD-MM-YYYY HH:MM:SS'),
          question,
          description,
          questionType,
          devMode,
          answerList: answerListData,
          selectedDesigns: selectedDesignsData,
          disableAnswer
        },
      });
      return resolve({ status: constants.SERVER_STATUS_CODE.success, message: constants.SERVER_STATUS_CODE.success });
    }).catch(() => {
      return resolve({ status: constants.SERVER_STATUS_CODE.error });
    });
  });
}

export function deleteFeedback(selectedId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child(`feedback/${selectedId}`).remove().then(async () => {
      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'deleteFeedback',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        date: Firebase.database.ServerValue.TIMESTAMP,
        selectedId,
      });
      return resolve({ status: constants.SERVER_STATUS_CODE.success });
    }).catch(() => {
      return resolve({ status: constants.SERVER_STATUS_CODE.error });
    });
  });
}

export function createFeedback({ startDate, endDate, platforms, designs, devMode }) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  const adminPlatformDevMode = getDevMode();

  console.log('adminPlatformDevMode', adminPlatformDevMode);

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child('feedback').startAt(Date.parse(startDate)).endAt(Date.parse(endDate)).once('value', (snapshot) => {
      const results = snapshot.val();
      console.log(results, "resultcheck===============");

      FirebaseRef.child('feedback').push({
        startDate: Date.parse(startDate),
        endDate: Date.parse(endDate),
        platforms,
        designs,
        devMode,
        adminPlatformDevMode: adminPlatformDevMode || false,
      }).then(async (res) => {
        console.log(res, "check===============111111111111");

        const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
        const confirmAdminName = (await adminNamePromise)?.val() || null;

        AdminLogsRef().child('adminLogs/adminActions').push({
          type: 'createFeedback',
          adminId: UID,
          adminEmail,
          adminName: confirmAdminName || adminName,
          date: Firebase.database.ServerValue.TIMESTAMP,
          data: {
            startDate: moment(startDate).format('DD-MM-YYYY HH:MM:SS'),
            endDate: moment(endDate).format('DD-MM-YYYY HH:MM:SS'),
            platforms,
            designs,
            devMode,
            adminPlatformDevMode: adminPlatformDevMode || false,
          },
        });
        return resolve({ status: constants.SERVER_STATUS_CODE.success, message: constants.SERVER_STATUS_CODE.success });
      }).catch(() => {
        return resolve({ status: constants.SERVER_STATUS_CODE.error });
      });
    })
  });
}

export function editFeedback({selectedId, startDate, endDate, platforms, designs, devMode,}) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  const adminPlatformDevMode = getDevMode();

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child(`feedback/${selectedId}`).update({
      startDate: Date.parse(startDate),
      endDate: Date.parse(endDate),
      platforms,
      designs,
      devMode,
      adminPlatformDevMode: adminPlatformDevMode || false,
    }).then(async (res) => {
      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'editFeedback',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        date: Firebase.database.ServerValue.TIMESTAMP,
        data: {
          startDate: moment(startDate).format('DD-MM-YYYY HH:MM:SS'),
          endDate: moment(endDate).format('DD-MM-YYYY HH:MM:SS'),
          platforms,
          designs,
          devMode,
          adminPlatformDevMode: adminPlatformDevMode || false,
        },
      });
      return resolve({ status: constants.SERVER_STATUS_CODE.success });
    }).catch(() => {
      return resolve({ status: constants.SERVER_STATUS_CODE.error });
    });
  });
}

export function deleteSurveyFunc(selectedId, description) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child(`surveys/${selectedId}`).remove().then(async () => {
      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'deleteSurvey',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        date: Firebase.database.ServerValue.TIMESTAMP,
        data: {
          selectedId,
          description,
        },
      });
      return resolve({ status: constants.SERVER_STATUS_CODE.success });
    }).catch(() => {
      return resolve({ status: constants.SERVER_STATUS_CODE.error });
    });
  });
}

export function editSurveyFunc({selectedId, startDate, endDate, question, description, questionType, devMode, answerList, selectedDesigns, disableAnswer}) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child(`surveys/${selectedId}`).update({
      startDate: Date.parse(startDate),
      endDate: Date.parse(endDate),
      question,
      description,
      questionType,
      devMode: devMode || null,
      answerList,
      selectedDesigns,
      disableAnswer
    }).then(async (res) => {
      let answerListData = '';
      answerList.map(item => answerListData += `${item.value},`);
      let selectedDesignsData = '';
      selectedDesigns.map(item => selectedDesignsData += `${item.label},`);

      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'editSurvey',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        date: Firebase.database.ServerValue.TIMESTAMP,
        data: {
          startDate: moment(startDate).format('DD-MM-YYYY HH:MM:SS'),
          endDate: moment(endDate).format('DD-MM-YYYY HH:MM:SS'),
          question,
          description,
          questionType,
          devMode,
          answerList: answerListData,
          selectedDesigns: selectedDesignsData,
          disableAnswer,
          selectedId,
        },
      });
      return resolve({ status: constants.SERVER_STATUS_CODE.success });
    }).catch(() => {
      return resolve({ status: constants.SERVER_STATUS_CODE.error });
    });
  });
}

export function getTranslationsFiles(devMode) {
  console.log('getTranslationsFiles', devMode);

  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    // dispatch({ type: 'REPLACE_SURVEY_PLATFORMS', data: [], loading: true });

    const promises = [];

    let lvReference = FirebaseStorage.ref(`/translations`).child(`lv.json`);
    let enReference = FirebaseStorage.ref(`/translations`).child(`en.json`);
    let ruReference = FirebaseStorage.ref(`/translations`).child(`ru.json`);

    if (devMode) {
      console.log('get dev translations');

      lvReference = FirebaseStorage.ref(`/translationsDev`).child(`lv.json`);
      enReference = FirebaseStorage.ref(`/translationsDev`).child(`en.json`);
      ruReference = FirebaseStorage.ref(`/translationsDev`).child(`ru.json`);
    }

    const languageMap = {
      'english': null,
      'latvian': null,
      'russian': null,
    };

    promises.push(new Promise((resolve2) => {
      lvReference.getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          let translationsDb = response.data;

          console.log('translations file lv', translationsDb);

          if (translationsDb.common) { i18n.addResourceBundle('lv', 'common', translationsDb.common); }
          if (translationsDb.holiday) { i18n.addResourceBundle('lv', 'holiday', translationsDb.holiday); }
          if (translationsDb.previousRound) { i18n.addResourceBundle('lv', 'previousRound', translationsDb.previousRound); }
          if (translationsDb.achievements) { i18n.addResourceBundle('lv', 'achievements', translationsDb.achievements); }
          if (translationsDb.userNotifications) { i18n.addResourceBundle('lv', 'userNotifications', translationsDb.userNotifications); }
          if (translationsDb.game) { i18n.addResourceBundle('lv', 'game', translationsDb.game); }
          if (translationsDb.playerInfo) { i18n.addResourceBundle('lv', 'playerInfo', translationsDb.playerInfo); }
          if (translationsDb.chat) { i18n.addResourceBundle('lv', 'chat', translationsDb.chat); }
          if (translationsDb.notifications) { i18n.addResourceBundle('lv', 'notifications', translationsDb.notifications); }
          if (translationsDb.login) { i18n.addResourceBundle('lv', 'login', translationsDb.login); }
          if (translationsDb.help) { i18n.addResourceBundle('lv', 'help', translationsDb.help); }
          if (translationsDb.settings) { i18n.addResourceBundle('lv', 'settings', translationsDb.settings); }
          if (translationsDb.updateProfile) { i18n.addResourceBundle('lv', 'updateProfile', translationsDb.updateProfile); }
          if (translationsDb.nativeNotifications) { i18n.addResourceBundle('lv', 'nativeNotifications', translationsDb.nativeNotifications); }
          if (translationsDb.bonus) { i18n.addResourceBundle('lv', 'bonus', translationsDb.bonus); }
          if (translationsDb.admin) { i18n.addResourceBundle('lv', 'admin', translationsDb.admin); }
          if (translationsDb.rulesPage) { i18n.addResourceBundle('lv', 'rulesPage', translationsDb.rulesPage); }
          if (translationsDb.rules) { i18n.addResourceBundle('lv', 'rules', translationsDb.rules); }
          if (translationsDb.tournamentHelp) { i18n.addResourceBundle('lv', 'tournamentHelp', translationsDb.tournamentHelp); }

          languageMap.latvian = translationsDb;

          return resolve2(dispatch({ type: 'REPLACE_TRASLATIONS_FILES', data: translationsDb, language: 'lv' }));
        });
      });
    }));

    promises.push(new Promise((resolve2) => {
      enReference.getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          let translationsDb = response.data;

          console.log('translations file en', translationsDb);

          if (translationsDb.common) { i18n.addResourceBundle('en', 'common', translationsDb.common); }
          if (translationsDb.holiday) { i18n.addResourceBundle('en', 'holiday', translationsDb.holiday); }
          if (translationsDb.previousRound) { i18n.addResourceBundle('en', 'previousRound', translationsDb.previousRound); }
          if (translationsDb.achievements) { i18n.addResourceBundle('en', 'achievements', translationsDb.achievements); }
          if (translationsDb.userNotifications) { i18n.addResourceBundle('en', 'userNotifications', translationsDb.userNotifications); }
          if (translationsDb.game) { i18n.addResourceBundle('en', 'game', translationsDb.game); }
          if (translationsDb.playerInfo) { i18n.addResourceBundle('en', 'playerInfo', translationsDb.playerInfo); }
          if (translationsDb.chat) { i18n.addResourceBundle('en', 'chat', translationsDb.chat); }
          if (translationsDb.notifications) { i18n.addResourceBundle('en', 'notifications', translationsDb.notifications); }
          if (translationsDb.login) { i18n.addResourceBundle('en', 'login', translationsDb.login); }
          if (translationsDb.help) { i18n.addResourceBundle('en', 'help', translationsDb.help); }
          if (translationsDb.settings) { i18n.addResourceBundle('en', 'settings', translationsDb.settings); }
          if (translationsDb.updateProfile) { i18n.addResourceBundle('en', 'updateProfile', translationsDb.updateProfile); }
          if (translationsDb.nativeNotifications) { i18n.addResourceBundle('en', 'nativeNotifications', translationsDb.nativeNotifications); }
          if (translationsDb.bonus) { i18n.addResourceBundle('en', 'bonus', translationsDb.bonus); }
          if (translationsDb.admin) { i18n.addResourceBundle('en', 'admin', translationsDb.admin); }
          if (translationsDb.rulesPage) { i18n.addResourceBundle('en', 'rulesPage', translationsDb.rulesPage); }
          if (translationsDb.rules) { i18n.addResourceBundle('en', 'rules', translationsDb.rules); }
          if (translationsDb.tournamentHelp) { i18n.addResourceBundle('en', 'tournamentHelp', translationsDb.tournamentHelp); }

          languageMap.english = translationsDb;

          return resolve2(dispatch({ type: 'REPLACE_TRASLATIONS_FILES', data: translationsDb, language: 'en' }));
        });
      });
    }));

    promises.push(new Promise((resolve2) => {
      ruReference.getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          let translationsDb = response.data;

          console.log('translations file ru', translationsDb);

          if (translationsDb.common) { i18n.addResourceBundle('ru', 'common', translationsDb.common); }
          if (translationsDb.holiday) { i18n.addResourceBundle('ru', 'holiday', translationsDb.holiday); }
          if (translationsDb.previousRound) { i18n.addResourceBundle('ru', 'previousRound', translationsDb.previousRound); }
          if (translationsDb.achievements) { i18n.addResourceBundle('ru', 'achievements', translationsDb.achievements); }
          if (translationsDb.userNotifications) { i18n.addResourceBundle('ru', 'userNotifications', translationsDb.userNotifications); }
          if (translationsDb.game) { i18n.addResourceBundle('ru', 'game', translationsDb.game); }
          if (translationsDb.playerInfo) { i18n.addResourceBundle('ru', 'playerInfo', translationsDb.playerInfo); }
          if (translationsDb.chat) { i18n.addResourceBundle('ru', 'chat', translationsDb.chat); }
          if (translationsDb.notifications) { i18n.addResourceBundle('ru', 'notifications', translationsDb.notifications); }
          if (translationsDb.login) { i18n.addResourceBundle('ru', 'login', translationsDb.login); }
          if (translationsDb.help) { i18n.addResourceBundle('ru', 'help', translationsDb.help); }
          if (translationsDb.settings) { i18n.addResourceBundle('ru', 'settings', translationsDb.settings); }
          if (translationsDb.updateProfile) { i18n.addResourceBundle('ru', 'updateProfile', translationsDb.updateProfile); }
          if (translationsDb.nativeNotifications) { i18n.addResourceBundle('ru', 'nativeNotifications', translationsDb.nativeNotifications); }
          if (translationsDb.bonus) { i18n.addResourceBundle('ru', 'bonus', translationsDb.bonus); }
          if (translationsDb.admin) { i18n.addResourceBundle('ru', 'admin', translationsDb.admin); }
          if (translationsDb.rulesPage) { i18n.addResourceBundle('ru', 'rulesPage', translationsDb.rulesPage); }
          if (translationsDb.rules) { i18n.addResourceBundle('ru', 'rules', translationsDb.rules); }
          if (translationsDb.tournamentHelp) { i18n.addResourceBundle('ru', 'tournamentHelp', translationsDb.tournamentHelp); }

          languageMap.russian = translationsDb;

          return resolve2(dispatch({ type: 'REPLACE_TRASLATIONS_FILES', data: translationsDb, language: 'ru' }));
        });
      });
    }));

    Promise.all(promises).then(() => {
      console.log('languageMap', languageMap);
      if (languageMap && languageMap.english && languageMap.latvian && languageMap.russian) {
        return resolve(languageMap);
      }

      return resolve(null);
    }).catch(err => {
      console.log(err);
      return resolve(null);
    })

  });
}
export function getAppTranslationsFiles(devMode) {
  console.log('getTranslationsFiles', devMode);

  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    // dispatch({ type: 'REPLACE_SURVEY_PLATFORMS', data: [], loading: true });

    const promises = [];

    let lvReference = FirebaseStorage.ref(`/appTranslations`).child(`lv.json`);
    let enReference = FirebaseStorage.ref(`/appTranslations`).child(`en.json`);
    let ruReference = FirebaseStorage.ref(`/appTranslations`).child(`ru.json`);

    if (devMode) {
      console.log('get dev translations');

      lvReference = FirebaseStorage.ref(`/appTranslationsDev`).child(`lv.json`);
      enReference = FirebaseStorage.ref(`/appTranslationsDev`).child(`en.json`);
      ruReference = FirebaseStorage.ref(`/appTranslationsDev`).child(`ru.json`);
    }

    const languageMap = {
      'english': null,
      'latvian': null,
      'russian': null,
    };

    promises.push(new Promise((resolve2) => {
      lvReference.getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          let translationsDb = response.data;

          console.log('translations file lv', translationsDb);

          if (translationsDb.common) { i18n.addResourceBundle('lv', 'common', translationsDb.common); }
          if (translationsDb.holiday) { i18n.addResourceBundle('lv', 'holiday', translationsDb.holiday); }
          if (translationsDb.previousRound) { i18n.addResourceBundle('lv', 'previousRound', translationsDb.previousRound); }
          if (translationsDb.achievements) { i18n.addResourceBundle('lv', 'achievements', translationsDb.achievements); }
          if (translationsDb.game) { i18n.addResourceBundle('lv', 'game', translationsDb.game); }
          if (translationsDb.playerInfo) { i18n.addResourceBundle('lv', 'playerInfo', translationsDb.playerInfo); }
          if (translationsDb.chat) { i18n.addResourceBundle('lv', 'chat', translationsDb.chat); }
          if (translationsDb.notifications) { i18n.addResourceBundle('lv', 'notifications', translationsDb.notifications); }
          if (translationsDb.login) { i18n.addResourceBundle('lv', 'login', translationsDb.login); }
          if (translationsDb.help) { i18n.addResourceBundle('lv', 'help', translationsDb.help); }
          if (translationsDb.settings) { i18n.addResourceBundle('lv', 'settings', translationsDb.settings); }
          if (translationsDb.updateProfile) { i18n.addResourceBundle('lv', 'updateProfile', translationsDb.updateProfile); }
          if (translationsDb.nativeNotifications) { i18n.addResourceBundle('lv', 'nativeNotifications', translationsDb.nativeNotifications); }
          if (translationsDb.bonus) { i18n.addResourceBundle('lv', 'bonus', translationsDb.bonus); }
          if (translationsDb.admin) { i18n.addResourceBundle('lv', 'admin', translationsDb.admin); }
          if (translationsDb.rulesPage) { i18n.addResourceBundle('lv', 'rulesPage', translationsDb.rulesPage); }
          if (translationsDb.rules) { i18n.addResourceBundle('lv', 'rules', translationsDb.rules); }
          if (translationsDb.tournamentHelp) { i18n.addResourceBundle('lv', 'tournamentHelp', translationsDb.tournamentHelp); }

          languageMap.latvian = translationsDb;

          return resolve2(dispatch({ type: 'REPLACE_APP_TRASLATIONS_FILES', data: translationsDb, language: 'lv' }));
        });
      });
    }));

    promises.push(new Promise((resolve2) => {
      enReference.getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          let translationsDb = response.data;

          console.log('translations file en', translationsDb);

          if (translationsDb.common) { i18n.addResourceBundle('en', 'common', translationsDb.common); }
          if (translationsDb.holiday) { i18n.addResourceBundle('en', 'holiday', translationsDb.holiday); }
          if (translationsDb.previousRound) { i18n.addResourceBundle('en', 'previousRound', translationsDb.previousRound); }
          if (translationsDb.achievements) { i18n.addResourceBundle('en', 'achievements', translationsDb.achievements); }
          if (translationsDb.game) { i18n.addResourceBundle('en', 'game', translationsDb.game); }
          if (translationsDb.playerInfo) { i18n.addResourceBundle('en', 'playerInfo', translationsDb.playerInfo); }
          if (translationsDb.chat) { i18n.addResourceBundle('en', 'chat', translationsDb.chat); }
          if (translationsDb.notifications) { i18n.addResourceBundle('en', 'notifications', translationsDb.notifications); }
          if (translationsDb.login) { i18n.addResourceBundle('en', 'login', translationsDb.login); }
          if (translationsDb.help) { i18n.addResourceBundle('en', 'help', translationsDb.help); }
          if (translationsDb.settings) { i18n.addResourceBundle('en', 'settings', translationsDb.settings); }
          if (translationsDb.updateProfile) { i18n.addResourceBundle('en', 'updateProfile', translationsDb.updateProfile); }
          if (translationsDb.nativeNotifications) { i18n.addResourceBundle('en', 'nativeNotifications', translationsDb.nativeNotifications); }
          if (translationsDb.bonus) { i18n.addResourceBundle('en', 'bonus', translationsDb.bonus); }
          if (translationsDb.admin) { i18n.addResourceBundle('en', 'admin', translationsDb.admin); }
          if (translationsDb.rulesPage) { i18n.addResourceBundle('en', 'rulesPage', translationsDb.rulesPage); }
          if (translationsDb.rules) { i18n.addResourceBundle('en', 'rules', translationsDb.rules); }
          if (translationsDb.tournamentHelp) { i18n.addResourceBundle('en', 'tournamentHelp', translationsDb.tournamentHelp); }

          languageMap.english = translationsDb;

          return resolve2(dispatch({ type: 'REPLACE_APP_TRASLATIONS_FILES', data: translationsDb, language: 'en' }));
        });
      });
    }));

    promises.push(new Promise((resolve2) => {
      ruReference.getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          let translationsDb = response.data;

          console.log('translations file ru', translationsDb);

          if (translationsDb.common) { i18n.addResourceBundle('ru', 'common', translationsDb.common); }
          if (translationsDb.holiday) { i18n.addResourceBundle('ru', 'holiday', translationsDb.holiday); }
          if (translationsDb.previousRound) { i18n.addResourceBundle('ru', 'previousRound', translationsDb.previousRound); }
          if (translationsDb.achievements) { i18n.addResourceBundle('ru', 'achievements', translationsDb.achievements); }
          if (translationsDb.game) { i18n.addResourceBundle('ru', 'game', translationsDb.game); }
          if (translationsDb.playerInfo) { i18n.addResourceBundle('ru', 'playerInfo', translationsDb.playerInfo); }
          if (translationsDb.chat) { i18n.addResourceBundle('ru', 'chat', translationsDb.chat); }
          if (translationsDb.notifications) { i18n.addResourceBundle('ru', 'notifications', translationsDb.notifications); }
          if (translationsDb.login) { i18n.addResourceBundle('ru', 'login', translationsDb.login); }
          if (translationsDb.help) { i18n.addResourceBundle('ru', 'help', translationsDb.help); }
          if (translationsDb.settings) { i18n.addResourceBundle('ru', 'settings', translationsDb.settings); }
          if (translationsDb.updateProfile) { i18n.addResourceBundle('ru', 'updateProfile', translationsDb.updateProfile); }
          if (translationsDb.nativeNotifications) { i18n.addResourceBundle('ru', 'nativeNotifications', translationsDb.nativeNotifications); }
          if (translationsDb.bonus) { i18n.addResourceBundle('ru', 'bonus', translationsDb.bonus); }
          if (translationsDb.admin) { i18n.addResourceBundle('ru', 'admin', translationsDb.admin); }
          if (translationsDb.rulesPage) { i18n.addResourceBundle('ru', 'rulesPage', translationsDb.rulesPage); }
          if (translationsDb.rules) { i18n.addResourceBundle('ru', 'rules', translationsDb.rules); }
          if (translationsDb.tournamentHelp) { i18n.addResourceBundle('ru', 'tournamentHelp', translationsDb.tournamentHelp); }

          languageMap.russian = translationsDb;

          return resolve2(dispatch({ type: 'REPLACE_APP_TRASLATIONS_FILES', data: translationsDb, language: 'ru' }));
        });
      });
    }));

    Promise.all(promises).then(() => {
      console.log('languageMap', languageMap);
      if (languageMap && languageMap.english && languageMap.latvian && languageMap.russian) {
        return resolve(languageMap);
      }

      return resolve(null);
    }).catch(err => {
      console.log(err);
      return resolve(null);
    })

  });
}

export function updateTranslationsFile(translationsJson, language, changes, devMode) {
  console.log("updateTranslationsFile", translationsJson, language, changes, devMode);

  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());

  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  let translationReference = FirebaseStorage.ref(`/translations`).child(`${language}.json`);

  if (devMode) {
    translationReference = FirebaseStorage.ref(`/translationsDev`).child(`${language}.json`);
  }

  return dispatch => new Promise((resolve) => {
    const jsonString = JSON.stringify(translationsJson);
    const blob = new Blob([jsonString], { type: "application/json" });

    translationReference.put(blob).then(async () => {
      console.log('Uploaded a blob!');

      // dispatch(getTranslationsFiles());

      console.log('test 7');
      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'updateTranslations',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        devMode,
        date: Firebase.database.ServerValue.TIMESTAMP,
        data: {...changes},
      });

      return resolve({ status: constants.SERVER_STATUS_CODE.success });
    }).catch((err) => {
      console.log('test 8');
      console.log('err', err);
      return resolve({ status: constants.SERVER_STATUS_CODE.error });
    });
  });
}


export function updateAppTranslationsFile(translationsJson, language, changes, devMode) {
  console.log("updateAppTranslationsFile", translationsJson, language, changes, devMode);

  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());

  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  let translationReference = FirebaseStorage.ref(`/appTranslations`).child(`${language}.json`);

  if (devMode) {
    translationReference = FirebaseStorage.ref(`/appTranslationsDev`).child(`${language}.json`);
  }

  return dispatch => new Promise((resolve) => {
    const jsonString = JSON.stringify(translationsJson);
    const blob = new Blob([jsonString], { type: "application/json" });

    translationReference.put(blob).then(async () => {
      console.log('Uploaded a blob!');

      // dispatch(getTranslationsFiles());

      console.log('test 7');
      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'updateAppTranslations',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        devMode,
        date: Firebase.database.ServerValue.TIMESTAMP,
        data: {...changes},
      });

      return resolve({ status: constants.SERVER_STATUS_CODE.success });
    }).catch((err) => {
      console.log('test 8');
      console.log('err', err);
      return resolve({ status: constants.SERVER_STATUS_CODE.error });
    });
  });
}

export function getPossibleBotPlayers(filter, filterType) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const filterDate = Date.parse(new Date());

  console.log('getPossibleBotPlayers', filter, filterType);

  if (filter && filterType) {
    if (filterType === 'uid' || filterType === 'name') {
      console.log('test 1');

      return dispatch => new Promise(resolve => {
        console.log('test 2');
        dispatch({ type: 'ADMIN_POSSIBLE_BOT_PLAYERS_REPLACE', data: {}, possibleBotLoading: true });

        FirebaseRef.child('possibleBotUsers/latest')
          .orderByChild(filterType)
          .equalTo(filter)
          .limitToLast(20)
          .once('value', (snapshot) => {
            const possibleBotPlayers = snapshot.val() || {};

            console.log('possibleBotPlayers 1', possibleBotPlayers);

            return resolve(dispatch({ type: 'ADMIN_POSSIBLE_BOT_PLAYERS_REPLACE', data: possibleBotPlayers, possibleBotLoading: false }));
          });

        console.log('test 3');
      }).catch((err) => { console.log(err.message); });
    } else if (filterType === 'lastIp') {
      console.log('test 4');
      return dispatch => new Promise(resolve => {
        dispatch({ type: 'ADMIN_POSSIBLE_BOT_PLAYERS_REPLACE', data: {}, possibleBotLoading: true });

        FirebaseRef.child('usersLastIp').orderByValue().equalTo(filter).once('value')
          .then((ipSnapshot) => {
            const matchingKeys = Object.keys(ipSnapshot.val() || {});

            console.log('matchingKeys', matchingKeys);

            let promises = [];
            let possibleBotPlayers = {};

            matchingKeys.map((key) => {
              promises.push(new Promise((resolve2) => {
                FirebaseRef.child('possibleBotUsers/latest')
                  .orderByChild('uid')
                  .equalTo(key)
                  .once('value', (snapshot) => {
                    const tempPossibleBotPlayers = snapshot.val() || {};

                    console.log('possibleBotPlayers 2', tempPossibleBotPlayers);

                    possibleBotPlayers = { ...possibleBotPlayers, ...tempPossibleBotPlayers };

                    return resolve2();
                  });
              }));
            });

            console.log('possibleBotPlayers 3', possibleBotPlayers);

            return Promise.all(promises).then(() => {
              console.log('possibleBotPlayers 4', possibleBotPlayers);

              return resolve(dispatch({ type: 'ADMIN_POSSIBLE_BOT_PLAYERS_REPLACE', data: possibleBotPlayers, possibleBotLoading: false }));
            });

            // return resolve(dispatch({ type: 'ADMIN_POSSIBLE_BOT_PLAYERS_REPLACE', data: possibleBotPlayers, possibleBotLoading: false }));

            /*
            FirebaseRef.child('possibleBotUsers/latest')
              .orderByChild('uid')
              .limitToLast(20)
              .once('value', (snapshot) => {
                const possibleBotPlayers = snapshot.val() || {};

                console.log('possibleBotPlayers 2', possibleBotPlayers);

                return resolve(dispatch({ type: 'ADMIN_POSSIBLE_BOT_PLAYERS_REPLACE', data: possibleBotPlayers, possibleBotLoading: false }));
              }); */
        }).catch((err) => { console.log(err.message); });
      }).catch((err) => { console.log(err.message); });
    }
  }

  console.log('test 5');

  return dispatch => new Promise(resolve => {
    dispatch({ type: 'ADMIN_POSSIBLE_BOT_PLAYERS_REPLACE', data: {}, possibleBotLoading: true });

    console.log('test 6');

    FirebaseRef.child('possibleBotUsers/latest')
    .orderByChild('date')
    .once('value', (snapshot) => {
      const possibleBotPlayers = snapshot.val() || {};

      console.log('possibleBotPlayers 3', possibleBotPlayers);

      return resolve(dispatch({ type: 'ADMIN_POSSIBLE_BOT_PLAYERS_REPLACE', data: possibleBotPlayers, possibleBotLoading: false  }));
    });
  }).catch((err) => { console.log(err.message); });
}

export function getPossibleBotPlayerData(playerId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const filterDate = Date.parse(new Date());

  const d = Date.now();
  const startAt = d - (1000 * 60 * 60 * 24 * 28);

  if (playerId) {
    return dispatch => new Promise(resolve => FirebaseRef.child(`possibleBotUsers/history/${playerId}`)
      .orderByChild('date')
      .startAt(startAt)
      .once('value', (snapshot) => {
        const possibleBotPlayerData = snapshot.val() || {};

        return resolve(dispatch({ type: 'ADMIN_POSSIBLE_BOT_PLAYER_DATA_REPLACE', data: possibleBotPlayerData }));
      })).catch((err) => { console.log(err.message); });
  } else {
    return dispatch => new Promise(resolve => {
      return resolve(dispatch({ type: 'ADMIN_POSSIBLE_BOT_PLAYER_DATA_REPLACE', data: null }));
    });
  }
}

export function getRoomOptions(roomId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => AdminLogsRef().child(`adminLogs/roomIds/${roomId}`)
    .once('value', async (snapshot) => {
      const roomOptions = snapshot.val() || {};

      return resolve(dispatch({ type: 'ADMIN_ROOM_OPTIONS_REPLACE', data: roomOptions }));
    }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
}

export function updateHelpEditor(helpSection, lang, actionType, actionOrderId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;
  const convertString = JSON.stringify(helpSection);

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child(`helpEditor/${lang}`).update({
      helpSection: convertString,
    }).then(async (res) => {

      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'updateHelpSection',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        date: Firebase.database.ServerValue.TIMESTAMP,
        data: {type: actionType, orderId: actionOrderId}
      });

      return resolve({ status: constants.SERVER_STATUS_CODE.success, message: constants.SERVER_STATUS_CODE.success });
    }).catch(() => {
      return resolve({ status: constants.SERVER_STATUS_CODE.error });
    });
  });
}

export function updateHelpEditorDevMode(devMode) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child(`helpEditor`).update({
      devMode,
    }).then(async (res) => {

      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'updateHelpSection',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        date: Firebase.database.ServerValue.TIMESTAMP,
      });

      return resolve({ status: constants.SERVER_STATUS_CODE.success, message: constants.SERVER_STATUS_CODE.success });
    }).catch(() => {
      return resolve({ status: constants.SERVER_STATUS_CODE.error });
    });
  });
}

export function getHelpEditor() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise((resolve) => {
    dispatch({ type: 'ADMIN_HELP_EDITOR_REPLACE', data: [], helpEditorLoading: true });
    FirebaseRef.child('helpEditor').on('value', (snapshot) => {
      const helpSections = snapshot.val();
      console.log(helpSections,  "parsedData=============")

      return resolve(dispatch({ type: 'ADMIN_HELP_EDITOR_REPLACE', data: helpSections, helpEditorLoading: false }));

    });
  });
}

export function getAnnouncements() {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => {
    dispatch({ type: 'ADMIN_ANNOUNCEMENTS_REPLACE', data: {}, loading: true });

    FirebaseRef.child('announcements')
    .on('value', (snapshot) => {
      const allAnnouncements = snapshot.val() || {};

      return resolve(dispatch({ type: 'ADMIN_ANNOUNCEMENTS_REPLACE', data: allAnnouncements, loading: false }));
    });

  }).catch((err) => { console.log(err.message); });
}

export function addNewAnnouncement({ title, announcement, imageUrl, platforms, designs, environments, receivers, date }) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise((resolve) => {
    FirebaseRef.child('announcements').push({
      date: Date.parse(date),
      title,
      announcement,
      imageUrl,
      platforms,
      designs,
      environments,
      receivers,
    }).then(async (res) => {

      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'addNewAnnouncement',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        date: Firebase.database.ServerValue.TIMESTAMP,
        data: {
          date,
          title,
          announcement,
          imageUrl,
          platforms,
          designs,
          environments,
          receivers,
        },
      });
      return resolve({ status: constants.SERVER_STATUS_CODE.success, message: constants.SERVER_STATUS_CODE.success });
    }).catch(() => {
      return resolve({ status: constants.SERVER_STATUS_CODE.error });
    });
  })
};

export function editAnnouncement({ selectedId, title, announcement, imageUrl, platforms, designs, environments, receivers, date }) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return () => new Promise((resolve) => {
    FirebaseRef.child(`announcements/${selectedId}`).update({
      date: Date.parse(date),
      title,
      announcement,
      imageUrl,
      platforms,
      designs,
      environments,
      receivers,
    }).then(async (res) => {

      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'editAnnouncement',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        date: Firebase.database.ServerValue.TIMESTAMP,
        data: {
          date,
          title,
          announcement,
          imageUrl,
          platforms,
          designs,
          environments,
          receivers,
        },
      });
      return resolve({ status: constants.SERVER_STATUS_CODE.success, message: constants.SERVER_STATUS_CODE.success });
    }).catch(() => {
      return resolve({ status: constants.SERVER_STATUS_CODE.error });
    });
  })
};

export function deleteAnnouncement(selectedId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise((resolve) => {
    FirebaseRef.child(`announcements/${selectedId}`).remove().then(async () => {
      const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
      const confirmAdminName = (await adminNamePromise)?.val() || null;

      AdminLogsRef().child('adminLogs/adminActions').push({
        type: 'deleteAnnouncement',
        adminId: UID,
        adminEmail,
        adminName: confirmAdminName || adminName,
        date: Firebase.database.ServerValue.TIMESTAMP,
        selectedId,
      });
      return resolve({ status: constants.SERVER_STATUS_CODE.success });
    }).catch(() => {
      return resolve({ status: constants.SERVER_STATUS_CODE.error });
    });
  });
}

export function getCantJoinRoom(startCalendarDate, endCalendarDate, actionType, reason, filterType, filter) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());

  return dispatch => new Promise(async (resolve) => {
    dispatch({ type: 'ADMIN_CANT_JOIN_ROOM_REPLACE', data: {}, loading: true });

    const startAt = Date.parse(startCalendarDate);
    const endAt = Date.parse(endCalendarDate);

    await AdminLogsRef().child('failedToJoinRoom')
      .orderByChild('date')
      .startAt(startAt)
      .endAt(endAt)
      .once('value', (snapshot) => {
        let data = snapshot.val() || {};
        let merge = { ...data };

        if (actionType && actionType !== 'all') {
          merge = Object.keys(merge).filter(key => merge[key].actionType === actionType).reduce((obj, key) => {
            obj[key] = merge[key];
            return obj;
          }, {});
        }

        if (reason && reason !== 'all') {
          merge = Object.keys(merge).filter(key => merge[key].reason === reason).reduce((obj, key) => {
            obj[key] = merge[key];
            return obj;
          }, {});
        }

        if (filterType === 'userId' && filter !== '') {
          merge = Object.keys(merge).filter(key => merge[key].playerId === filter.trim()).reduce((obj, key) => {
            obj[key] = merge[key];
            return obj;
          }, {});
        }

        if (filterType === 'playerName' && filter !== '') {
          const normalize = str =>
            (str || '')
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .replace(/\s+/g, ' ')
              .trim()
              .toLowerCase();

          const search = normalize(filter).split(' ');
          const searchFirst = search[0] || '';
          const searchLast = search[1] || '';

          merge = Object.keys(merge).filter(key => {
            const playerName = normalize(merge[key].playerName);
            const [firstName, ...lastNameParts] = playerName.split(' ');
            const lastName = lastNameParts.join(' ');

            // Case-insensitive search: first name must start with searchFirst, and last name starts with searchLast (if provided)
            if (searchFirst && !firstName.startsWith(searchFirst)) return false;
            if (searchLast && !lastName.startsWith(searchLast)) return false;
            return true;
          }).reduce((obj, key) => {
            obj[key] = merge[key];
            return obj;
          }, {});
        }

        return resolve(dispatch({ type: 'ADMIN_CANT_JOIN_ROOM_REPLACE', data: merge, loading: false }));
    });
  });
}

export function getCantJoinRoomCount(startCalendarDate, endCalendarDate) {
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {

    const startAt = Date.parse(startCalendarDate);
    const endAt = Date.parse(endCalendarDate);

    AdminLogsRef().child('failedToJoinRoom')
      .orderByChild('date')
      .startAt(startAt)
      .endAt(endAt)
      .once('value', (snapshot) => {
        let data = snapshot.val() || {};

        return resolve(dispatch({ type: 'ADMIN_CANT_JOIN_ROOM_COUNT', data: size(data) }));
    });
  });
}


export function getBalanceAndHistoryCheck(startCalendarDate, endCalendarDate, userId) {
  console.log('getBalanceAndHistoryCheck', startCalendarDate, endCalendarDate, userId);
  if (Firebase === null) return () => new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  console.log(UID);

  if (!UID) return new Promise(resolve => resolve());

  return dispatch => new Promise((resolve) => {
    dispatch({ type: 'ADMIN_BALANCE_AND_HISTORY_REPLACE', data: {}, loading: true });

    const startAt = Date.parse(startCalendarDate);
    const endAt = Date.parse(endCalendarDate);

    console.log(startAt);

    UserStatsRef().child('userBalHistoryIssues')
      .orderByChild('time')
      .startAt(startAt)
      .endAt(endAt)
      .once('value', (snapshot) => {
        let data = snapshot.val() || {};
        let merge = { ...data };

        console.log('getBalanceAndHistoryCheck data', merge);

        if (userId) {
          merge = Object.keys(merge).filter(key => merge[key].userId === userId).reduce((obj, key) => {
            obj[key] = merge[key];
            return obj;
          }, {});
        }

        return resolve(dispatch({ type: 'ADMIN_BALANCE_AND_HISTORY_REPLACE', data: merge, dataSize: size(merge), loading: false }));
      }).catch(err => console.log(err));
  });
}


// export function getUsersEmailChangesHistory() {
//   if (Firebase === null) return () => Promise.resolve();

//   const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;

//   if (!UID) return Promise.resolve();

//   return dispatch => new Promise((resolve) => {
//     dispatch({ type: 'ADMIN_USERS_EMAIL_CHANGES_HISTORY_REPLACE', data: {}, loading: true });

//     FirebaseRef.child('usersEmailChangesHistory').orderByChild('date').once('value', (snapshot) => {
//       let data = snapshot.val() || {};
//       console.log('getUsersEmailChangesHistory data', data);
//       return resolve(dispatch({ type: 'ADMIN_USERS_EMAIL_CHANGES_HISTORY_REPLACE', data, loading: false}))

//     }).catch(err => {
//       console.log(err)
//      return dispatch({ type: 'ADMIN_USERS_EMAIL_CHANGES_HISTORY_REPLACE', data: {}, loading: false });
//     });
//   });
// }

export function getUsersEmailChangesHistory() {
  if (Firebase === null) return () => Promise.resolve();

  const UID = (
    FirebaseRef &&
    Firebase &&
    Firebase.auth() &&
    Firebase.auth().currentUser &&
    Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null;

  if (!UID) return Promise.resolve();

  return dispatch => new Promise((resolve) => {
    dispatch({ type: 'ADMIN_USERS_EMAIL_CHANGES_HISTORY_REPLACE', data: {}, loading: true });

    FirebaseRef.child('usersEmailChangesHistory')
      .orderByChild('date')
      .once('value', async (snapshot) => {

        let data = snapshot.val() || {};
        console.log('getUsersEmailChangesHistory data', data);

        const uniqueUids = [...new Set(
          Object.values(data).map(obj => obj.uid).filter(Boolean)
        )];

        const userFetches = uniqueUids.map(uid => {
          return FirebaseRef.child(`users/${uid}`)
            .once('value')
            .then(snap => {
              const val = snap.val() || {};
              return {
                uid,
                socProvider: val.socProvider || null,
                lastName: val.lastName || null
              };
            })
            .catch(() => ({
              uid,
              socProvider: null,
              lastName: null
            }));
        });

        const users = await Promise.all(userFetches);

        const userMap = users.reduce((acc, { uid, socProvider, lastName }) => {
          acc[uid] = { socProvider, lastName };
          return acc;
        }, {});

        Object.keys(data).forEach(key => {
          const uid = data[key].uid;
          data[key].socProvider = uid ? userMap[uid]?.socProvider : null;
          data[key].lastName = uid ? userMap[uid]?.lastName : null;
        });

        resolve(
          dispatch({
            type: 'ADMIN_USERS_EMAIL_CHANGES_HISTORY_REPLACE',
            data,
            loading: false
          })
        );
      })
      .catch(err => {
        console.log(err);
        return dispatch({
          type: 'ADMIN_USERS_EMAIL_CHANGES_HISTORY_REPLACE',
          data: {},
          loading: false
        });
      });
  });
}


export function getSuspiciousRoomLeftPlayers() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const endString = Date.now();
  const startString = constants.CALC_ACTIVATE_DATE_BY_TIME(constants.WEEKLY_VALUE.twoWeek);

  console.log('getSuspiciousRoomLeftPlayers', endString, startString)

  return dispatch => new Promise(resolve => AdminLogsRef().child('suspiciousLeftRooms')
    .orderByChild('date')
    .startAt(startString)
    .endAt(endString)
    .once('value', async (snapshot) => {
      const data = snapshot.val() || {};

      const array = filter(data, item => item.count > 1)
      .slice()
      .sort((a, b) => (b.date - a.date));

      return resolve(dispatch({ type: 'SUSPICIOUS_ROOM_LEFT_PLAYERS', data: array }));
    }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
}

export function getSuspiciousSameIPPlayers() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const endString = Date.now();
  const startString = constants.CALC_ACTIVATE_DATE_BY_TIME(constants.WEEKLY_VALUE.twoWeek);

  console.log('getSuspiciousSameIPPlayers');

  return dispatch => new Promise(resolve => AdminLogsRef().child('suspiciousSameIP/players')
    .orderByChild('lastDate')
    .startAt(startString)
    .endAt(endString)
    .once('value', async (snapshot) => {
      const data = snapshot.val() || {};

      console.log('getSuspiciousSameIPPlayers data', data);

      const array = filter(data, item => item.count > 2)
      .slice()
      .sort((a, b) => (b.dateAdded - a.dateAdded));

      return resolve(dispatch({ type: 'SUSPICIOUS_SAME_IP_PLAYERS', data: array }));
    }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
}

export function getSuspiciousLeavingRoomData(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  if (!uid) return new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => AdminLogsRef().child(`suspiciousLeftRoomsData/${uid}`)
    .once('value', (snapshot) => {
      const data = snapshot.val() || {};

      const sortedData = Object.keys(data).sort((a, b) => data[b].date - data[a].date).reduce((obj, key) => {
        obj[key] = data[key];
        return obj;
      }, {});
      console.log('getSuspiciousLeavingRoomData sortedData', sortedData);
      return resolve(dispatch({ type: 'SUSPICIOUS_LEAVING_ROOM_DATA', data: sortedData }));
    }));
}
export function getOneGames() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const endString = Date.now();
  const startString = constants.CALC_ACTIVATE_DATE_BY_TIME(constants.WEEKLY_VALUE.twoWeek);

  return dispatch => new Promise(resolve => AdminLogsRef().child('suspiciousLeftFirstRound')
    .orderByChild('date')
    .startAt(startString)
    .endAt(endString)
    .once('value', async (snapshot) => {
      const data = snapshot.val() || {};

      const array = filter(data, item => item.count >= 10)
        .slice()
        .sort((a, b) => (b.count - a.count));

      // Fetch rank data for each user
      await Promise.all(array.map(async (item, index) => {
        if (item.uid) {
          try {
            const userSnapshot = await FirebaseRef.child(`users/${item.uid}/rankG`).once('value');
            const userRankData = userSnapshot.val();
            if (userRankData) {
              array[index] = {
                ...item,
                rankG: userRankData || false,
              };
            }
          } catch (error) {
            console.log('Error fetching user data for uid:', item.uid, error);
            array[index] = {
              ...item,
              rankG: false,
            };
          }
        }
      }));

      return resolve(dispatch({ type: 'SUSPICIOUS_LEFT_FIRST_ROUND', data: array }));
    }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
}

export function checkRankPlayers() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const endString = Date.now();
  const startString = constants.CALC_ACTIVATE_DATE_BY_TIME(constants.WEEKLY_VALUE.twoWeek);

  return dispatch => new Promise(resolve => AdminLogsRef().child('suspiciousLeftFirstRound')
    .orderByChild('date')
    .startAt(startString)
    .endAt(endString)
    .once('value', async (snapshot) => {
      const data = snapshot.val() || {};

      const array = filter(data, item => item.count >= 10)
        .slice()
        .sort((a, b) => (b.count - a.count));

      // Fetch rank data for each user
      await Promise.all(array.map(async (item, index) => {
        if (item.uid) {
          try {
            const userSnapshot = await FirebaseRef.child(`users/${item.uid}/rankG`).once('value');
            const userRankData = userSnapshot.val();
            if (userRankData) {
              array[index] = {
                ...item,
                rankG: userRankData || false,
              };
            }
          } catch (error) {
            console.log('Error fetching user data for uid:', item.uid, error);
            array[index] = {
              ...item,
              rank: false,
            };
          }
        }
      }));

      return resolve(dispatch({ type: 'SUSPICIOUS_LEFT_FIRST_ROUND', data: array }));
    }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
}

export function getSuspiciousLeftFirstRoundData(uid) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  if (!uid) return new Promise(resolve => resolve());

  return dispatch => new Promise(resolve => AdminLogsRef().child(`suspiciousLeftFirstRoundData/${uid}`)
    .once('value', (snapshot) => {
      const data = snapshot.val() || {};
      return resolve(dispatch({ type: 'SUSPICIOUS_LEFT_FIRST_ROUND_DATA', data }));
    }));
}


export function removeRankGrasshopper(item) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  if (!item) return new Promise(resolve => resolve());
  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise(resolve => FirebaseRef.child(`users/${item.uid}/rankG`).remove().then(async () => {
    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'removeRankGrasshopper',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      date: Firebase.database.ServerValue.TIMESTAMP,
      data: {
        rankG: false,
      },
      userId: item.uid,
      userName: item.name,
    });
    dispatch(getOneGames());
    return resolve(dispatch({ type: 'REMOVE_RANK_GRASSHOPPER', data: item }));
  }));
}

export function addRankGrasshopper(item) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  if (!item) return new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise(resolve => FirebaseRef.child(`users/${item.uid}/rankG`).set(true).then(async () => {

    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'addRankGrasshopper',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      date: Firebase.database.ServerValue.TIMESTAMP,
      data: {
        rankG: true,
      },
      userId: item.uid,
      userName: item.name,
      date: Firebase.database.ServerValue.TIMESTAMP,
    });


    dispatch(getOneGames());
    return resolve(dispatch({ type: 'ADD_RANK_GRASSHOPPER', data: item }));
  }));
}

export function removeRankSnail(item) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  if (!item) return new Promise(resolve => resolve());
  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise(resolve => FirebaseRef.child(`users/${item.uid}/rankS`).remove().then(async () => {
    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'removeRankSnail',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      date: Firebase.database.ServerValue.TIMESTAMP,
      data: {
        rankS: false,
      },
      userId: item.uid,
      userName: item.name,
    });
    dispatch(getPlayersSlowdown());
    return resolve(dispatch({ type: 'REMOVE_RANK_SNAIL', data: item }));
  }));
}

export function addRankSnail(item) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  if (!item) return new Promise(resolve => resolve());

  const UID = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.uid) ? Firebase.auth().currentUser.uid : null;
  if (!UID) return new Promise(resolve => resolve());
  const adminEmail = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.email) ? Firebase.auth().currentUser.email : null;
  const adminName = (FirebaseRef && Firebase && Firebase.auth() && Firebase.auth().currentUser && Firebase.auth().currentUser.displayName) ? Firebase.auth().currentUser.displayName : null;

  return dispatch => new Promise(resolve => FirebaseRef.child(`users/${item.uid}/rankS`).set(true).then(async () => {

    const adminNamePromise = FirebaseRef.child(`users/${UID.toString()}/name`).once('value');
    const confirmAdminName = (await adminNamePromise)?.val() || null;

    AdminLogsRef().child('adminLogs/adminActions').push({
      type: 'addRankSnail',
      adminId: UID,
      adminEmail,
      adminName: confirmAdminName || adminName,
      date: Firebase.database.ServerValue.TIMESTAMP,
      data: {
        rankS: true,
      },
      userId: item.uid,
      userName: item.name,
      date: Firebase.database.ServerValue.TIMESTAMP,
    });


    dispatch(getPlayersSlowdown());
    return resolve(dispatch({ type: 'ADD_RANK_SNAIL', data: item }));
  }));
}

export function getPlayersSlowdown() {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const endString = Date.now();
  const startString = constants.CALC_ACTIVATE_DATE_BY_TIME(constants.WEEKLY_VALUE.twoWeek);

  return dispatch => new Promise(resolve => AdminLogsRef().child('slowdownPlayers')
    .orderByChild('date')
    .startAt(startString)
    .endAt(endString)
    .once('value', async (snapshot) => {
      const data = snapshot.val() || {};
      console.log("slowdownPlayers data", data);

      const array = filter(data, item => item.count >= 10)
        .slice()
        .sort((a, b) => (b.count - a.count));
      // Fetch rank data for each user
      await Promise.all(array.map(async (item, index) => {
        if (item.uid) {
          try {
            const userSnapshot = await FirebaseRef.child(`users/${item.uid}/rankS`).once('value');
            const userRankData = userSnapshot.val();
            if (userRankData) {
              array[index] = {
                ...item,
                rankS: userRankData || false,
              };
            }
          } catch (error) {
            console.log('Error fetching user data for uid:', item.uid, error);
            array[index] = {
              ...item,
              rankS: false,
            };
          }
        }
      }));

      return resolve(dispatch({ type: 'REPLACE_PLAYERS_SLOWDOWN', data: array }));
    }, (err) => { console.log(err); })).catch((err) => { console.log(err); });
}

export function getSlowdownPlayerData(playerId) {
  if (Firebase === null) return () => new Promise(resolve => resolve());
  const filterDate = Date.parse(new Date());

  const d = Date.now();
  const startAt = d - (1000 * 60 * 60 * 24 * 28);

  if (playerId) {
    return dispatch => new Promise(resolve => AdminLogsRef().child(`slowdownPlayersData/${playerId}`)
      .orderByChild('date')
      .startAt(startAt)
      .once('value', (snapshot) => {
        const slowdownPlayerData = snapshot.val() || {};

        return resolve(dispatch({ type: 'ADMIN_SLOWDOWN_PLAYER_DATA_REPLACE', data: slowdownPlayerData }));
      })).catch((err) => { console.log(err.message); });
  } else {
    return dispatch => new Promise(resolve => {
      return resolve(dispatch({ type: 'ADMIN_SLOWDOWN_PLAYER_DATA_REPLACE', data: null }));
    });
  }
}
